var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAbout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-30",
    d: "M78.76,446.25c-94.57-54.6-94.57-143.13,0-197.73s247.91-54.6,342.48,0,94.57,143.13,0,197.73S173.33,500.85,78.76,446.25Z",
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-30"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--Shadow--inject-30",
    cx: 413.17,
    cy: 393.87,
    rx: 53.83,
    ry: 31.08,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-30",
    d: "M295,399.8l-90.32-52.15c-2.27-1.31-2.27-3.44,0-4.75l141.56-81.73a9.09,9.09,0,0,1,8.22,0l90.32,52.15c2.27,1.31,2.27,3.44,0,4.75L303.19,399.8A9.09,9.09,0,0,1,295,399.8Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-30",
    d: "M127.09,426.68a3.86,3.86,0,0,1-3.74-3.09l-.87-4.58a49.32,49.32,0,0,1-5.81-1.43h-.15l-8.06,3.74a4.75,4.75,0,0,1-4.16-.19l-8-4.64a3.18,3.18,0,0,1-.27-5.44l4.86-3.5a17.65,17.65,0,0,1-1.21-1.84l-10.24-.64A3.67,3.67,0,0,1,86,401.42v-6a3.67,3.67,0,0,1,3.43-3.66l10.24-.65a17.53,17.53,0,0,1,1.21-1.83L96,385.81a3.18,3.18,0,0,1,.27-5.44l8-4.64a4.57,4.57,0,0,1,2.28-.58,4.42,4.42,0,0,1,1.88.39l8.07,3.74h.1s0,0,0,0a50,50,0,0,1,5.88-1.44l.87-4.58a3.85,3.85,0,0,1,3.74-3.09H138.9a3.86,3.86,0,0,1,3.74,3.09l.87,4.58a51.2,51.2,0,0,1,5.8,1.42h.15l8.07-3.74a4.41,4.41,0,0,1,1.87-.39,4.58,4.58,0,0,1,2.29.58l8,4.64a3.19,3.19,0,0,1,.28,5.44l-4.87,3.5a18.77,18.77,0,0,1,1.22,1.83l10.24.65a3.67,3.67,0,0,1,3.43,3.66v6a3.68,3.68,0,0,1-3.43,3.66l-10.24.64a17.75,17.75,0,0,1-1.22,1.84l4.87,3.5a3.19,3.19,0,0,1-.28,5.44l-8,4.64a4.69,4.69,0,0,1-2.29.58,4.57,4.57,0,0,1-1.87-.39l-8.07-3.74h-.1s0,0,0,0a49.85,49.85,0,0,1-5.87,1.45l-.87,4.57a3.86,3.86,0,0,1-3.74,3.1ZM133,393a24.93,24.93,0,0,0-12.27,2.9c-2.75,1.59-4.33,3.62-4.33,5.59s1.58,4,4.33,5.59a27.43,27.43,0,0,0,24.55,0c2.75-1.59,4.32-3.62,4.32-5.59s-1.57-4-4.32-5.59A25,25,0,0,0,133,393Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-30",
    d: "M218.08,433.45a3.13,3.13,0,0,1-.75-.08l-8.59-2.06a3,3,0,0,1-2.05-1.65,3.16,3.16,0,0,1,.06-2.78l1.31-2.59a23.66,23.66,0,0,1-2.25-1.38l-7.73,1.3a3.87,3.87,0,0,1-3.66-1.34s-2.38-3.35-3.33-4.66a3,3,0,0,1-.5-2.62,2.66,2.66,0,0,1,.26-.6l.06-.1a3.42,3.42,0,0,1,1.86-1.4l6-1.88a5.61,5.61,0,0,1,0-.58l-6.15-1.95a2.92,2.92,0,0,1-2-2.27l-.06-.15v-.41a3.25,3.25,0,0,1,.64-1.92l3.11-4.33a4,4,0,0,1,3.15-1.64,3.31,3.31,0,0,1,.55,0l7.86,1.32h0c.52-.37,1.12-.74,1.75-1.11l.46-.25-1.4-2.76a2.91,2.91,0,0,1-.3-1.33,3.16,3.16,0,0,1,2.54-3l8.25-2a4.46,4.46,0,0,1,1-.11,3.71,3.71,0,0,1,2.72,1.07l3.58,3.77c.78-.05,1.62-.07,2.45-.07s1.72,0,2.59.07l3.38-3.56a4.25,4.25,0,0,1,3-1.3,3.42,3.42,0,0,1,.79.1l8.56,2a3,3,0,0,1,2.32,2.57l0,.12v.35a3.36,3.36,0,0,1-.37,1.43l-1.29,2.56.41.22c.64.37,1.26.76,1.83,1.15l7.73-1.3a3.86,3.86,0,0,1,3.66,1.35l3.43,4.77a2.85,2.85,0,0,1,.53,1.66v.16a3.19,3.19,0,0,1-2.34,2.79L255.19,411v.58l6.13,1.94a2.94,2.94,0,0,1,2.08,2.82,3.41,3.41,0,0,1-.61,1.9l-3.14,4.37a4,4,0,0,1-3.15,1.64,3.43,3.43,0,0,1-.56,0l-7.85-1.33h0a23.87,23.87,0,0,1-2.22,1.37l1.39,2.76a2.87,2.87,0,0,1,0,2.51,3.3,3.3,0,0,1-2.25,1.79l-8.28,2a4,4,0,0,1-1,.12,3.72,3.72,0,0,1-2.71-1.07l-3.59-3.77c-.79,0-1.65.07-2.5.07s-1.68,0-2.53-.07l-3.38,3.55A4.21,4.21,0,0,1,218.08,433.45ZM215.37,409l-.21.25a3.74,3.74,0,0,0-.22.32c0,.05-.16.26-.16.26a2.87,2.87,0,0,0,.26,3.35,6.56,6.56,0,0,0,1.5,1.47,8.27,8.27,0,0,0,1.05.69,19.56,19.56,0,0,0,9.37,2.18,22.69,22.69,0,0,0,5.19-.59,16,16,0,0,0,4.18-1.59,10.4,10.4,0,0,0,1-.66,6.56,6.56,0,0,0,1.71-1.76v0l.21-.37.08-.21a2.86,2.86,0,0,0-.48-2.9c-1.86-2.6-6.65-4.34-11.92-4.34a22.06,22.06,0,0,0-5.18.6,12.93,12.93,0,0,0-6.14,3.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-30",
    d: "M216.28,263.78l-3.35-1.93a9.09,9.09,0,0,0-8.22,0L27.86,364c-2.26,1.3-2.26,3.44,0,4.74l3.34,1.93a9.11,9.11,0,0,0,8.23,0l53.72-31,21.77,12.56c6.16,3.56,16.25,3.56,22.41,0l37.06-21.4c5.26-3,5.26-8,0-11L151,306.22l65.29-37.69C218.54,267.22,218.54,265.09,216.28,263.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shadow--inject-30",
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.13,90.56l-160,92.37v90.53a2.61,2.61,0,0,0,.42,1.48,1.12,1.12,0,0,0,.91.54,1.3,1.3,0,0,0,.65-.19l161.83-93.51v-89C226.94,90.32,225.23,89.34,223.13,90.56Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.43,389.43v-4.78a1.09,1.09,0,0,0-1-1.07l-7.62-.48V372.4h0a.65.65,0,0,0-.37-.59l-8-4.63a2.13,2.13,0,0,0-1.78-.08l-8.15,3.77a3,3,0,0,1-1.86.11,49.35,49.35,0,0,0-6.32-1.5,1.56,1.56,0,0,1-1.18-1.15l-1-5.36a1.25,1.25,0,0,0-1.19-1H127.09a1.26,1.26,0,0,0-1.19,1l-1,5.36a1.54,1.54,0,0,1-1.18,1.15,49.35,49.35,0,0,0-6.32,1.5,3,3,0,0,1-1.86-.11l-8.15-3.77a2.11,2.11,0,0,0-1.77.08l-8,4.63a.64.64,0,0,0-.37.58V383.1l-7.62.48a1.08,1.08,0,0,0-1,1.07v6h0v4.18h0v6h0v0c0,.12.09.22.14.33a1,1,0,0,0,.16.38,1,1,0,0,0,.51.24c.07,0,.11.09.19.1h.14l7.37.46.43,0-.32.54v5.6h0v4.57h0s0,0,0,0a.55.55,0,0,0,.06.22h0a.73.73,0,0,0,.28.27l8,4.64h0a1.82,1.82,0,0,0,.77.2h.21a2.62,2.62,0,0,0,.28,0v-.05a1.93,1.93,0,0,0,.5-.09l8.14-3.77a3,3,0,0,1,1.86-.11,49.1,49.1,0,0,0,6.33,1.5,1.53,1.53,0,0,1,1.17,1.14l1,5.37a1.07,1.07,0,0,0,.2.32v.13a.79.79,0,0,0,.17.14.66.66,0,0,0,.15.14,1.12,1.12,0,0,0,.67.26H138.9a1.2,1.2,0,0,0,.75-.28h0a1.15,1.15,0,0,0,.44-.7l1-5.37a1.54,1.54,0,0,1,1.18-1.14,49,49,0,0,0,6.32-1.5,3,3,0,0,1,1.87.11l8.14,3.77a2.06,2.06,0,0,0,.76.15v0a2,2,0,0,0,1-.21l8-4.64a.67.67,0,0,0,.38-.54h0V402.34l7.62-.48a1.09,1.09,0,0,0,1-1.07l0-11.15A1.49,1.49,0,0,0,177.43,389.43Zm-29.29,5a15.79,15.79,0,0,1-1.57,1c-7.5,4.33-19.65,4.33-27.15,0a17.78,17.78,0,0,1-1.57-1c.48-.34,1-.68,1.57-1,7.5-4.32,19.66-4.32,27.15,0C147.14,393.76,147.66,394.1,148.14,394.44Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.43,389.43v-4.78a1.09,1.09,0,0,0-1-1.07l-7.62-.48V372.4h0a.65.65,0,0,0-.37-.59l-8-4.63a2.13,2.13,0,0,0-1.78-.08l-8.15,3.77a3,3,0,0,1-1.86.11,49.35,49.35,0,0,0-6.32-1.5,1.56,1.56,0,0,1-1.18-1.15l-1-5.36a1.25,1.25,0,0,0-1.19-1H127.09a1.26,1.26,0,0,0-1.19,1l-1,5.36a1.54,1.54,0,0,1-1.18,1.15,49.35,49.35,0,0,0-6.32,1.5,3,3,0,0,1-1.86-.11l-8.15-3.77a2.11,2.11,0,0,0-1.77.08l-8,4.63a.64.64,0,0,0-.37.58V383.1l-7.62.48a1.08,1.08,0,0,0-1,1.07v6h0v4.18h0v6h0v0c0,.12.09.22.14.33a1,1,0,0,0,.16.38,1,1,0,0,0,.51.24c.07,0,.11.09.19.1h.14l7.37.46.43,0-.32.54v5.6h0v4.57h0s0,0,0,0a.55.55,0,0,0,.06.22h0a.73.73,0,0,0,.28.27l8,4.64h0a1.82,1.82,0,0,0,.77.2h.21a2.62,2.62,0,0,0,.28,0v-.05a1.93,1.93,0,0,0,.5-.09l8.14-3.77a3,3,0,0,1,1.86-.11,49.1,49.1,0,0,0,6.33,1.5,1.53,1.53,0,0,1,1.17,1.14l1,5.37a1.07,1.07,0,0,0,.2.32v.13a.79.79,0,0,0,.17.14.66.66,0,0,0,.15.14,1.12,1.12,0,0,0,.67.26H138.9a1.2,1.2,0,0,0,.75-.28h0a1.15,1.15,0,0,0,.44-.7l1-5.37a1.54,1.54,0,0,1,1.18-1.14,49,49,0,0,0,6.32-1.5,3,3,0,0,1,1.87.11l8.14,3.77a2.06,2.06,0,0,0,.76.15v0a2,2,0,0,0,1-.21l8-4.64a.67.67,0,0,0,.38-.54h0V402.34l7.62-.48a1.09,1.09,0,0,0,1-1.07l0-11.15A1.49,1.49,0,0,0,177.43,389.43Zm-29.29,5a15.79,15.79,0,0,1-1.57,1c-7.5,4.33-19.65,4.33-27.15,0a17.78,17.78,0,0,1-1.57-1c.48-.34,1-.68,1.57-1,7.5-4.32,19.66-4.32,27.15,0C147.14,393.76,147.66,394.1,148.14,394.44Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.6,367.18l-8,4.63a.6.6,0,0,0,0,1.09l6.37,4.58a.85.85,0,0,1,.11,1.31,16.21,16.21,0,0,0-2.27,3.15,1.94,1.94,0,0,1-1.45,1l-10.7.68a1.08,1.08,0,0,0-1,1.07v6a1.09,1.09,0,0,0,1,1.07l10.7.67a2,2,0,0,1,1.45,1,16.21,16.21,0,0,0,2.27,3.15.85.85,0,0,1-.11,1.31l-6.37,4.58a.59.59,0,0,0,0,1.08l8,4.64a2.15,2.15,0,0,0,1.77.08l8.15-3.77a3,3,0,0,1,1.86-.11,49.1,49.1,0,0,0,6.33,1.5,1.53,1.53,0,0,1,1.17,1.14l1,5.37a1.26,1.26,0,0,0,1.19,1H138.9a1.25,1.25,0,0,0,1.19-1l1-5.37a1.54,1.54,0,0,1,1.18-1.14,49.35,49.35,0,0,0,6.32-1.5,3,3,0,0,1,1.87.11l8.14,3.77a2.17,2.17,0,0,0,1.78-.08l8-4.64a.59.59,0,0,0,.06-1.08l-6.37-4.58a.85.85,0,0,1-.12-1.31,15.57,15.57,0,0,0,2.27-3.16,2,2,0,0,1,1.45-1l10.71-.67a1.09,1.09,0,0,0,1-1.07v-6a1.09,1.09,0,0,0-1-1.07l-10.71-.68a2,2,0,0,1-1.45-1,15.8,15.8,0,0,0-2.27-3.15.85.85,0,0,1,.12-1.31l6.37-4.58a.6.6,0,0,0-.06-1.09l-8-4.63a2.13,2.13,0,0,0-1.78-.08l-8.15,3.77a3,3,0,0,1-1.86.11,49.35,49.35,0,0,0-6.32-1.5,1.56,1.56,0,0,1-1.18-1.15l-1-5.36a1.25,1.25,0,0,0-1.19-1H127.09a1.26,1.26,0,0,0-1.19,1l-1,5.36a1.54,1.54,0,0,1-1.18,1.15,49.35,49.35,0,0,0-6.32,1.5,3,3,0,0,1-1.86-.11l-8.15-3.77A2.11,2.11,0,0,0,105.6,367.18Zm41,12.62c7.5,4.33,7.5,11.34,0,15.67s-19.65,4.33-27.15,0-7.49-11.34,0-15.67S139.07,375.47,146.57,379.8Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.51,402.36l3.21-2.3v-7.59a1.48,1.48,0,0,0-.45-.11l-10.7-.68a1.07,1.07,0,0,1-1-1.06v10.19a1.07,1.07,0,0,0,1,1h0l.14,0,6.09.38,1.71.11Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.13,404.24a2.18,2.18,0,0,0-.61.16l-8.14,3.77a2,2,0,0,1-1,.13v10.18a2.53,2.53,0,0,0,.55,0h0v-.06a1.54,1.54,0,0,0,.5-.08l8.14-3.77a2.73,2.73,0,0,1,.61-.14Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.05,412.68a1.16,1.16,0,0,1-.15-.38l-1-5.37a1.05,1.05,0,0,0-.16-.4v10.18a1,1,0,0,1,.16.39l1,5.37a.68.68,0,0,0,.15.26Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.27,406.53a1.52,1.52,0,0,0-.16.4l-1,5.37a1.09,1.09,0,0,1-.15.39v10.16a1,1,0,0,0,.15-.38l1-5.37a1.17,1.17,0,0,1,.16-.36Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.66,408.3a2,2,0,0,1-1-.13l-8.14-3.77a2.25,2.25,0,0,0-.62-.16v10.17a2.25,2.25,0,0,1,.62.16l8.14,3.77a2,2,0,0,0,.76.15v0h.28Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.94,406.49c0,.43,0,8.46,0,8.68a.37.37,0,0,0,.08.22l3.41,4.76a1.37,1.37,0,0,0,1.25.37l7.87-1.33a2.12,2.12,0,0,1,1.41.25c.6.42,1.24.83,1.91,1.21,0,0,0,6.39,0,6.53a.53.53,0,0,0,.43.47l8.57,2.05a1.63,1.63,0,0,0,1.38-.51l3.54-3.72a2.11,2.11,0,0,1,1.44-.62,45.8,45.8,0,0,0,5.37,0,1.81,1.81,0,0,1,1.3.4l3.94,4.15a1.54,1.54,0,0,0,1.34.25l8.24-2c.41-.1.66-.36.65-.62v-6.43c.56-.33,1.1-.67,1.61-1a2.56,2.56,0,0,1,1.56-.44l8.12,1.37a1.5,1.5,0,0,0,1.28-.6l3.1-4.34a.83.83,0,0,0,.18-.5c0-.15,0-2.7,0-6.26a.47.47,0,0,0,.06-.19c0-.08,0-11.65,0-12.37v0a.36.36,0,0,0-.07-.22l-3.41-4.76a1.39,1.39,0,0,0-1.25-.36l-7.87,1.32A2.12,2.12,0,0,1,247,392a21.39,21.39,0,0,0-1.91-1.21c0-3,0-6,0-6.41v0a.56.56,0,0,0-.44-.56l-8.58-2a1.62,1.62,0,0,0-1.37.51L231.11,386a2.07,2.07,0,0,1-1.44.63,43.88,43.88,0,0,0-5.38,0,1.83,1.83,0,0,1-1.29-.4L219.06,382a1.57,1.57,0,0,0-1.33-.25l-8.25,2c-.4.1-.65.34-.65.6h0v6.46c-.57.33-1.11.67-1.61,1a2.44,2.44,0,0,1-1.56.44l-8.12-1.36a1.48,1.48,0,0,0-1.28.6l-3.11,4.34a.8.8,0,0,0-.17.47v0c0,.38,0,6.45,0,9.95h0a.31.31,0,0,0-.06.19h0Zm44.62,1.06a18.22,18.22,0,0,1-4.83,1.86c-5.78,1.37-12.18.53-16.36-1.85a11.93,11.93,0,0,1-1.29-.84c.36-.26.76-.51,1.19-.76,5.89-3.4,15.44-3.4,21.33,0a12.81,12.81,0,0,1,1.22.78A11.86,11.86,0,0,1,237.56,407.55Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.94,406.49c0,.43,0,8.46,0,8.68a.37.37,0,0,0,.08.22l3.41,4.76a1.37,1.37,0,0,0,1.25.37l7.87-1.33a2.12,2.12,0,0,1,1.41.25c.6.42,1.24.83,1.91,1.21,0,0,0,6.39,0,6.53a.53.53,0,0,0,.43.47l8.57,2.05a1.63,1.63,0,0,0,1.38-.51l3.54-3.72a2.11,2.11,0,0,1,1.44-.62,45.8,45.8,0,0,0,5.37,0,1.81,1.81,0,0,1,1.3.4l3.94,4.15a1.54,1.54,0,0,0,1.34.25l8.24-2c.41-.1.66-.36.65-.62v-6.43c.56-.33,1.1-.67,1.61-1a2.56,2.56,0,0,1,1.56-.44l8.12,1.37a1.5,1.5,0,0,0,1.28-.6l3.1-4.34a.83.83,0,0,0,.18-.5c0-.15,0-2.7,0-6.26a.47.47,0,0,0,.06-.19c0-.08,0-11.65,0-12.37v0a.36.36,0,0,0-.07-.22l-3.41-4.76a1.39,1.39,0,0,0-1.25-.36l-7.87,1.32A2.12,2.12,0,0,1,247,392a21.39,21.39,0,0,0-1.91-1.21c0-3,0-6,0-6.41v0a.56.56,0,0,0-.44-.56l-8.58-2a1.62,1.62,0,0,0-1.37.51L231.11,386a2.07,2.07,0,0,1-1.44.63,43.88,43.88,0,0,0-5.38,0,1.83,1.83,0,0,1-1.29-.4L219.06,382a1.57,1.57,0,0,0-1.33-.25l-8.25,2c-.4.1-.65.34-.65.6h0v6.46c-.57.33-1.11.67-1.61,1a2.44,2.44,0,0,1-1.56.44l-8.12-1.36a1.48,1.48,0,0,0-1.28.6l-3.11,4.34a.8.8,0,0,0-.17.47v0c0,.38,0,6.45,0,9.95h0a.31.31,0,0,0-.06.19h0Zm44.62,1.06a18.22,18.22,0,0,1-4.83,1.86c-5.78,1.37-12.18.53-16.36-1.85a11.93,11.93,0,0,1-1.29-.84c.36-.26.76-.51,1.19-.76,5.89-3.4,15.44-3.4,21.33,0a12.81,12.81,0,0,1,1.22.78A11.86,11.86,0,0,1,237.56,407.55Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.6,400a8.37,8.37,0,0,1,0,2.69.88.88,0,0,0,.55.95l7.42,2.34a.48.48,0,0,1,.35.47c0,.15,0,2.41,0,2.41a.48.48,0,0,0,.06-.18c0-4.21,0-11.25,0-11.87v-.51c0,.22-.23.44-.59.55l-7,2.23A1,1,0,0,0,252.6,400Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,410.46v8.71h.3l8.12,1.37a1,1,0,0,0,.41,0v-8.68a.9.9,0,0,1-.43,0l-8.12-1.36A1.27,1.27,0,0,0,248,410.46Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.43,416.28V425a1.26,1.26,0,0,1,.5.28l3.94,4.15a1.29,1.29,0,0,0,.72.29V421a1.2,1.2,0,0,1-.73-.28l-4-4.16A1.3,1.3,0,0,0,230.43,416.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.49,421v8.69a1.71,1.71,0,0,0,.79-.46l3.53-3.72a2.4,2.4,0,0,1,.93-.54v-8.7a2.23,2.23,0,0,0-.94.55l-3.54,3.71A1.81,1.81,0,0,1,218.49,421Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.11,410.48v8.7a1.79,1.79,0,0,1,.86.26,22.45,22.45,0,0,0,1.92,1.21s0-2,0-2.26A1,1,0,0,1,209,418L211,414a.73.73,0,0,0-.26-1,23.6,23.6,0,0,1-3.8-2.19A1.78,1.78,0,0,0,206.11,410.48Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.94,406.49c0,.43,0,8.46,0,8.69a.46.46,0,0,0,.08.21l3.41,4.76a1,1,0,0,0,.59.34V411.8a1.09,1.09,0,0,1-.61-.34L193,406.7A.35.35,0,0,1,192.94,406.49Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.6,383.78l-8.58-2a1.62,1.62,0,0,0-1.37.51L231.11,386a2.07,2.07,0,0,1-1.44.63,43.88,43.88,0,0,0-5.38,0,1.83,1.83,0,0,1-1.29-.4L219.06,382a1.57,1.57,0,0,0-1.33-.25l-8.25,2c-.4.1-.65.34-.65.6a.58.58,0,0,0,0,.18l2.24,4.43c.16.31-.11.74-.6,1s-1.14.57-1.67.87-1.11.67-1.61,1a2.44,2.44,0,0,1-1.56.44l-8.12-1.36a1.48,1.48,0,0,0-1.28.6l-3.11,4.34a.8.8,0,0,0-.17.47v0a.47.47,0,0,0,.34.45l7.42,2.35a.87.87,0,0,1,.55.95,8.31,8.31,0,0,0,0,2.68c.06.36-.28.77-.77.93l-7,2.22a.91.91,0,0,0-.54.37h0a.31.31,0,0,0-.06.19h0a.35.35,0,0,0,.07.21l3.41,4.76a1.41,1.41,0,0,0,1.25.36l7.88-1.32a2.14,2.14,0,0,1,1.41.24,24.84,24.84,0,0,0,3.8,2.19.73.73,0,0,1,.26,1L209,418a.59.59,0,0,0,.35.91l8.57,2.06a1.67,1.67,0,0,0,1.37-.51l3.54-3.72a2.12,2.12,0,0,1,1.45-.63,43.72,43.72,0,0,0,5.37,0,1.87,1.87,0,0,1,1.29.4l4,4.16a1.55,1.55,0,0,0,1.33.24l8.24-2c.49-.13.77-.47.61-.79l-2.24-4.42c-.15-.32.11-.74.6-1a23,23,0,0,0,3.29-1.89,2.4,2.4,0,0,1,1.55-.44l8.12,1.36a1.43,1.43,0,0,0,1.28-.6l3.11-4.33a1,1,0,0,0,.18-.48.49.49,0,0,0-.35-.47l-7.42-2.35a.86.86,0,0,1-.55-.94,8.37,8.37,0,0,0,0-2.69,1,1,0,0,1,.77-.92l7-2.23c.36-.11.58-.33.59-.55v0a.36.36,0,0,0-.07-.22l-3.41-4.76a1.39,1.39,0,0,0-1.25-.36l-7.87,1.32A2.12,2.12,0,0,1,247,392a21.39,21.39,0,0,0-1.91-1.21c-.61-.35-1.24-.67-1.9-1a.74.74,0,0,1-.26-1L245,384.7a.71.71,0,0,0,.09-.33v0A.56.56,0,0,0,244.6,383.78Zm-23.41,9.55c7.69-1.84,16.51.26,19.69,4.71a5.29,5.29,0,0,1,.77,5.26,1.08,1.08,0,0,1-.08.19,1.42,1.42,0,0,1-.08.18l-.08.17s0,0,0,0a8.44,8.44,0,0,1-2.57,2.86,11.86,11.86,0,0,1-1.26.81,18.22,18.22,0,0,1-4.83,1.86c-5.78,1.37-12.18.53-16.36-1.85a11.93,11.93,0,0,1-1.29-.84,9.15,9.15,0,0,1-2.05-2,5.32,5.32,0,0,1-.41-6c0-.05,0-.1.08-.14l.18-.29c.1-.15.2-.3.32-.45l.3-.37.15-.16.21-.21A15.13,15.13,0,0,1,221.19,393.33Z",
    style: {
      fill: "#35885D"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.68,346.91l30.66-17.72c3.16-1.83,4.74-4.22,4.74-6.61s0-4.27,0-4.27l-28.86-16.37a6.77,6.77,0,0,1-3.05-5.29v-37.8L90.64,289.8v37.8a6.73,6.73,0,0,0,3,5.28l24.1,14C124.11,350.56,134.36,350.56,140.68,346.91Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.49,334.29v4.25l-9.81-5.66a6.77,6.77,0,0,1-3.05-5.29V289.8l10.2-5.89c.22,2.59.44,5.27.66,7.88l-7.16,4.14v29.53a6.71,6.71,0,0,0,3,5.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.33,325.47a6.77,6.77,0,0,0,3,5.29l20.4,11.89c6.33,3.65,16.58,3.65,22.9,0l30.67-17.72c6.33-3.65,6.33-9.57,0-13.22l-20.42-11.9a6.73,6.73,0,0,1-3.05-5.29V265L94.33,295.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.15,303.4h0l-6.21-3.59a6.73,6.73,0,0,1-3.05-5.29V265L94.33,295.93v29.54a6.77,6.77,0,0,0,3,5.29l6.11,3.52Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.53,348.78a8.19,8.19,0,0,0,7.4-.14c26.33-15.2,149.87-86.53,176.2-101.72a8.46,8.46,0,0,0,3.81-6.61V92.76a7.16,7.16,0,0,0-11-6.33L30.77,188.15A8.46,8.46,0,0,0,27,194.76V342.31A8.2,8.2,0,0,0,30.53,348.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.93,348.64l176.2-101.73a8.43,8.43,0,0,0,3.81-6.61V92.76c0-2.44-1.71-3.42-3.81-2.2L37.93,192.28a8.43,8.43,0,0,0-3.81,6.61V346.44C34.11,348.87,35.82,349.85,37.93,348.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.16,328.64v-128a5.19,5.19,0,0,1,2.34-4.06l169.05-97.6c1.29-.75,2.34-.14,2.34,1.35V228.33a5.19,5.19,0,0,1-2.35,4.07L41.5,330C40.21,330.74,39.16,330.14,39.16,328.64Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.16,328.64v-128a5.19,5.19,0,0,1,2.34-4.06l169.05-97.6c1.29-.75,2.34-.14,2.34,1.35V228.33a5.19,5.19,0,0,1-2.35,4.07L41.5,330C40.21,330.74,39.16,330.14,39.16,328.64Z",
    style: {
      fill: "#fff",
      opacity: 0.75
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.08,191l7.16,4.13a8.05,8.05,0,0,0-1.13,3.77V346.44c0,2.22,1.51,3.46,3.82,2.2a8.1,8.1,0,0,1-7.4.14,7.36,7.36,0,0,1-3.58-6v-148A7.89,7.89,0,0,1,28.08,191Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.24,292.1l15.57-9c.78-.44,1.4-.13,1.4.71a3,3,0,0,1-1.4,2.32l-15.57,9c-.77.45-1.4.13-1.4-.7A3,3,0,0,1,118.24,292.1Z",
    style: {
      fill: "#35885D"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,337.06c-1.73-1.22-1.74-2.85-1.74-5.11V225.39a7.85,7.85,0,0,1,3.54-6.14l135.86-78.43c1.95-1.13,3.76-.31,5.59.74s3,2,3,4.24V252.36a7.85,7.85,0,0,1-3.54,6.14L218.82,336.93C215.85,338.93,213.83,338.39,212,337.06Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.82,336.93c-3,2-5,1.46-6.87.13-1.73-1.22-1.74-2.85-1.74-5.11V225.39a7.26,7.26,0,0,1,1-3.49l5.07,2.94a7.24,7.24,0,0,0-1,3.48V334.89C215.27,337.14,216.86,338.06,218.82,336.93Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.21,145.8c0-2.26-1.59-3.17-3.54-2.05L218.81,222.19a7.19,7.19,0,0,0-2.5,2.65l-5-2.93h0a7.32,7.32,0,0,1,2.52-2.65L349.6,140.82c2-1.14,3.76-.32,5.6.74S358.21,143.54,358.21,145.8Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.21,145.8a4.73,4.73,0,0,0,0-.54A4.56,4.56,0,0,1,358.21,145.8Z",
    style: {
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.27,228.32V334.89c0,2.26,1.59,3.17,3.55,2L354.67,258.5a7.85,7.85,0,0,0,3.54-6.14V145.8c0-2.26-1.59-3.18-3.54-2.05L218.82,222.19A7.82,7.82,0,0,0,215.27,228.32Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.72,226.27l131-75.6c1.17-.67,2.13-.12,2.13,1.23V249a4.73,4.73,0,0,1-2.13,3.69l-131,75.59c-1.17.68-2.12.13-2.12-1.22V230A4.71,4.71,0,0,1,220.72,226.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.72,226.27A4.71,4.71,0,0,0,218.6,230v96.48l130.2-75.16a4.7,4.7,0,0,0,2.13-3.68V151.12Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.27,342.82a7.59,7.59,0,0,0,3.55,5.88L296,393.25a7.84,7.84,0,0,0,7.09,0L438.9,314.82a6.65,6.65,0,0,0,0-11.77L361.75,258.5a7.82,7.82,0,0,0-7.08,0L218.82,336.93A7.61,7.61,0,0,0,215.27,342.82Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.45,308.93a7.59,7.59,0,0,1-3.55,5.89L303.05,393.25a7.3,7.3,0,0,1-3.54.85v-7.67a7.19,7.19,0,0,0,3.54-.86L438.9,307.14c1.72-1,1.93-2.51.65-3.64A7.62,7.62,0,0,1,442.45,308.93Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.82,341,296,385.57a7.84,7.84,0,0,0,7.09,0L438.9,307.14c2-1.13,2-3,0-4.09L361.75,258.5a7.82,7.82,0,0,0-7.08,0L218.82,336.93C216.86,338.06,216.86,339.89,218.82,341Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.62,337.14l126.1-72.8a3.88,3.88,0,0,1,3.54,0l3.67,1.93a1.08,1.08,0,0,1,0,2L235.81,341.1a3.88,3.88,0,0,1-3.54,0l-3.65-1.91A1.08,1.08,0,0,1,228.62,337.14Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.51,343l126.1-72.8a3.63,3.63,0,0,1,3.24-.18L400.67,289c.81.47.67,1.31-.31,1.87L274.41,363.57a3.66,3.66,0,0,1-3.24.18l-33-18.86C237.4,344.42,237.53,343.59,238.51,343Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.09,308.64l-3.48-2a.6.6,0,0,0-.55,0L301.11,309c-.16.09-.19.23-.06.32l3.49,2a.57.57,0,0,0,.55,0l4-2.27C309.21,308.87,309.24,308.73,309.09,308.64Zm47.38-28.82-.92-.54a.69.69,0,0,0-.56,0l-3.94,2.28c-.17.11-.2.25-.06.32l.92.54a.65.65,0,0,0,.56,0l3.95-2.28C356.58,280,356.61,279.9,356.47,279.82ZM386,290.2l-3.48-2a.6.6,0,0,0-.55,0L378,290.49c-.17.11-.19.25-.06.33l3.48,2a.6.6,0,0,0,.55,0l3.95-2.29C386.1,290.42,386.13,290.28,386,290.2Zm-10.66-12.82-3.48-2a.63.63,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.06.32l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C375.44,277.6,375.46,277.46,375.33,277.38ZM368,273.15l-.93-.53a.63.63,0,0,0-.55,0l-3.95,2.28c-.16.1-.19.24-.05.32l.93.53a.57.57,0,0,0,.55,0l3.94-2.27C368.13,273.38,368.15,273.24,368,273.15Zm-17.31,10-.92-.53a.63.63,0,0,0-.55,0l-4,2.28c-.17.11-.2.25-.06.33l.92.53a.65.65,0,0,0,.56,0l3.95-2.28C350.81,283.38,350.84,283.23,350.7,283.15ZM320.64,302l-3.49-2a.57.57,0,0,0-.55,0l-4,2.27c-.17.1-.19.24,0,.33l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C320.75,302.21,320.78,302.07,320.64,302Zm-5.77,3.33-3.49-2a.57.57,0,0,0-.55,0l-3.95,2.28c-.17.09-.19.23-.05.32l3.48,2a.6.6,0,0,0,.55,0l3.95-2.28C315,305.54,315,305.4,314.87,305.31Zm24.35-14.06-3.48-2a.67.67,0,0,0-.55,0l-3.95,2.29c-.17.09-.19.24-.06.31l3.49,2a.62.62,0,0,0,.56,0l3.93-2.28C339.34,291.47,339.36,291.33,339.22,291.25Zm-12.81,7.4-3.49-2a.6.6,0,0,0-.55,0L318.42,299c-.17.1-.19.24-.05.32l3.48,2a.67.67,0,0,0,.55,0l4-2.28C326.52,298.88,326.54,298.73,326.41,298.65ZM345,287.92l-3.48-2a.6.6,0,0,0-.55,0L337,288.23c-.17.09-.19.23-.06.31l3.49,2a.6.6,0,0,0,.55,0l3.95-2.27C345.11,288.14,345.14,288,345,287.92Zm-11.54,6.67-3.48-2a.67.67,0,0,0-.55,0l-3.95,2.29c-.16.09-.19.24-.06.31l3.48,2a.65.65,0,0,0,.56,0l3.95-2.29C333.56,294.8,333.59,294.66,333.45,294.59Zm28.79-18.11-.92-.53a.69.69,0,0,0-.56,0l-3.95,2.28c-.16.1-.19.25-.05.32l.92.53a.62.62,0,0,0,.56,0l3.94-2.28C362.35,276.71,362.38,276.57,362.24,276.48Zm-32.43,46.15-3.49-2a.67.67,0,0,0-.55,0l-3.95,2.28c-.17.09-.19.24-.05.31l3.48,2a.6.6,0,0,0,.55,0l3.95-2.28C329.92,322.86,329.94,322.72,329.81,322.63Zm-11.55,6.67-3.48-2a.6.6,0,0,0-.55,0l-4,2.28c-.17.1-.19.24-.06.32l3.49,2a.63.63,0,0,0,.55,0l3.95-2.28C318.38,329.53,318.41,329.38,318.26,329.3ZM324,326l-3.48-2a.67.67,0,0,0-.55,0l-3.95,2.28c-.17.09-.19.24-.06.31l3.49,2a.63.63,0,0,0,.55,0l4-2.28C324.15,326.19,324.17,326.05,324,326ZM301,339.29l-3.48-2a.57.57,0,0,0-.55,0L293,339.6c-.16.09-.19.23-.06.31l3.48,2a.59.59,0,0,0,.56,0l3.95-2.27C301.06,339.52,301.09,339.37,301,339.29Zm11.54-6.66-3.48-2a.58.58,0,0,0-.55,0l-3.95,2.27c-.17.1-.19.24-.06.32l3.49,2a.6.6,0,0,0,.55,0l3.95-2.28C312.61,332.86,312.63,332.72,312.49,332.63ZM306.72,336l-3.48-2a.57.57,0,0,0-.55,0l-3.95,2.28c-.17.09-.19.23-.06.31l3.48,2a.59.59,0,0,0,.56,0l3.94-2.28C306.84,336.19,306.86,336.05,306.72,336Zm55-31.73-3.47-2a.59.59,0,0,0-.56,0l-4,2.27c-.16.1-.19.24,0,.33l3.47,2a.62.62,0,0,0,.56,0l3.95-2.28C361.8,304.45,361.83,304.31,361.69,304.23ZM335.58,319.3l-3.49-2a.6.6,0,0,0-.55,0l-4,2.28c-.17.09-.2.23,0,.31l3.48,2a.57.57,0,0,0,.55,0l3.95-2.27C335.69,319.53,335.71,319.39,335.58,319.3ZM369,293.7l-3.48-2a.6.6,0,0,0-.55,0L361,294c-.16.09-.19.23-.06.32l3.48,2a.57.57,0,0,0,.55,0l4-2.27C369.08,293.92,369.11,293.78,369,293.7Zm5.48,3.16-3.49-2a.67.67,0,0,0-.55,0l-4,2.28c-.16.1-.19.24,0,.32l3.48,2a.6.6,0,0,0,.55,0l3.95-2.28C374.56,297.08,374.59,296.94,374.45,296.86Zm-25.51,14.73-3.48-2a.63.63,0,0,0-.55,0l-11.54,6.66c-.18.1-.2.24-.06.33l3.48,2a.57.57,0,0,0,.55,0l11.54-6.66C349.06,311.81,349.07,311.67,348.94,311.59Zm7.57-17-3.49-2a.67.67,0,0,0-.55,0l-4,2.28c-.16.1-.19.24,0,.32l3.48,2a.65.65,0,0,0,.56,0l3.95-2.28C356.62,294.79,356.65,294.65,356.51,294.57Zm23.71-1-3.49-2a.6.6,0,0,0-.55,0l-3.94,2.28c-.18.1-.19.24-.06.32l3.48,2a.57.57,0,0,0,.55,0l4-2.27C380.33,293.75,380.36,293.61,380.22,293.53Zm-13.05,13.86-3.48-2a.62.62,0,0,0-.56,0l-3.95,2.27c-.16.11-.19.25,0,.33l3.48,2a.58.58,0,0,0,.55,0l3.95-2.28C367.28,307.61,367.31,307.47,367.17,307.39Zm-20.65,11.92-3.48-2a.6.6,0,0,0-.55,0l-4.86,2.81c-.17.09-.2.24-.06.32l3.48,2a.6.6,0,0,0,.55,0l4.86-2.81C346.64,319.53,346.65,319.39,346.52,319.31Zm-61,35.25-3.49-2a.69.69,0,0,0-.56,0l-4.85,2.81c-.17.1-.2.24-.05.32l3.48,2a.63.63,0,0,0,.55,0l4.86-2.81C285.58,354.77,285.61,354.63,285.48,354.56ZM333.16,327l-3.49-2a.57.57,0,0,0-.55,0l-4.86,2.81c-.17.09-.19.23-.05.31l3.48,2a.57.57,0,0,0,.55,0l4.86-2.81C333.27,327.25,333.29,327.11,333.16,327Zm-41,23.66-3.48-2a.59.59,0,0,0-.56,0l-4.86,2.81c-.16.09-.19.24-.05.31l3.48,2a.63.63,0,0,0,.55,0L292.1,351C292.26,350.92,292.29,350.78,292.16,350.69Zm34.31-19.81-3.48-2a.58.58,0,0,0-.55,0l-32.5,18.76c-.16.09-.19.23-.05.32l3.49,2a.6.6,0,0,0,.55,0l32.49-18.75C326.59,331.1,326.62,331,326.47,330.88Zm27.95-16.12-3.48-2a.65.65,0,0,0-.56,0l-6.07,3.51c-.17.1-.2.24-.06.32l3.49,2a.6.6,0,0,0,.55,0l6.07-3.51C354.53,315,354.55,314.83,354.42,314.76Zm-14.58,8.41-3.48-2a.69.69,0,0,0-.56,0l-4.86,2.8c-.17.11-.18.25-.05.32l3.48,2a.64.64,0,0,0,.55,0l4.86-2.8C340,323.39,340,323.25,339.84,323.17ZM397.24,290l-9-5.17a.63.63,0,0,0-.55,0l-4,2.28c-.17.11-.19.25-.06.33l9,5.17a.63.63,0,0,0,.55,0l3.95-2.28C397.35,290.25,397.37,290.11,397.24,290Zm-5.77,3.33-3.49-2a.6.6,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.05.32l3.48,2a.6.6,0,0,0,.55,0l4-2.28C391.58,293.58,391.61,293.44,391.47,293.36ZM361.4,310.72l-3.48-2a.62.62,0,0,0-.56,0L353.41,311c-.16.1-.19.24-.05.32l3.49,2a.58.58,0,0,0,.55,0l4-2.27C361.51,310.94,361.54,310.8,361.4,310.72Zm-66.22,31.9-3.48-2a.66.66,0,0,0-.56,0l-3.94,2.28c-.17.09-.19.24-.05.31l3.47,2a.62.62,0,0,0,.56,0l3.95-2.28C295.29,342.85,295.32,342.7,295.18,342.62Zm77.76-38.56-3.49-2a.63.63,0,0,0-.55,0L365,304.35c-.16.11-.19.25,0,.33l3.47,2a.66.66,0,0,0,.56,0l3.95-2.28C373.05,304.28,373.08,304.13,372.94,304.06Zm12.75-7.37-3.48-2a.6.6,0,0,0-.55,0l-9.72,5.62c-.16.09-.19.24-.06.31l3.49,2a.65.65,0,0,0,.56,0l9.71-5.62C385.81,296.91,385.84,296.77,385.69,296.69ZM269.46,331.54l-3.49-2a.6.6,0,0,0-.55,0l-3.95,2.28c-.17.11-.2.25-.05.33l3.48,2a.64.64,0,0,0,.55,0l3.95-2.28C269.57,331.76,269.59,331.61,269.46,331.54Zm5.77-3.33-3.49-2a.63.63,0,0,0-.55,0l-3.95,2.28c-.17.11-.2.25-.05.32l3.48,2a.64.64,0,0,0,.55,0l3.95-2.28C275.34,328.42,275.36,328.28,275.23,328.21Zm3.57,30.2-3.49-2a.6.6,0,0,0-.55,0l-6.07,3.5c-.17.09-.2.24-.06.32l3.48,2a.6.6,0,0,0,.55,0l6.08-3.51C278.91,358.64,278.93,358.5,278.8,358.41Zm4.7-35-3.48-2a.58.58,0,0,0-.55,0l-4,2.28c-.17.09-.19.23-.06.31l3.49,2a.6.6,0,0,0,.55,0l3.95-2.27C283.62,323.64,283.65,323.5,283.5,323.42Zm11.55-6.66-3.49-2a.6.6,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.05.32l3.48,2a.67.67,0,0,0,.55,0l3.95-2.28C295.16,317,295.18,316.84,295.05,316.76Zm-31.37,18.11-3.48-2a.57.57,0,0,0-.55,0l-3.95,2.27c-.17.11-.2.25-.06.33l3.49,2a.58.58,0,0,0,.55,0l3.95-2.28C263.8,335.09,263.82,335,263.68,334.87Zm25.59-14.78-3.48-2a.58.58,0,0,0-.55,0l-3.95,2.27c-.17.1-.19.24-.05.32l3.48,2a.6.6,0,0,0,.55,0l4-2.28C289.39,320.31,289.41,320.17,289.27,320.09Zm11.55-6.66-3.49-2a.6.6,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.05.31l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C300.93,313.65,301,313.5,300.82,313.43ZM272.1,356l-3.48-2a.57.57,0,0,0-.55,0l-4.86,2.8c-.17.09-.2.23-.06.32l3.49,2a.6.6,0,0,0,.55,0l4.86-2.8C272.22,356.17,272.24,356,272.1,356Zm-2.74-4.73-3.48-2a.63.63,0,0,0-.55,0l-7.6,4.39c-.17.09-.2.23-.05.32l3.48,2a.57.57,0,0,0,.55,0l7.59-4.38C269.47,351.43,269.49,351.29,269.36,351.22Zm-11.45-13-3.48-2a.57.57,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.06.32l3.49,2a.57.57,0,0,0,.55,0l4-2.28C258,338.42,258.05,338.28,257.91,338.2ZM249.63,343l-3.48-2a.69.69,0,0,0-.56,0l-4.86,2.8c-.16.11-.19.25,0,.32l3.48,2a.64.64,0,0,0,.55,0l4.86-2.8C249.74,343.2,249.77,343.06,249.63,343Zm12.73,5.95-3.48-2a.63.63,0,0,0-.55,0l-6.07,3.52c-.18.09-.2.23-.06.31l3.48,2a.57.57,0,0,0,.55,0l6.08-3.51C262.48,349.15,262.5,349,262.36,348.93Zm-7.6-1.94-3.48-2a.57.57,0,0,0-.55,0l-3.95,2.28c-.17.09-.2.23-.06.31l3.49,2a.6.6,0,0,0,.55,0l3.94-2.28C254.88,347.21,254.89,347.07,254.76,347Zm34.65-1-3.48-2a.66.66,0,0,0-.56,0l-3.95,2.28c-.16.1-.18.24,0,.31l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C289.52,346.17,289.55,346,289.41,346Zm7.57-17-3.48-2a.63.63,0,0,0-.55,0L289,329.24c-.17.1-.19.24-.06.31l3.49,2a.67.67,0,0,0,.55,0l3.95-2.28C297.1,329.16,297.12,329,297,328.94Zm-5.77,3.33-3.48-2a.6.6,0,0,0-.55,0l-3.95,2.28c-.16.1-.19.24-.06.32l3.49,2a.67.67,0,0,0,.55,0l3.94-2.28C291.33,332.49,291.35,332.35,291.21,332.27Zm23.09-13.33-3.49-2a.57.57,0,0,0-.55,0l-3.95,2.28c-.17.09-.19.23-.05.31l3.48,2a.6.6,0,0,0,.55,0l3.95-2.28C314.41,319.16,314.43,319,314.3,318.94Zm-11.55,6.67-3.48-2a.67.67,0,0,0-.55,0l-4,2.29c-.17.09-.19.24-.06.31l3.49,2a.63.63,0,0,0,.55,0l3.95-2.28C302.87,325.82,302.9,325.68,302.75,325.61Zm5.77-3.34-3.48-2a.64.64,0,0,0-.55,0l-3.95,2.28c-.17.09-.19.23-.06.31l3.49,2a.6.6,0,0,0,.55,0l4-2.27C308.64,322.49,308.66,322.35,308.52,322.27ZM285.44,335.6l-3.48-2a.6.6,0,0,0-.55,0l-4,2.28c-.16.1-.19.24-.06.32l3.48,2a.62.62,0,0,0,.56,0l3.95-2.28C285.55,335.82,285.58,335.68,285.44,335.6Zm-5.77,3.33-3.48-2a.62.62,0,0,0-.56,0l-3.94,2.29c-.17.09-.19.23-.05.31l3.47,2a.62.62,0,0,0,.56,0l3.95-2.27C279.78,339.15,279.81,339,279.67,338.93Zm18.54-4.37-3.49-2a.67.67,0,0,0-.55,0l-3.95,2.28c-.17.11-.19.25-.05.32l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C298.32,334.78,298.35,334.63,298.21,334.56Zm-5.77,3.33-3.49-2a.63.63,0,0,0-.55,0l-3.95,2.28c-.16.11-.19.25-.05.33l3.48,2a.66.66,0,0,0,.56,0l3.95-2.28C292.55,338.11,292.58,338,292.44,337.89Zm-5.78,3.33-3.48-2a.6.6,0,0,0-.55,0l-3.95,2.27c-.16.11-.19.25-.05.33l3.48,2a.59.59,0,0,0,.56,0l3.95-2.28C286.78,341.44,286.81,341.3,286.66,341.22Zm-12.76,1-3.48-2a.69.69,0,0,0-.56,0l-3.95,2.29c-.16.09-.18.24,0,.31l3.48,2a.63.63,0,0,0,.55,0l4-2.28C274,342.48,274,342.34,273.9,342.26Zm7,2.29-3.47-2a.59.59,0,0,0-.56,0l-3.95,2.28c-.16.1-.19.24-.05.32l3.49,2a.58.58,0,0,0,.55,0l4-2.27C281,344.77,281,344.63,280.89,344.55Zm44.95-32.27-3.49-2a.6.6,0,0,0-.55,0l-3.94,2.28c-.18.1-.2.24-.06.32l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C326,312.5,326,312.35,325.84,312.28Zm48.9-21.91-3.48-2a.57.57,0,0,0-.55,0l-3.95,2.28c-.17.09-.19.24-.06.32l3.48,2a.59.59,0,0,0,.56,0l3.94-2.28C374.85,290.59,374.88,290.45,374.74,290.37Zm-54.67,25.24-3.49-2a.57.57,0,0,0-.55,0l-3.95,2.27c-.17.1-.19.24-.05.32l3.48,2a.6.6,0,0,0,.55,0l3.95-2.28C320.18,315.83,320.2,315.69,320.07,315.61Zm43.42-25.08-3.48-2a.57.57,0,0,0-.55,0l-3.95,2.28c-.17.09-.19.23-.06.32l3.49,2a.6.6,0,0,0,.55,0l3.95-2.27C363.61,290.76,363.64,290.62,363.49,290.53Zm22.79-6.82-9-5.18a.63.63,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.05.32l9,5.18a.63.63,0,0,0,.55,0l4-2.28C386.4,283.93,386.42,283.78,386.28,283.71Zm-11.24.16-3.49-2a.6.6,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.05.33l3.48,2a.67.67,0,0,0,.55,0l4-2.28C375.15,284.1,375.18,284,375,283.87Zm-5.78,3.33-3.48-2a.57.57,0,0,0-.55,0l-4,2.27c-.17.1-.19.24-.06.33l3.49,2a.6.6,0,0,0,.55,0l3.95-2.28C369.38,287.43,369.41,287.29,369.26,287.2Zm11.25-.16L377,285a.57.57,0,0,0-.55,0l-4,2.27c-.17.1-.19.25-.06.33l3.49,2a.6.6,0,0,0,.55,0l3.95-2.28C380.63,287.26,380.65,287.12,380.51,287Zm-70.76,40.85-3.48-2a.65.65,0,0,0-.56,0l-3.94,2.28c-.17.1-.19.24-.06.32l3.48,2a.6.6,0,0,0,.55,0l3.95-2.28C309.86,328.11,309.89,328,309.75,327.89Zm59.81-47.18-3.49-2a.6.6,0,0,0-.55,0L361.58,281c-.18.1-.19.24-.06.32l3.48,2a.63.63,0,0,0,.55,0L369.5,281C369.67,280.94,369.7,280.79,369.56,280.71ZM331.61,309l-3.48-2a.63.63,0,0,0-.55,0l-3.95,2.28c-.17.1-.2.24-.06.31l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C331.72,309.17,331.74,309,331.61,309ZM363.79,284l-3.49-2a.6.6,0,0,0-.55,0l-3.95,2.27c-.17.1-.19.24-.05.33l3.48,2a.6.6,0,0,0,.55,0l4-2.28C363.9,284.27,363.93,284.13,363.79,284ZM351,291.41l-3.48-2a.64.64,0,0,0-.55,0l-3.95,2.28c-.16.09-.19.24-.06.31l3.48,2a.65.65,0,0,0,.56,0l3.94-2.28C351.14,291.63,351.17,291.49,351,291.41Zm7-4-3.49-2a.6.6,0,0,0-.55,0l-4,2.28c-.17.09-.19.23,0,.32l3.48,2a.57.57,0,0,0,.55,0l3.95-2.28C358.13,287.6,358.16,287.46,358,287.37Zm-54,43.85-3.49-2a.67.67,0,0,0-.55,0L296,331.52c-.18.1-.19.25-.06.32l3.48,2a.63.63,0,0,0,.55,0l3.95-2.29C304.09,331.44,304.12,331.3,304,331.22Zm-26.14,2.44-3.49-2a.64.64,0,0,0-.55,0L269.85,334c-.16.09-.19.24-.05.31l3.48,2a.62.62,0,0,0,.56,0l4-2.28C278,333.88,278,333.74,277.84,333.66Zm5.77-3.33-3.49-2a.58.58,0,0,0-.55,0l-3.94,2.28c-.17.09-.19.23-.06.31l3.48,2a.59.59,0,0,0,.56,0l3.94-2.27C283.72,330.56,283.75,330.41,283.61,330.33Zm5.77-3.33-3.48-2a.6.6,0,0,0-.56,0l-3.94,2.27c-.17.1-.19.24-.06.32l3.48,2a.57.57,0,0,0,.55,0l3.95-2.28C289.49,327.23,289.52,327.08,289.38,327Zm11.54-6.66-3.48-2a.6.6,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.06.31l3.49,2a.63.63,0,0,0,.55,0l3.94-2.28C301,320.57,301.05,320.42,300.92,320.34ZM272.07,337l-3.48-2a.66.66,0,0,0-.56,0l-3.95,2.28c-.16.09-.19.24,0,.31l3.47,2a.65.65,0,0,0,.56,0l3.95-2.28C272.18,337.21,272.21,337.07,272.07,337Zm23.08-13.33-3.48-2a.6.6,0,0,0-.55,0L287.17,324c-.17.1-.19.24-.06.32l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C295.26,323.9,295.29,323.75,295.15,323.67Zm-28.86,16.66-3.47-2a.62.62,0,0,0-.56,0l-3.95,2.28c-.16.1-.19.24-.05.31l3.49,2a.67.67,0,0,0,.55,0l3.95-2.28C266.41,340.55,266.44,340.4,266.29,340.33Zm11.58,12.29-3.48-2a.57.57,0,0,0-.55,0l-3.95,2.27c-.17.1-.2.24-.05.32l3.48,2a.6.6,0,0,0,.55,0l3.95-2.28C278,352.84,278,352.7,277.87,352.62Zm5.78-3.33-3.49-2a.62.62,0,0,0-.56,0l-4,2.28c-.16.1-.19.24,0,.32l3.48,2a.63.63,0,0,0,.55,0l3.95-2.28C283.75,349.51,283.78,349.36,283.65,349.29Zm-15.51-3.69-3.49-2a.69.69,0,0,0-.56,0l-3.94,2.29c-.17.09-.2.24,0,.31l3.48,2a.67.67,0,0,0,.55,0l3.95-2.29C268.24,345.81,268.27,345.67,268.14,345.6Zm-7.61-1.94-3.48-2a.59.59,0,0,0-.56,0L252.55,344c-.17.1-.2.24-.06.32l3.49,2a.63.63,0,0,0,.55,0l4-2.28C260.64,343.88,260.67,343.74,260.53,343.66Zm14.6,4.22-3.48-2a.62.62,0,0,0-.56,0l-3.94,2.28c-.17.1-.2.24-.06.32l3.49,2a.58.58,0,0,0,.55,0l3.94-2.27C275.24,348.1,275.26,348,275.13,347.88ZM306.69,317l-3.48-2a.67.67,0,0,0-.55,0l-4,2.28c-.17.09-.19.24-.06.31l3.49,2a.63.63,0,0,0,.55,0l3.95-2.28C306.81,317.23,306.83,317.09,306.69,317Zm5.77-3.34-3.48-2a.63.63,0,0,0-.55,0L304.48,314c-.17.09-.19.24-.06.31l3.49,2a.57.57,0,0,0,.55,0l4-2.27C312.58,313.9,312.6,313.76,312.46,313.67Zm31-5.24-9-5.18a.66.66,0,0,0-.56,0l-4.54,2.63c-.17.09-.2.24-.06.31l5,2.88c.15.08.12.23,0,.32l-3.65,2.11c-.17.09-.2.24-.05.31l3.48,2a.63.63,0,0,0,.55,0l8.81-5.09C343.57,308.65,343.6,308.51,343.46,308.43Zm1.5-7.2-3.47-2a.62.62,0,0,0-.56,0L337,301.53c-.16.1-.19.24-.05.33l3.49,2a.6.6,0,0,0,.55,0l3.95-2.28C345.08,301.46,345.11,301.32,345,301.23Zm-29.44,23.33-3.48-2a.6.6,0,0,0-.55,0l-3.95,2.28c-.17.1-.19.24-.06.32l3.48,2a.6.6,0,0,0,.55,0l3.95-2.29C315.63,324.78,315.65,324.64,315.52,324.56Zm5.77-3.33-3.48-2a.6.6,0,0,0-.55,0l-3.95,2.27c-.17.11-.19.25-.06.33l3.49,2a.63.63,0,0,0,.55,0l3.94-2.29C321.41,321.45,321.42,321.31,321.29,321.23Zm5.77-3.33-3.48-2a.63.63,0,0,0-.55,0l-3.95,2.28c-.17.11-.19.25-.06.33l3.49,2a.67.67,0,0,0,.55,0l3.95-2.29C327.18,318.12,327.2,318,327.06,317.9Zm5.77-3.33-3.48-2a.67.67,0,0,0-.55,0l-3.95,2.28c-.17.11-.2.25-.06.32l3.49,2a.67.67,0,0,0,.55,0l3.95-2.29C333,314.78,333,314.64,332.83,314.57Zm-14.6-4.23-3.48-2a.57.57,0,0,0-.55,0l-3.95,2.28c-.17.09-.2.23-.05.31l3.48,2a.57.57,0,0,0,.55,0l3.95-2.27C318.35,310.57,318.37,310.43,318.23,310.34ZM324,307l-3.49-2a.6.6,0,0,0-.55,0l-4,2.27c-.17.1-.2.24,0,.32l3.48,2a.57.57,0,0,0,.55,0l3.95-2.28C324.12,307.24,324.14,307.1,324,307Zm15.48-8.94-3.48-2a.62.62,0,0,0-.56,0l-3.95,2.28c-.16.1-.19.24,0,.32l3.48,2a.6.6,0,0,0,.55,0l3.95-2.28C339.6,298.3,339.63,298.15,339.49,298.07Zm-7,4-3.48-2a.62.62,0,0,0-.56,0L321.79,304c-.17.1-.19.24-.05.32l3.48,2a.63.63,0,0,0,.55,0l6.68-3.85C332.62,302.32,332.64,302.18,332.51,302.1Zm12.75-7.36-3.48-2a.62.62,0,0,0-.56,0L337.28,295c-.17.1-.19.24,0,.31l3.47,2a.65.65,0,0,0,.56,0l3.95-2.28C345.37,295,345.4,294.81,345.26,294.74Zm5.48,3.16-3.49-2a.63.63,0,0,0-.55,0l-3.95,2.28c-.16.1-.19.24,0,.32l3.47,2a.65.65,0,0,0,.56,0l3.95-2.28C350.85,298.13,350.88,298,350.74,297.9Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.21 341.07 323.02 341.54 344.52 353.95 382.76 331.88 383.55 331.42 361.24 318.54 322.21 341.07",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.4 332.08 361.24 319.88 323.37 341.75 344.52 353.95 382.4 332.08",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "382.4 332.08 361.24 319.88 323.37 341.75 344.52 353.95 382.4 332.08",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.51,386.43v7.67a7.16,7.16,0,0,1-3.54-.85L218.81,348.7a6.64,6.64,0,0,1-.36-11.54c-1.58,1.14-1.46,2.81.36,3.86L296,385.58A7.27,7.27,0,0,0,299.51,386.43Z",
    style: {
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary-code--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Binary--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M237.42,227.52l.53-.41v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,232.32a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.81,1.81,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.5,3.5,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,242.28l.53-.4V238l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,247.09a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37V247.1a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.5,3.5,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,257.06l.53-.41v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,264.44l.53-.4V260.1l-.54.33V260l1-.91v4.7l.52-.2V264l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,271.83l.53-.41v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,276.63a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.5,3.5,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,286.6l.53-.41v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,291.4a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.5,3.5,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.42,301.37,238,301V297l-.54.32v-.44l1-.91v4.69l.52-.2V301l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.21,306.17a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.5,3.5,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.49,228.81a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.36,2.36,0,0,1-.29-1.37v-1.25a4.6,4.6,0,0,1,.29-1.71,1.92,1.92,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12V230a2,2,0,0,0,.16.93.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.26,3.26,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,238.78l.53-.4v-3.94l-.54.33v-.45l1-.91v4.7l.52-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,246.17l.53-.41v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,253.55l.53-.4v-3.94l-.54.33v-.45l1-.91v4.7l.52-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.49,258.35a4.52,4.52,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.36,2.36,0,0,1-.29-1.37v-1.25a4.63,4.63,0,0,1,.29-1.71,1.92,1.92,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.93.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.26,3.26,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.49,265.74a4.56,4.56,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.39,2.39,0,0,1,.29,1.38Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,275.71l.53-.41v-3.93l-.54.32v-.44l1-.91V275l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.49,280.51a4.56,4.56,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.39,2.39,0,0,1,.29,1.38Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,290.48l.53-.41v-3.93l-.54.32V286l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.49,295.28a4.56,4.56,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,305.25l.53-.41v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.49,310.05a4.56,4.56,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,235.28l.53-.41v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,242.66l.53-.4v-3.94l-.54.33v-.45l1-.91V242l.52-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,247.46a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.36,2.36,0,0,1-.29-1.37v-1.25a4.6,4.6,0,0,1,.29-1.71,1.92,1.92,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.47.08a1.1,1.1,0,0,0,.46-.61,3.26,3.26,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,257.43l.53-.4v-3.94l-.54.33V253l1-.91v4.7l.52-.2V257l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,262.23a4.52,4.52,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.36,2.36,0,0,1-.29-1.37v-1.25a4.63,4.63,0,0,1,.29-1.71,1.92,1.92,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.47.08a1.1,1.1,0,0,0,.46-.61,3.26,3.26,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,269.62a4.56,4.56,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.39,2.39,0,0,1,.29,1.38Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,279.59l.53-.41v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46L224,280Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,284.39a4.56,4.56,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37V284.4a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.39,2.39,0,0,1,.29,1.38Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,291.77a4.49,4.49,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.36,2.36,0,0,1-.29-1.37v-1.25a4.63,4.63,0,0,1,.29-1.71,1.92,1.92,0,0,1,.79-1c.34-.19.6-.17.8.08a2.36,2.36,0,0,1,.29,1.37Zm-.46-1.12a1.88,1.88,0,0,0-.16-.94c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.47.08a1.1,1.1,0,0,0,.46-.61,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,301.74l.53-.4V297.4l-.54.33v-.45l1-.9v4.69l.52-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,309.13l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.21v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.77,313.93a4.56,4.56,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.2-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.39,2.39,0,0,1,.29,1.38Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.52,215.91l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,220.71a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.34.19-.6.16-.79-.08a2.29,2.29,0,0,1-.3-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.08a2.26,2.26,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,230.68l.53-.41v-3.93l-.54.32v-.44l1-.91V230l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,235.48a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.34.19-.6.16-.79-.08a2.29,2.29,0,0,1-.3-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.08a2.26,2.26,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,245.45l.53-.41v-3.93l-.54.32V241l1-.91v4.7l.52-.2V245l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,252.83l.53-.4V248.5l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,260.22l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,265a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.34.19-.6.16-.79-.08a2.29,2.29,0,0,1-.3-1.37V265a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.08a2.26,2.26,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,275l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,279.79a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.34.19-.6.16-.79-.08a2.29,2.29,0,0,1-.3-1.37V279.8a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.08a2.26,2.26,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.52,289.76l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.31,294.56a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.34.19-.6.16-.79-.08a2.29,2.29,0,0,1-.3-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.08a2.26,2.26,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,217.21a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.81,1.81,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94.32.32,0,0,0,.47.08,1.12,1.12,0,0,0,.46-.62,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,227.17l.53-.4v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,234.56l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,241.94l.53-.4v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,246.75a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.81,1.81,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.5,3.5,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,254.13a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.38,2.38,0,0,1-.29-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,264.1l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,268.9a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.38,2.38,0,0,1-.29-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11V270a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,278.87l.53-.4v-3.94l-.54.33v-.45l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,283.67a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.38,2.38,0,0,1-.29-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.8,293.64l.53-.41V289.3l-.54.32v-.44l1-.91V293l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.59,298.44a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.38,2.38,0,0,1-.29-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08A1.1,1.1,0,0,0,252,300a3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,223.67l.53-.41v-3.93l-.54.32v-.44l1-.91V223l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,231.05l.53-.4v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,235.86a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.81,1.81,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12V237a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,245.82l.53-.4v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,250.63a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.81,1.81,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,258a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.38,2.38,0,0,1-.29-1.37V258a4.56,4.56,0,0,1,.29-1.71,1.92,1.92,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,268l.53-.41v-3.93l-.54.33v-.45l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,272.78a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.38,2.38,0,0,1-.29-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,1.92,1.92,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,280.17a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94c.11.17.27.19.47.08a1.12,1.12,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,290.14l.53-.41V285.8l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.08,297.52l.53-.4v-3.94l-.54.33v-.45l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.87,302.32a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.36,2.36,0,0,1-.29-1.37v-1.25a4.6,4.6,0,0,1,.29-1.71,1.92,1.92,0,0,1,.79-1c.34-.2.6-.17.8.08a2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M277.62,204.3l.53-.4V200l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.41,209.11a4.28,4.28,0,0,1-.29,1.7,1.9,1.9,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.27,2.27,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1c.33-.19.6-.17.79.08a2.28,2.28,0,0,1,.29,1.37ZM279,208a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.46-.07a1.11,1.11,0,0,0-.47.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.12,1.12,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,219.07l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.41,223.88a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1c.33-.19.6-.17.79.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.46-.07a1.11,1.11,0,0,0-.47.61,3.46,3.46,0,0,0-.16,1.12V225a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.12,1.12,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,233.84l.53-.4V229.5l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,241.23l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,248.61l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.41,253.42a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.27,2.27,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1c.33-.19.6-.17.79.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.46-.07a1.11,1.11,0,0,0-.47.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.12,1.12,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,263.38l.53-.4V259l-.54.33v-.45l1-.9v4.69l.53-.2V263l-1.52.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.41,268.19a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37V268.2a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1c.33-.19.6-.17.79.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.46-.07a1.11,1.11,0,0,0-.47.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.12,1.12,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.62,278.15l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.41,283a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37V283a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1c.33-.19.6-.17.79.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.46-.07a1.11,1.11,0,0,0-.47.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.12,1.12,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,205.6a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.33.2-.6.17-.79-.07a2.3,2.3,0,0,1-.3-1.38v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.07a2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.08a1.13,1.13,0,0,0-.46.62,3.43,3.43,0,0,0-.16,1.11v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.09,1.09,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,215.57l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.21v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,223l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.52-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,230.34l.53-.41V226l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,235.14a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.56.56,0,0,1-.79-.08,2.3,2.3,0,0,1-.3-1.38v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.07a2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.08a1.13,1.13,0,0,0-.46.62,3.43,3.43,0,0,0-.16,1.11v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,242.53a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.61-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.11-.16-.26-.19-.47-.07a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.06,1.06,0,0,0,.46-.61,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,252.49l.53-.4v-3.94l-.54.33V248l1-.91v4.69l.52-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,257.3a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.61-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.11-.16-.26-.19-.47-.07a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.06,1.06,0,0,0,.46-.61,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,267.26l.53-.4v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,272.07a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.61-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.11-.16-.26-.19-.47-.07a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.06,1.06,0,0,0,.46-.61,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,282l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.52-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,286.84a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.61-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.11-.16-.26-.19-.47-.07a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12V288a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.06,1.06,0,0,0,.46-.61,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,212.06l.53-.4v-3.94l-.54.33v-.44l1-.91v4.69l.52-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,219.45l.53-.41v-3.93l-.54.32V215l1-.91v4.7l.52-.21V219l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,224.25a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.39,2.39,0,0,1-.29-1.38v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.6-.17.8.07A2.32,2.32,0,0,1,266,223Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.08a1.13,1.13,0,0,0-.46.62,3.43,3.43,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.09,1.09,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,234.22l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,239a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.38,2.38,0,0,1-.29-1.37V239a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.6-.17.8.08a2.26,2.26,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.08a1.17,1.17,0,0,0-.46.62,3.43,3.43,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,246.41a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.11-.16-.26-.19-.47-.07a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.93.32.32,0,0,0,.47.09,1.12,1.12,0,0,0,.46-.62,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,256.37l.53-.4V252l-.54.33v-.44l1-.91v4.69l.52-.2V256l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,261.18a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.11-.16-.26-.19-.47-.07a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.93.32.32,0,0,0,.47.09,1.12,1.12,0,0,0,.46-.62,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,268.56a4.37,4.37,0,0,1-.29,1.71,2,2,0,0,1-.79,1,.57.57,0,0,1-.8-.08,2.38,2.38,0,0,1-.29-1.37v-1.25a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.6-.17.8.08a2.26,2.26,0,0,1,.29,1.37Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.11-.17-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.43,3.43,0,0,0-.16,1.11v1.54a2,2,0,0,0,.16.94.31.31,0,0,0,.47.08,1.1,1.1,0,0,0,.46-.61,3.3,3.3,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,278.53l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.52-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.18,285.91l.53-.4v-3.93l-.54.32v-.44l1-.91v4.69l.52-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,290.72a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.34.19-.6.17-.8-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.3,2.3,0,0,1,.29,1.37Zm-.46-1.13a1.81,1.81,0,0,0-.16-.93c-.11-.17-.26-.2-.47-.08a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a2,2,0,0,0,.16.94.32.32,0,0,0,.47.08,1.12,1.12,0,0,0,.46-.62,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M297.72,192.7l.53-.41v-3.93l-.54.32v-.44l1-.91V192l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,197.5a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.57,4.57,0,0,1,.28-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.47-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72,207.47l.53-.41v-3.93l-.54.32V203l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,212.27a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.57,4.57,0,0,1,.28-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.47-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.28,3.28,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.1,1.1,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72,222.24l.53-.41V217.9l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72,229.62l.53-.4v-3.94l-.54.33v-.45l1-.9V229l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72,237l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,241.81a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.57,4.57,0,0,1,.28-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.47-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72,251.78l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,256.58a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.57,4.57,0,0,1,.28-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.47-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.28,3.28,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.1,1.1,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.72,266.55l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.52,271.35a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.57,4.57,0,0,1,.28-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.47-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.1,1.1,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,194a4.48,4.48,0,0,1-.28,1.7,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.27,2.27,0,0,1-.3-1.37V194a4.54,4.54,0,0,1,.29-1.7,1.92,1.92,0,0,1,.8-1c.33-.19.6-.17.79.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.46-.07a1.07,1.07,0,0,0-.47.61,3.48,3.48,0,0,0-.15,1.12v1.54a1.86,1.86,0,0,0,.16.93c.1.17.26.2.46.08a1.07,1.07,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,204l.53-.4v-3.94L291,200v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,211.35l.53-.41V207l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,218.73l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,223.54a4.48,4.48,0,0,1-.28,1.7,2,2,0,0,1-.8,1c-.33.19-.6.17-.79-.08a2.27,2.27,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,1.92,1.92,0,0,1,.8-1c.33-.19.6-.17.79.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.46-.07a1.07,1.07,0,0,0-.47.61,3.48,3.48,0,0,0-.15,1.12v1.54a1.86,1.86,0,0,0,.16.93c.1.17.26.2.46.08a1.07,1.07,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,230.92a4.57,4.57,0,0,1-.28,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.19-.46-.08a1.11,1.11,0,0,0-.47.61,3.57,3.57,0,0,0-.15,1.12v1.54a1.88,1.88,0,0,0,.16.94c.1.17.26.19.46.08a1.1,1.1,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,240.89l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,245.69a4.57,4.57,0,0,1-.28,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37V245.7a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.19-.46-.08a1.11,1.11,0,0,0-.47.61,3.57,3.57,0,0,0-.15,1.12v1.54a1.88,1.88,0,0,0,.16.94c.1.17.26.19.46.08a1.1,1.1,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,255.66l.53-.41v-3.93l-.54.32v-.44l1-.91V255l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,260.46a4.57,4.57,0,0,1-.28,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.19-.46-.08a1.11,1.11,0,0,0-.47.61,3.57,3.57,0,0,0-.15,1.12v1.54a1.88,1.88,0,0,0,.16.94c.1.17.26.2.46.08a1.1,1.1,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291,270.43l.53-.41v-3.93l-.54.32V266l1-.91v4.7l.53-.21V270l-1.52.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.79,275.23a4.57,4.57,0,0,1-.28,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.11,1.11,0,0,0-.47.61,3.57,3.57,0,0,0-.15,1.12v1.54a1.88,1.88,0,0,0,.16.94c.1.17.26.19.46.08a1.1,1.1,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,200.46l.53-.41v-3.93l-.54.32V196l1-.91v4.7l.53-.21V200l-1.52.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,207.84l.53-.4V203.5l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,212.65a4.28,4.28,0,0,1-.29,1.7,1.94,1.94,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.27,2.27,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.61-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.06,1.06,0,0,0,.46-.61,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,222.61l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,227.42a4.28,4.28,0,0,1-.29,1.7,1.9,1.9,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.27,2.27,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.61-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.47-.07a1.11,1.11,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.06,1.06,0,0,0,.46-.61,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,234.8a4.37,4.37,0,0,1-.29,1.71,1.88,1.88,0,0,1-.79,1c-.33.2-.6.17-.79-.07a2.3,2.3,0,0,1-.3-1.38v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.07a2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.19-.47-.08a1.14,1.14,0,0,0-.46.61,3.54,3.54,0,0,0-.16,1.12v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.09,1.09,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,244.77l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,249.57a4.37,4.37,0,0,1-.29,1.71,1.88,1.88,0,0,1-.79,1c-.33.2-.6.17-.79-.07a2.3,2.3,0,0,1-.3-1.38v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.07a2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.19-.47-.08a1.14,1.14,0,0,0-.46.61,3.54,3.54,0,0,0-.16,1.12v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.19.46.08a1.09,1.09,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,257a4.37,4.37,0,0,1-.29,1.71,1.92,1.92,0,0,1-.79,1c-.33.19-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37V257a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.61-.17.8.08a2.28,2.28,0,0,1,.29,1.37Zm-.46-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.47-.07a1.14,1.14,0,0,0-.46.61,3.46,3.46,0,0,0-.16,1.12v1.54a1.83,1.83,0,0,0,.17.93c.1.17.26.2.46.08a1.06,1.06,0,0,0,.46-.61,3.24,3.24,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,266.92l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.28,274.31l.53-.41V270l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.07,279.11a4.37,4.37,0,0,1-.29,1.71,1.88,1.88,0,0,1-.79,1c-.33.2-.6.17-.79-.07a2.3,2.3,0,0,1-.3-1.38v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.2.61-.17.8.07a2.32,2.32,0,0,1,.29,1.38Zm-.46-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.19-.47-.08a1.14,1.14,0,0,0-.46.61,3.54,3.54,0,0,0-.16,1.12v1.54a1.85,1.85,0,0,0,.17.94c.1.17.26.2.46.08a1.09,1.09,0,0,0,.46-.62,3.2,3.2,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.83,181.09l.52-.4v-3.94l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.62,185.89a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37V185.9a4.4,4.4,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12V187a1.88,1.88,0,0,0,.16.94c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.52,3.52,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,195.86l.52-.4v-3.94l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.62,200.66a4.52,4.52,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.44,4.44,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.52,3.52,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,210.63l.52-.4v-3.94l-.53.33v-.45l1-.91V210l.53-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,218l.52-.41v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,225.4l.52-.4v-3.94l-.53.33v-.45l1-.91v4.7l.53-.2V225l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.62,230.2a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.44,4.44,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.52,3.52,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,240.17l.52-.4v-3.94l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.62,245a4.52,4.52,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37V245a4.44,4.44,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.12a2,2,0,0,0-.16-.94c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.52,3.52,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.83,254.94l.52-.4V250.6l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.62,259.74a4.52,4.52,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.44,4.44,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.52,3.52,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,182.39a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37V182.4a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.46-1.13a1.81,1.81,0,0,0-.17-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,192.36l.53-.41V188l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.52.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,199.74l.53-.4V195.4l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,207.13l.53-.41v-3.93l-.53.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,211.93a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.46-1.13a1.83,1.83,0,0,0-.17-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,219.31a4.49,4.49,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.44,4.44,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.12a1.85,1.85,0,0,0-.17-.94c-.1-.17-.26-.19-.46-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.5,3.5,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,229.28l.53-.4v-3.94l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,234.08a4.52,4.52,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.44,4.44,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.17-.93c-.1-.17-.26-.19-.46-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.52,3.52,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,244.05l.53-.4v-3.94l-.53.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,248.85a4.49,4.49,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.44,4.44,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.12a1.85,1.85,0,0,0-.17-.94c-.1-.17-.26-.19-.46-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12V250a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.5,3.5,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.1,258.82l.53-.4v-3.94l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.9,263.62a4.52,4.52,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.44,4.44,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a1.83,1.83,0,0,0-.17-.93c-.1-.17-.26-.19-.46-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.52,3.52,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38,188.85l.53-.4v-3.94l-.54.33v-.45l1-.91v4.7l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38,196.24l.53-.41V191.9l-.54.32v-.44l1-.91v4.69l.53-.2v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,201a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.47-1.13a1.83,1.83,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38,211l.53-.41v-3.93l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,215.81a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.47-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,223.19a4.49,4.49,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.27,2.27,0,0,1-.3-1.37V223.2a4.63,4.63,0,0,1,.29-1.71,1.94,1.94,0,0,1,.8-1c.33-.19.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.47-1.12a1.88,1.88,0,0,0-.16-.94c-.1-.17-.26-.19-.46-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38,233.16l.53-.4v-3.94l-.54.33v-.45l1-.9v4.69l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,238a4.49,4.49,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.27,2.27,0,0,1-.3-1.37V238a4.63,4.63,0,0,1,.29-1.71,1.94,1.94,0,0,1,.8-1c.33-.19.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.47-1.12a1.88,1.88,0,0,0-.16-.94c-.1-.17-.26-.19-.46-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,245.35a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.25,2.25,0,0,1-.3-1.37v-1.24a4.56,4.56,0,0,1,.29-1.71,2,2,0,0,1,.8-1,.56.56,0,0,1,.79.08,2.3,2.3,0,0,1,.3,1.38Zm-.47-1.13a1.86,1.86,0,0,0-.16-.93c-.1-.17-.26-.2-.46-.08a1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.48,3.48,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38,255.32l.53-.41V251l-.54.32v-.44l1-.91v4.7l.53-.21v.46l-1.52.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.38,262.7l.53-.4v-3.94l-.54.33v-.45l1-.9V262l.53-.2v.45l-1.52.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.18,267.51a4.47,4.47,0,0,1-.29,1.7,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.27,2.27,0,0,1-.3-1.37v-1.25a4.54,4.54,0,0,1,.29-1.7,1.92,1.92,0,0,1,.8-1c.33-.19.6-.17.79.08a2.27,2.27,0,0,1,.3,1.37Zm-.47-1.13a1.88,1.88,0,0,0-.16-.94c-.1-.16-.26-.19-.46-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.53,3.53,0,0,0,.15-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M337.93,169.48l.52-.4v-3.93l-.53.32V165l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.72,174.29a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.59.17-.79-.08a2.33,2.33,0,0,1-.29-1.37V174.3a4.37,4.37,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94.31.31,0,0,0,.46.08,1.14,1.14,0,0,0,.47-.62,3.5,3.5,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.93,184.25l.52-.4v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.72,189.06a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.59.17-.79-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.93,199l.52-.4v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.93,206.41l.52-.41v-3.93l-.53.33V202l1-.91v4.7l.53-.2V206l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.93,213.79l.52-.4v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.72,218.6a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.59.17-.79-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.93,228.56l.52-.4v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.72,233.37a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.59.17-.79-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,2,2,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61A3.24,3.24,0,0,0,338,233v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.93,243.33l.52-.4V239l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.72,248.14a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.59.17-.79-.08a2.33,2.33,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,2,2,0,0,1,.79-1c.34-.19.6-.17.8.08a2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,170.78a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.3,2.3,0,0,1-.29-1.37v-1.25a4.37,4.37,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1,.55.55,0,0,1,.8.08,2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.57,3.57,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,180.75l.52-.41v-3.93l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,188.13l.52-.4V183.8l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,195.52l.52-.4v-3.94l-.53.33v-.45l1-.91v4.7l.53-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,200.32a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.37,4.37,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1,.55.55,0,0,1,.8.08,2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.57,3.57,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,207.71a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.56.56,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,217.68l.52-.41v-3.93l-.53.32v-.44l1-.91V217l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,222.48a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.56.56,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,232.45l.52-.41v-3.93l-.53.32V228l1-.91v4.69l.53-.2V232l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,237.25a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.57.57,0,0,1,.8.08A2.38,2.38,0,0,1,333,236Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.21,247.22l.52-.41v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333,252a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37V252a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.57.57,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,177.24l.52-.4v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,184.63l.52-.4v-3.94l-.53.33v-.45l1-.91V184l.53-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,189.43a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.3,2.3,0,0,1-.29-1.37v-1.25a4.37,4.37,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.57,3.57,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,199.4l.52-.4v-3.94l-.53.33v-.45l1-.91v4.7l.53-.2V199l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,204.2a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.4,4.4,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.57,3.57,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,211.59a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37V211.6a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.56.56,0,0,1,.79.08,2.29,2.29,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,221.56l.52-.41v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,226.36a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1c.33-.19.6-.17.79.08a2.29,2.29,0,0,1,.3,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,233.74a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.28,2.28,0,0,1-.29-1.37v-1.25a4.4,4.4,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1c.33-.2.6-.17.79.08a2.25,2.25,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.86,1.86,0,0,0,.16.93c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.52,3.52,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,243.71l.52-.4v-3.94l-.53.33v-.45l1-.91V243l.53-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.49,251.1l.52-.41v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.28,255.9a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.2-.6.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.56.56,0,0,1,.79.08,2.29,2.29,0,0,1,.3,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12V257a1.9,1.9,0,0,0,.16.94c.11.17.26.19.46.08a1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--binary--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.59,165.64l.52-.41V161.3l-.53.32v-.44l1-.91V165l.53-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,173l.52-.4v-3.94l-.53.33v-.44l1-.91v4.69l.53-.2v.45l-1.51.88Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,177.83a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.59.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.9,1.9,0,0,1,.79-1,.56.56,0,0,1,.8.08,2.36,2.36,0,0,1,.29,1.37Zm-.46-1.13a2,2,0,0,0-.16-.94.31.31,0,0,0-.47-.07,1.1,1.1,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12V179a1.86,1.86,0,0,0,.16.93.31.31,0,0,0,.46.09,1.14,1.14,0,0,0,.47-.62,3.5,3.5,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,187.79l.52-.4v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,192.6a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.59.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.9,1.9,0,0,1,.79-1,.56.56,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.2,3.2,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94.31.31,0,0,0,.46.08,1.14,1.14,0,0,0,.47-.62,3.5,3.5,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,200a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.3,2.3,0,0,1-.29-1.37V200a4.37,4.37,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1,.55.55,0,0,1,.8.08,2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.57,3.57,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,210l.52-.41v-3.93l-.53.32v-.44l1-.91v4.7l.53-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,214.75a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.3,2.3,0,0,1-.29-1.37v-1.25a4.37,4.37,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1,.55.55,0,0,1,.8.08,2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.57,3.57,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,222.14a4.56,4.56,0,0,1-.29,1.71,1.94,1.94,0,0,1-.8,1c-.33.19-.59.17-.79-.08a2.26,2.26,0,0,1-.29-1.37v-1.24a4.37,4.37,0,0,1,.29-1.71,1.94,1.94,0,0,1,.79-1,.56.56,0,0,1,.8.08,2.38,2.38,0,0,1,.29,1.37Zm-.46-1.13a1.92,1.92,0,0,0-.16-.93.31.31,0,0,0-.47-.08,1.1,1.1,0,0,0-.46.61,3.24,3.24,0,0,0-.16,1.12v1.54a1.9,1.9,0,0,0,.16.94.31.31,0,0,0,.46.08,1.14,1.14,0,0,0,.47-.62,3.46,3.46,0,0,0,.16-1.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,232.1l.52-.4v-3.93l-.53.32v-.44l1-.91v4.69l.53-.2v.46l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.59,239.49l.52-.41v-3.93l-.53.32V235l1-.91v4.7l.53-.2v.45l-1.51.87Z",
    style: {
      fill: "#35885D",
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.38,244.29a4.56,4.56,0,0,1-.29,1.71,2,2,0,0,1-.8,1,.56.56,0,0,1-.79-.08,2.3,2.3,0,0,1-.29-1.37V244.3a4.37,4.37,0,0,1,.29-1.71,1.88,1.88,0,0,1,.79-1,.55.55,0,0,1,.8.08,2.33,2.33,0,0,1,.29,1.37Zm-.46-1.13a2,2,0,0,0-.16-.93c-.11-.17-.27-.19-.47-.07a1.06,1.06,0,0,0-.46.61,3.18,3.18,0,0,0-.16,1.11v1.54a1.88,1.88,0,0,0,.16.94c.11.17.26.2.46.08a1.11,1.11,0,0,0,.47-.61,3.57,3.57,0,0,0,.16-1.13Z",
    style: {
      fill: "#35885D",
      opacity: 0.30000000000000004
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Windows--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--flowchart-window--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.93,271a1.29,1.29,0,0,0,.65-.2l171.28-99a5.42,5.42,0,0,0,2.43-4.19V38.19c0-.91-.38-1.45-1-1.45a2,2,0,0,0-1,.3L62,136a5.44,5.44,0,0,0-2.43,4.2V268.94a2.65,2.65,0,0,0,.42,1.48A1.16,1.16,0,0,0,60.93,271Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.88,269.32c.29.15,2.35,1.32,3.25,1.84a2.69,2.69,0,0,1-1-2.23V148.83l-3.39-2V267A2.59,2.59,0,0,0,56.88,269.32Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Outline--inject-30",
    d: "M234.27,37.19c.5,0,.57.62.57,1V167.6a5,5,0,0,1-2.2,3.81l-171.28,99a.88.88,0,0,1-.43.13c-.47,0-.88-.73-.88-1.57V140.17a4.93,4.93,0,0,1,2.2-3.81L233.53,37.43a1.5,1.5,0,0,1,.74-.24m0-.89a2.32,2.32,0,0,0-1.18.36L61.8,135.58a5.86,5.86,0,0,0-2.64,4.59V268.94c0,1.33.74,2.47,1.77,2.47a1.73,1.73,0,0,0,.88-.26l171.27-99a5.83,5.83,0,0,0,2.66-4.58V38.19c0-1.2-.6-1.89-1.47-1.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--up-bar--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.73,38.13V47l-176.57,102-3.39-2v-8.72a5.53,5.53,0,0,1,.8-2.65,5.37,5.37,0,0,1,1.85-1.93L229.7,34.74a1.88,1.88,0,0,1,1.93-.16c.49.3,2.81,1.62,3.28,1.86a.72.72,0,0,1,.2.14,1,1,0,0,1,.21.21,1.24,1.24,0,0,1,.17.27,1,1,0,0,1,.13.32,1.9,1.9,0,0,1,.08.36v0A2.22,2.22,0,0,1,235.73,38.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73,38.13V47l-176.57,102-3.39-2v-8.72a5.53,5.53,0,0,1,.8-2.65,5.37,5.37,0,0,1,1.85-1.93L229.7,34.74a1.88,1.88,0,0,1,1.93-.16c.49.3,2.81,1.62,3.28,1.86a.72.72,0,0,1,.2.14,1,1,0,0,1,.21.21,1.24,1.24,0,0,1,.17.27,1,1,0,0,1,.13.32,1.9,1.9,0,0,1,.08.36v0A2.22,2.22,0,0,1,235.73,38.13Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.73,38.13V47l-176.57,102v-8.76a4.73,4.73,0,0,1,.32-1.65,1.92,1.92,0,0,1,.11-.27,6,6,0,0,1,.36-.72,5.3,5.3,0,0,1,1.86-1.95L233.08,36.66a1.76,1.76,0,0,1,2-.08,1,1,0,0,1,.21.21,1.24,1.24,0,0,1,.17.27,1,1,0,0,1,.13.32,1.9,1.9,0,0,1,.08.36v0A2.22,2.22,0,0,1,235.73,38.13Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,48.76a4.37,4.37,0,0,0-1.65,3.5c0,1.41.74,2.12,1.65,1.59a4.37,4.37,0,0,0,1.65-3.5C219.6,49,218.86,48.23,218,48.76Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.9,45.32a4.35,4.35,0,0,0-1.65,3.5c0,1.4.74,2.12,1.65,1.59a4.36,4.36,0,0,0,1.66-3.5C225.56,45.5,224.82,44.79,223.9,45.32Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.86,41.87a4.36,4.36,0,0,0-1.66,3.5c0,1.41.74,2.12,1.66,1.6a4.38,4.38,0,0,0,1.65-3.5C231.51,42.06,230.77,41.35,229.86,41.87Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.09,36.66,61.81,135.58a5.46,5.46,0,0,0-1.87,2l-3.36-2a5.22,5.22,0,0,1,1.84-1.94L229.7,34.74a1.88,1.88,0,0,1,1.93-.16c.47.29,2.67,1.54,3.23,1.84A1.93,1.93,0,0,0,233.09,36.66Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.09,36.66,61.81,135.58a5.46,5.46,0,0,0-1.87,2l-3.36-2a5.22,5.22,0,0,1,1.84-1.94L229.7,34.74a1.88,1.88,0,0,1,1.93-.16c.47.29,2.67,1.54,3.23,1.84A1.93,1.93,0,0,0,233.09,36.66Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flowchart--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102,153.24a.24.24,0,0,1-.24-.24V142.91a.24.24,0,0,1,.24-.24.23.23,0,0,1,.23.24V153A.23.23,0,0,1,102,153.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.15 152.05 101.96 152.86 102.76 152.05 102.76 152.74 101.96 153.54 101.15 152.74 101.15 152.05",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53,154.34a.22.22,0,0,1-.21-.12.23.23,0,0,1,.09-.32l6.64-3.84a.24.24,0,0,1,.33.09.24.24,0,0,1-.09.32l-6.65,3.84A.2.2,0,0,1,110.53,154.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.75 151.44 117.05 150.34 115.95 150.04 116.54 149.7 117.64 149.99 117.35 151.09 116.75 151.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.3,207.35a.22.22,0,0,1-.21-.12.23.23,0,0,1,.09-.32l6.64-3.84a.25.25,0,0,1,.33.09.26.26,0,0,1-.09.33l-6.65,3.83A.2.2,0,0,1,109.3,207.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "115.52 204.45 115.82 203.35 114.72 203.06 115.31 202.71 116.41 203.01 116.12 204.11 115.52 204.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.41,193.43a.22.22,0,0,1-.2-.12.22.22,0,0,1,.09-.32l6.64-3.84a.22.22,0,0,1,.32.09.23.23,0,0,1-.08.32l-6.65,3.84A.24.24,0,0,1,133.41,193.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.64 190.53 139.94 189.43 138.84 189.13 139.43 188.79 140.53 189.08 140.23 190.18 139.64 190.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135,140.23a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l6.65-3.84a.23.23,0,0,1,.32.09.23.23,0,0,1-.08.32l-6.65,3.84A.27.27,0,0,1,135,140.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "141.19 137.33 141.49 136.23 140.39 135.93 140.98 135.59 142.08 135.88 141.78 136.99 141.19 137.33",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.53,166.89a.24.24,0,0,1-.21-.11.24.24,0,0,1,.09-.33l6.64-3.84a.24.24,0,0,1,.24.42l-6.65,3.83A.2.2,0,0,1,134.53,166.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.94 165.49 134.65 166.59 135.75 166.88 135.16 167.22 134.06 166.93 134.35 165.83 134.94 165.49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.1,216.47a.22.22,0,0,1-.2-.12A.22.22,0,0,1,134,216l6.2-3.59a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-6.21,3.59A.27.27,0,0,1,134.1,216.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.52 215.06 134.22 216.16 135.32 216.46 134.73 216.8 133.63 216.5 133.93 215.4 134.52 215.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.64,180.68a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l6.65-3.84a.24.24,0,0,1,.32.09.24.24,0,0,1-.09.33l-6.64,3.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "111.06 179.28 110.76 180.38 111.86 180.67 111.27 181.01 110.17 180.72 110.47 179.62 111.06 179.28",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.44,149.24a.24.24,0,0,1-.24-.24v-7.69a.24.24,0,0,1,.48,0V149A.24.24,0,0,1,148.44,149.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.64 148.06 148.44 148.86 149.25 148.06 149.25 148.74 148.44 149.54 147.64 148.74 147.64 148.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,198.38a.21.21,0,0,1-.12,0,.22.22,0,0,1-.12-.2v-5.66a.24.24,0,0,1,.24-.24.23.23,0,0,1,.23.24v5.24l46-26.56v-3.52a.24.24,0,0,1,.48,0v3.66a.24.24,0,0,1-.12.2l-46.49,26.84A.2.2,0,0,1,102,198.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.76 193.43 101.96 192.63 101.15 193.43 101.15 192.75 101.96 191.94 102.76 192.75 102.76 193.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,224.63a.21.21,0,0,1-.12,0,.22.22,0,0,1-.12-.21v-3.65a.24.24,0,0,1,.24-.24.23.23,0,0,1,.23.24V224l46-26.56V191.9a.24.24,0,0,1,.48,0v5.66a.24.24,0,0,1-.12.2L102.07,224.6A.2.2,0,0,1,102,224.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.25 192.84 148.44 192.04 147.64 192.84 147.64 192.16 148.44 191.36 149.25 192.16 149.25 192.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.32,217.73a.27.27,0,0,1-.12,0,.24.24,0,0,1-.12-.21V191.6a.24.24,0,0,1,.12-.2l2.52-1.46A.24.24,0,0,1,94,190a.24.24,0,0,1-.09.33l-2.39,1.38v25.34l2.64-1.52a.24.24,0,1,1,.23.41l-3,1.73A.27.27,0,0,1,91.32,217.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.9 216.94 94.19 215.84 93.09 215.54 93.69 215.2 94.78 215.5 94.49 216.59 93.9 216.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.45,203a.22.22,0,0,1-.2-.12.24.24,0,0,1,.09-.33l2.5-1.44V178.21l-2.16,1.24a.23.23,0,0,1-.32-.08.24.24,0,0,1,.08-.33l2.52-1.45a.25.25,0,0,1,.24,0,.24.24,0,0,1,.11.21v23.44a.23.23,0,0,1-.11.2L157.57,203A.24.24,0,0,1,157.45,203Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.87 201.58 157.58 202.68 158.68 202.97 158.08 203.32 156.98 203.02 157.28 201.92 157.87 201.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.13,132.51c0,2.69-3.21,6.72-7.17,9s-7.18,2-7.18-.73,3.21-6.72,7.18-9S109.13,129.82,109.13,132.51Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 125.5,
    cy: 221.2,
    rx: 8.73,
    ry: 3.99,
    transform: "translate(-112.71 132.14) rotate(-39.93)",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,159.59l-13.07,7.54c-.39.22-.7,0-.7-.54v-6.73a1.69,1.69,0,0,1,.7-1.35L108.49,151c.39-.22.7,0,.7.54v6.72A1.7,1.7,0,0,1,108.49,159.59Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,159.59l-13.07,7.54c-.39.22-.7,0-.7-.54v-6.73a1.69,1.69,0,0,1,.7-1.35L108.49,151c.39-.22.7,0,.7.54v6.72A1.7,1.7,0,0,1,108.49,159.59Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,146,119,153.53c-.39.23-.71,0-.71-.53v-6.73a1.69,1.69,0,0,1,.71-1.35L132,137.38c.39-.23.71,0,.71.53v6.73A1.69,1.69,0,0,1,132,146Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,146,119,153.53c-.39.23-.71,0-.71-.53v-6.73a1.69,1.69,0,0,1,.71-1.35L132,137.38c.39-.23.71,0,.71.53v6.73A1.69,1.69,0,0,1,132,146Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,172.4,119,179.94c-.39.23-.71,0-.71-.53v-6.73a1.7,1.7,0,0,1,.71-1.35L132,163.79c.39-.23.71,0,.71.53v6.73A1.69,1.69,0,0,1,132,172.4Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,172.4,119,179.94c-.39.23-.71,0-.71-.53v-6.73a1.7,1.7,0,0,1,.71-1.35L132,163.79c.39-.23.71,0,.71.53v6.73A1.69,1.69,0,0,1,132,172.4Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,198.3,119,205.84c-.39.22-.71,0-.71-.54v-6.73a1.7,1.7,0,0,1,.71-1.35L132,189.68c.39-.22.71,0,.71.54v6.72A1.71,1.71,0,0,1,132,198.3Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,198.3,119,205.84c-.39.22-.71,0-.71-.54v-6.73a1.7,1.7,0,0,1,.71-1.35L132,189.68c.39-.22.71,0,.71.54v6.72A1.71,1.71,0,0,1,132,198.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,185.05l-13.06,7.54c-.39.23-.71,0-.71-.53v-6.73a1.7,1.7,0,0,1,.71-1.35L155,176.44c.39-.23.71,0,.71.53v6.73A1.69,1.69,0,0,1,155,185.05Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,185.05l-13.06,7.54c-.39.23-.71,0-.71-.53v-6.73a1.7,1.7,0,0,1,.71-1.35L155,176.44c.39-.23.71,0,.71.53v6.73A1.69,1.69,0,0,1,155,185.05Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,208.49,141.91,216c-.39.23-.71,0-.71-.53v-6.73a1.69,1.69,0,0,1,.71-1.35L155,199.88c.39-.23.71,0,.71.53v6.73A1.7,1.7,0,0,1,155,208.49Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155,208.49,141.91,216c-.39.23-.71,0-.71-.53v-6.73a1.69,1.69,0,0,1,.71-1.35L155,199.88c.39-.23.71,0,.71.53v6.73A1.7,1.7,0,0,1,155,208.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,186l-13.07,7.54c-.39.23-.7,0-.7-.54v-6.72a1.71,1.71,0,0,1,.7-1.36l13.07-7.54c.39-.22.7,0,.7.54v6.73A1.69,1.69,0,0,1,108.49,186Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,186l-13.07,7.54c-.39.23-.7,0-.7-.54v-6.72a1.71,1.71,0,0,1,.7-1.36l13.07-7.54c.39-.22.7,0,.7.54v6.73A1.69,1.69,0,0,1,108.49,186Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.78,139.27l-5.52-7.71a2.12,2.12,0,0,1,.66-2.47l11-6.37c.7-.41,1.09.6.66,1.7l-5.52,14.09C148.77,139.37,148.12,139.74,147.78,139.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.06,156.41l-5.12,8.83c-.3.51-.7.75-1,.58l-5.12-2.92c-.45-.26-.45-1.29,0-2.07l5.12-8.82c.3-.51.7-.75,1-.58l5.12,2.92C154.51,154.6,154.51,155.64,154.06,156.41Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.57,209.14,102.46,218c-.3.51-.71.75-1,.58l-5.12-2.92c-.45-.25-.45-1.29,0-2.07l5.12-8.82c.29-.51.7-.75,1-.58l5.11,2.92C108,207.33,108,208.37,107.57,209.14Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,178a.26.26,0,0,1-.21-.11.25.25,0,0,1,.09-.33l15.42-8.9a.24.24,0,0,1,.33.08.25.25,0,0,1-.09.33L82.71,178A.27.27,0,0,1,82.59,178Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,180.28a.25.25,0,0,1-.21-.12.24.24,0,0,1,.09-.32l15.42-8.91a.25.25,0,0,1,.33.09.24.24,0,0,1-.09.32l-15.42,8.91A.27.27,0,0,1,82.59,180.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,182.52a.27.27,0,0,1-.21-.12.25.25,0,0,1,.09-.33l15.42-8.9a.24.24,0,0,1,.33.09.24.24,0,0,1-.09.32l-15.42,8.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.59,184.75a.26.26,0,0,1-.21-.11.25.25,0,0,1,.09-.33l15.42-8.9a.24.24,0,0,1,.33.08.25.25,0,0,1-.09.33l-15.42,8.9A.27.27,0,0,1,82.59,184.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,151.87a.22.22,0,0,1-.2-.12.24.24,0,0,1,.08-.33l15.43-8.9a.24.24,0,0,1,.23.41l-15.42,8.91A.27.27,0,0,1,75.81,151.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,154.1a.23.23,0,0,1-.2-.11.24.24,0,0,1,.08-.33l15.43-8.9a.23.23,0,0,1,.32.08.24.24,0,0,1-.09.33l-15.42,8.9A.27.27,0,0,1,75.81,154.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,156.34a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32L91.12,147a.24.24,0,0,1,.32.09.23.23,0,0,1-.09.32l-15.42,8.91A.27.27,0,0,1,75.81,156.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.81,158.58a.24.24,0,0,1-.12-.45l15.43-8.9a.23.23,0,0,1,.32.09.23.23,0,0,1-.09.32l-15.42,8.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,157.45a.24.24,0,0,1-.12-.45l15.43-8.9a.23.23,0,0,1,.32.09.23.23,0,0,1-.09.32l-15.42,8.9A.19.19,0,0,1,117.79,157.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,159.68a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l15.43-8.91a.24.24,0,0,1,.23.42l-15.42,8.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,161.92a.22.22,0,0,1-.2-.12.23.23,0,0,1,.08-.32l15.43-8.91a.24.24,0,0,1,.32.09.23.23,0,0,1-.09.32l-15.42,8.91A.27.27,0,0,1,117.79,161.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.79,164.16a.24.24,0,0,1-.12-.45l15.43-8.9a.23.23,0,0,1,.32.08.24.24,0,0,1-.09.33l-15.42,8.9A.19.19,0,0,1,117.79,164.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,119.2a.22.22,0,0,1-.2-.12.22.22,0,0,1,.09-.32l15.42-8.91a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-15.43,8.91A.24.24,0,0,1,140.1,119.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,121.44a.24.24,0,0,1-.2-.12A.24.24,0,0,1,140,121l15.42-8.9a.22.22,0,0,1,.32.09.23.23,0,0,1-.08.32l-15.43,8.9A.17.17,0,0,1,140.1,121.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,123.67a.22.22,0,0,1-.2-.12.23.23,0,0,1,.09-.32l15.42-8.9a.23.23,0,0,1,.32.08.24.24,0,0,1-.08.33l-15.43,8.9A.24.24,0,0,1,140.1,123.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,125.91a.22.22,0,0,1-.2-.12.22.22,0,0,1,.09-.32l15.42-8.91a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-15.43,8.91A.24.24,0,0,1,140.1,125.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,144.24a.22.22,0,0,1-.2-.12.22.22,0,0,1,.09-.32l15.42-8.91a.24.24,0,0,1,.24.42l-15.43,8.9A.24.24,0,0,1,154.39,144.24Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,146.48a.22.22,0,0,1-.2-.12.24.24,0,0,1,.09-.33l15.42-8.9a.22.22,0,0,1,.32.09.23.23,0,0,1-.08.32l-15.43,8.91A.24.24,0,0,1,154.39,146.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,148.71a.23.23,0,0,1-.2-.11.24.24,0,0,1,.09-.33l15.42-8.9a.23.23,0,0,1,.32.08.24.24,0,0,1-.08.33l-15.43,8.9A.24.24,0,0,1,154.39,148.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,151a.22.22,0,0,1-.2-.12.22.22,0,0,1,.09-.32l15.42-8.91a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-15.43,8.91A.24.24,0,0,1,154.39,151Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,166.48a.22.22,0,0,1-.2-.12.22.22,0,0,1,.09-.32l15.42-8.91a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-15.43,8.91A.24.24,0,0,1,154.39,166.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,168.72a.24.24,0,0,1-.2-.12.24.24,0,0,1,.09-.33l15.42-8.9a.22.22,0,0,1,.32.09.23.23,0,0,1-.08.32l-15.43,8.91A.24.24,0,0,1,154.39,168.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,171a.22.22,0,0,1-.2-.12.23.23,0,0,1,.09-.32l15.42-8.9a.23.23,0,0,1,.32.08.24.24,0,0,1-.08.33l-15.43,8.9A.24.24,0,0,1,154.39,171Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.39,173.19a.22.22,0,0,1-.2-.12.22.22,0,0,1,.09-.32l15.42-8.91a.24.24,0,0,1,.32.09.23.23,0,0,1-.08.32l-15.43,8.91A.24.24,0,0,1,154.39,173.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,228.53a.25.25,0,0,1-.21-.11.24.24,0,0,1,.09-.33l15.42-8.9a.24.24,0,0,1,.33.08.25.25,0,0,1-.09.33L82,228.5A.27.27,0,0,1,81.83,228.53Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,230.77a.24.24,0,0,1-.21-.12.23.23,0,0,1,.09-.32l15.42-8.91a.25.25,0,0,1,.33.09.24.24,0,0,1-.09.32L82,230.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,233a.26.26,0,0,1-.21-.12.24.24,0,0,1,.09-.33l15.42-8.9a.24.24,0,0,1,.33.09.24.24,0,0,1-.09.32L82,233A.27.27,0,0,1,81.83,233Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.83,235.24a.24.24,0,0,1-.12-.44l15.42-8.9a.24.24,0,0,1,.33.08.25.25,0,0,1-.09.33L82,235.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-window--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.3,62V183.89a6.45,6.45,0,0,1-2.93,5.07l-77.9,45a1.88,1.88,0,0,1-1,.28,1.57,1.57,0,0,1-.37,0,1.06,1.06,0,0,1-.25-.09l-.16-.08-.17-.12a1.07,1.07,0,0,1-.16-.14,2.37,2.37,0,0,1-.54-.77,3.69,3.69,0,0,1-.31-1.48V110.27a6.5,6.5,0,0,1,2.93-5.07l77.9-44.91a2.13,2.13,0,0,1,2-.25,1.65,1.65,0,0,1,.25.15A2.07,2.07,0,0,1,261.3,62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.67,60.9a.53.53,0,0,1,.27.06l.05,0s.31.26.31,1V183.89a5.44,5.44,0,0,1-2.43,4.2l-77.89,45a1,1,0,0,1-.47.15h0l-.17,0-.05,0h0l-.08-.06-.06,0h0l-.05-.05a1.54,1.54,0,0,1-.3-.44,2.69,2.69,0,0,1-.22-1.07V110.27a5.56,5.56,0,0,1,2.43-4.2l77.9-44.91a1.63,1.63,0,0,1,.8-.26m0-1a2.63,2.63,0,0,0-1.3.39l-77.9,44.91a6.5,6.5,0,0,0-2.93,5.07v121.2a3.69,3.69,0,0,0,.31,1.48,2.37,2.37,0,0,0,.54.77,1.07,1.07,0,0,0,.16.14l.17.12.16.08a1.06,1.06,0,0,0,.25.09,1.57,1.57,0,0,0,.37,0h0a1.94,1.94,0,0,0,.93-.28l77.9-45a6.45,6.45,0,0,0,2.93-5.07V62a2.07,2.07,0,0,0-.71-1.77,1.47,1.47,0,0,0-.92-.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.3,62V183.89a6.45,6.45,0,0,1-2.93,5.07l-77.9,45a1.88,1.88,0,0,1-1,.28,1.57,1.57,0,0,1-.37,0,1.06,1.06,0,0,1-.25-.09l-.16-.08-.17-.12a1.07,1.07,0,0,1-.16-.14,2.37,2.37,0,0,1-.54-.77,3.69,3.69,0,0,1-.31-1.48V110.27a6.5,6.5,0,0,1,2.93-5.07l77.9-44.91a2.13,2.13,0,0,1,2-.25,1.65,1.65,0,0,1,.25.15A2.07,2.07,0,0,1,261.3,62Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M260.34,60a2.13,2.13,0,0,0-2,.25l-77.9,44.91a6.5,6.5,0,0,0-2.93,5.07v9.57l-3.73-2.19v-9.5a6.44,6.44,0,0,1,2.92-5.06l77.91-44.91a2,2,0,0,1,2.12-.17C257.29,58.32,259.72,59.72,260.34,60Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.3,62c0-1.85-1.32-2.59-2.93-1.66l-77.9,44.91a6.47,6.47,0,0,0-2.92,5.06v9.57L261.3,71.57Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.37,60.29l-77.9,44.91a6.1,6.1,0,0,0-2.06,2.18l-3.71-2.16a5.79,5.79,0,0,1,2-2.13l77.9-44.91a2.07,2.07,0,0,1,2.13-.18c.52.33,2.95,1.71,3.57,2A2.11,2.11,0,0,0,258.37,60.29Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M173.8,117.66v-9.51a6,6,0,0,1,.9-2.93l3.72,2.15a5.94,5.94,0,0,0-.87,2.91v9.56Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.67,72.86a4.35,4.35,0,0,0-1.65,3.5c0,1.4.74,2.12,1.65,1.59a4.38,4.38,0,0,0,1.65-3.5C245.32,73,244.58,72.33,243.67,72.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.62,69.41a4.38,4.38,0,0,0-1.65,3.5c0,1.41.74,2.12,1.65,1.6a4.36,4.36,0,0,0,1.66-3.5C251.28,69.6,250.54,68.89,249.62,69.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.57,66a4.38,4.38,0,0,0-1.65,3.5c0,1.41.74,2.12,1.65,1.59a4.33,4.33,0,0,0,1.66-3.5C257.23,66.16,256.49,65.44,255.57,66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.62,233.93l-.37-.21a10.32,10.32,0,0,0-.9-.51h0l-.49-.28,0,0-.76-.44-.65-.37-.36-.2a1.48,1.48,0,0,1-.5-.4,2.17,2.17,0,0,1-.4-.6,3.63,3.63,0,0,1-.33-1.54V117.65l3.73,2.19V231.47a4.45,4.45,0,0,0,.31,1.48,2.37,2.37,0,0,0,.54.77.44.44,0,0,0,.16.14Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.87,123.9a.89.89,0,0,1,.11-.4l1.56-3.24a.25.25,0,0,1,.07-.09l0,0a.09.09,0,0,1,.13,0,.21.21,0,0,1,.05.15v1.09a1.58,1.58,0,0,1,0,.34c0,.08-.06.18-.11.29l-.83,1.71.83.76a.62.62,0,0,1,.11.17,1.05,1.05,0,0,1,0,.3V126a.59.59,0,0,1-.05.22.39.39,0,0,1-.13.15l0,0s0,0-.07,0L185,125a.31.31,0,0,1-.11-.27Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.59,115.79a1.52,1.52,0,0,1,.11-.32.59.59,0,0,1,.23-.24l.59-.34s.09,0,.12,0a.17.17,0,0,1,.05.15.49.49,0,0,1,0,.12L189,126.59a1.45,1.45,0,0,1-.11.31.55.55,0,0,1-.24.26l-.56.33a.1.1,0,0,1-.12,0,.21.21,0,0,1-.06-.16.74.74,0,0,1,0-.12Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.73,119a.93.93,0,0,1-.11.41l-1.56,3.23-.07.1s0,0,0,0a.12.12,0,0,1-.13,0,.23.23,0,0,1,0-.16v-1.09a1.42,1.42,0,0,1,0-.33,1.7,1.7,0,0,1,.12-.3l.82-1.71-.82-.75a.59.59,0,0,1-.12-.17,1.05,1.05,0,0,1,0-.3v-1.09a.63.63,0,0,1,0-.22.39.39,0,0,1,.13-.15h0a.06.06,0,0,1,.07,0l1.56,1.43a.33.33,0,0,1,.11.28Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.07,118.26a.13.13,0,0,1,.16,0,.28.28,0,0,1,.06.2v1.19a.66.66,0,0,1-.06.27.52.52,0,0,1-.16.19l-.73.42a.11.11,0,0,1-.15,0,.22.22,0,0,1-.07-.19v-1.2a.54.54,0,0,1,.07-.27.35.35,0,0,1,.15-.18Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.54,116.84a.12.12,0,0,1,.15,0,.28.28,0,0,1,.06.2v1.19a.66.66,0,0,1-.06.27.35.35,0,0,1-.15.18l-.74.43a.12.12,0,0,1-.15,0,.28.28,0,0,1-.06-.2v-1.19a.66.66,0,0,1,.06-.27.42.42,0,0,1,.15-.19Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204,115.42a.12.12,0,0,1,.16,0,.25.25,0,0,1,.06.19v1.2a.66.66,0,0,1-.06.27.41.41,0,0,1-.16.18l-.73.43a.12.12,0,0,1-.15,0,.24.24,0,0,1-.07-.2V116.3a.54.54,0,0,1,.07-.27.42.42,0,0,1,.15-.19Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,132.62,236,103.5c.42-.24.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28l-50.44,29.12c-.43.25-.77.08-.77-.39A1.65,1.65,0,0,1,185.53,132.62Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,146l50.44-29.12c.42-.24.77-.07.77.39a1.68,1.68,0,0,1-.77,1.29l-50.44,29.12c-.43.24-.77.07-.77-.39A1.65,1.65,0,0,1,197.12,146Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,152.7l31.6-18.24c.43-.25.77-.08.77.39a1.65,1.65,0,0,1-.77,1.28l-31.6,18.24c-.43.24-.77.07-.77-.39A1.63,1.63,0,0,1,197.12,152.7Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,159.39l31.6-18.24c.43-.25.77-.07.77.39a1.65,1.65,0,0,1-.77,1.28l-31.6,18.24c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,197.12,159.39Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,101.77l14.39-8.34c.43-.24.77-.07.77.39a1.65,1.65,0,0,1-.77,1.29L239,103.45c-.43.24-.77.07-.77-.39A1.65,1.65,0,0,1,239,101.77Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,199.11l38-22c.42-.25.77-.07.77.39a1.68,1.68,0,0,1-.77,1.28l-38,22c-.43.24-.77.07-.77-.39A1.67,1.67,0,0,1,198,199.11Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239,175.37,253.35,167c.43-.25.77-.07.77.39a1.63,1.63,0,0,1-.77,1.28L239,177c-.43.25-.77.07-.77-.39A1.65,1.65,0,0,1,239,175.37Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.45,175.19l48.9-28.2c.43-.24.77-.07.77.39a1.65,1.65,0,0,1-.77,1.29l-48.9,28.2c-.42.24-.77.07-.77-.4A1.68,1.68,0,0,1,204.45,175.19Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.18,189.2l61.17-35.52c.43-.24.77-.07.77.39a1.65,1.65,0,0,1-.77,1.29l-61.17,35.51c-.42.25-.77.07-.77-.39A1.66,1.66,0,0,1,192.18,189.2Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.06,194.11,236,170.41c.42-.24.77-.07.77.39a1.68,1.68,0,0,1-.77,1.29l-40.91,23.7c-.43.24-.77.07-.77-.39A1.65,1.65,0,0,1,195.06,194.11Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.18,182.26l8.09-4.67c.42-.25.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28l-8.09,4.67c-.42.25-.77.07-.77-.39A1.63,1.63,0,0,1,192.18,182.26Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,139.33l35.38-20.44c.43-.25.78-.07.78.39a1.64,1.64,0,0,1-.78,1.28L185.53,141c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,185.53,139.33Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,139.33l35.38-20.44c.43-.25.78-.07.78.39a1.64,1.64,0,0,1-.78,1.28L185.53,141c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,185.53,139.33Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,146l7.15-4.13c.42-.25.77-.08.77.39a1.68,1.68,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,185.53,146Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,146l7.15-4.13c.42-.25.77-.08.77.39a1.68,1.68,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,185.53,146Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,152.7l7.15-4.13c.42-.25.77-.07.77.39a1.68,1.68,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,185.53,152.7Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,152.7l7.15-4.13c.42-.25.77-.07.77.39a1.68,1.68,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,185.53,152.7Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,159.39l7.15-4.13c.42-.25.77-.07.77.39a1.68,1.68,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.07-.77-.39A1.65,1.65,0,0,1,185.53,159.39Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,159.39l7.15-4.13c.42-.25.77-.07.77.39a1.68,1.68,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.07-.77-.39A1.65,1.65,0,0,1,185.53,159.39Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,166.08l7.15-4.13c.42-.25.77-.07.77.39a1.68,1.68,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.07-.77-.39A1.65,1.65,0,0,1,185.53,166.08Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,166.08l7.15-4.13c.42-.25.77-.07.77.39a1.68,1.68,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.07-.77-.39A1.65,1.65,0,0,1,185.53,166.08Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,206.46l31.6-18.24c.43-.25.77-.07.77.39a1.65,1.65,0,0,1-.77,1.28l-31.6,18.24c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,197.12,206.46Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,213.15l31.6-18.24c.43-.25.77-.07.77.39a1.63,1.63,0,0,1-.77,1.28l-31.6,18.24c-.43.25-.77.07-.77-.39A1.65,1.65,0,0,1,197.12,213.15Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.32,185.56l19.86-11.43c.43-.24.77-.07.77.39a1.65,1.65,0,0,1-.77,1.29l-19.86,11.42c-.42.25-.77.07-.77-.39A1.66,1.66,0,0,1,233.32,185.56Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.32,192.25l19.86-11.43c.43-.24.77-.07.77.4a1.65,1.65,0,0,1-.77,1.28l-19.86,11.42c-.42.25-.77.07-.77-.39A1.68,1.68,0,0,1,233.32,192.25Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,213.15l7.15-4.13c.42-.25.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.08-.77-.39A1.65,1.65,0,0,1,185.53,213.15Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,213.15l7.15-4.13c.42-.25.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28l-7.15,4.13c-.43.25-.77.08-.77-.39A1.65,1.65,0,0,1,185.53,213.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,219.84l7.15-4.13c.42-.24.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28l-7.15,4.14c-.43.24-.77.07-.77-.39A1.65,1.65,0,0,1,185.53,219.84Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,219.84l7.15-4.13c.42-.24.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28l-7.15,4.14c-.43.24-.77.07-.77-.39A1.65,1.65,0,0,1,185.53,219.84Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.91,117.16l9.16-5.27c.42-.25.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28l-9.16,5.27c-.43.25-.78.08-.78-.39A1.66,1.66,0,0,1,223.91,117.16Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.91,117.16l9.16-5.27c.42-.25.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28l-9.16,5.27c-.43.25-.78.08-.78-.39A1.66,1.66,0,0,1,223.91,117.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.57,166.34l44.63-25.73c.42-.25.77-.07.77.39a1.66,1.66,0,0,1-.77,1.28L196.57,168c-.42.25-.77.07-.77-.39A1.66,1.66,0,0,1,196.57,166.34Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.53,179.57l67.82-39.26c.43-.25.77-.07.77.39a1.63,1.63,0,0,1-.77,1.28l-67.82,39.26c-.43.25-.77.07-.77-.39A1.63,1.63,0,0,1,185.53,179.57Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.19,138.88l9.16-5.27c.43-.25.77-.07.77.39a1.63,1.63,0,0,1-.77,1.28l-9.16,5.28c-.43.24-.77.07-.77-.4A1.65,1.65,0,0,1,244.19,138.88Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,139.32l35.38-20.44c.43-.25.78-.07.78.39a1.66,1.66,0,0,1-.78,1.28L197.12,141c-.43.25-.78.07-.78-.39A1.64,1.64,0,0,1,197.12,139.32Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.12,139.32l35.38-20.44c.43-.25.78-.07.78.39a1.66,1.66,0,0,1-.78,1.28L197.12,141c-.43.25-.78.07-.78-.39A1.64,1.64,0,0,1,197.12,139.32Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5,117.15l9.16-5.27c.42-.25.77-.08.77.39a1.68,1.68,0,0,1-.77,1.28l-9.16,5.27c-.43.25-.78.07-.78-.39A1.66,1.66,0,0,1,235.5,117.15Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.5,117.15l9.16-5.27c.42-.25.77-.08.77.39a1.68,1.68,0,0,1-.77,1.28l-9.16,5.27c-.43.25-.78.07-.78-.39A1.66,1.66,0,0,1,235.5,117.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--program-window--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.3,275.75a1.33,1.33,0,0,0,.65-.19L391.63,200a5.44,5.44,0,0,0,2.43-4.2V99.34c0-.91-.38-1.45-1-1.45a2,2,0,0,0-1,.3L261.39,173.68a5.47,5.47,0,0,0-2.43,4.2v95.85a2.69,2.69,0,0,0,.42,1.48A1.15,1.15,0,0,0,260.3,275.75Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.25,274.11,259.5,276a2.71,2.71,0,0,1-1-2.22V186.55l-3.39-2v87.25A2.56,2.56,0,0,0,256.25,274.11Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--outline--inject-30",
    d: "M393,98.34c.5,0,.57.62.57,1v96.49a5,5,0,0,1-2.2,3.81L260.72,275.17a.87.87,0,0,1-.43.14c-.47,0-.88-.74-.88-1.58V177.88a5,5,0,0,1,2.2-3.81L392.3,98.58a1.5,1.5,0,0,1,.74-.24m0-.89a2.32,2.32,0,0,0-1.18.36L261.17,173.29a5.85,5.85,0,0,0-2.65,4.59v95.85c0,1.34.74,2.47,1.77,2.47a1.82,1.82,0,0,0,.88-.25l130.68-75.53a5.85,5.85,0,0,0,2.65-4.59V99.34c0-1.2-.59-1.89-1.46-1.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--up-bar--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.5,99.28V108l-136,78.54-3.39-2V176a5.37,5.37,0,0,1,.81-2.65,5.22,5.22,0,0,1,1.84-1.94L388.47,95.89a1.88,1.88,0,0,1,1.93-.16c.49.3,2.81,1.62,3.28,1.86a.72.72,0,0,1,.2.14,1,1,0,0,1,.21.21,1.24,1.24,0,0,1,.17.27,1,1,0,0,1,.13.32,1.9,1.9,0,0,1,.08.36v0A2.22,2.22,0,0,1,394.5,99.28Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,99.28V108l-136,78.54-3.39-2V176a5.37,5.37,0,0,1,.81-2.65,5.22,5.22,0,0,1,1.84-1.94L388.47,95.89a1.88,1.88,0,0,1,1.93-.16c.49.3,2.81,1.62,3.28,1.86a.72.72,0,0,1,.2.14,1,1,0,0,1,.21.21,1.24,1.24,0,0,1,.17.27,1,1,0,0,1,.13.32,1.9,1.9,0,0,1,.08.36v0A2.22,2.22,0,0,1,394.5,99.28Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.5,99.28V108l-136,78.54v-8.67a4.64,4.64,0,0,1,.32-1.64c0-.09.07-.19.11-.28a5.26,5.26,0,0,1,.36-.71,5.33,5.33,0,0,1,1.86-2L391.85,97.81a1.76,1.76,0,0,1,2-.08,1,1,0,0,1,.21.21,1.24,1.24,0,0,1,.17.27,1,1,0,0,1,.13.32,1.9,1.9,0,0,1,.08.36v0A2.22,2.22,0,0,1,394.5,99.28Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.43,110a4.38,4.38,0,0,0-1.65,3.5c0,1.41.74,2.12,1.65,1.59a4.33,4.33,0,0,0,1.66-3.5C379.09,110.21,378.35,109.49,377.43,110Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.39,106.58a4.34,4.34,0,0,0-1.66,3.5c0,1.4.74,2.12,1.66,1.59a4.37,4.37,0,0,0,1.65-3.5C385,106.76,384.3,106.05,383.39,106.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.34,103.14a4.35,4.35,0,0,0-1.65,3.5c0,1.4.74,2.11,1.65,1.59a4.38,4.38,0,0,0,1.65-3.5C391,103.32,390.25,102.61,389.34,103.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.86,97.81,261.17,173.29a5.55,5.55,0,0,0-1.87,2l-3.36-1.95a5.12,5.12,0,0,1,1.84-1.93L388.47,95.89a1.88,1.88,0,0,1,1.93-.16c.47.29,2.67,1.54,3.23,1.84A1.93,1.93,0,0,0,391.86,97.81Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M391.86,97.81,261.17,173.29a5.55,5.55,0,0,0-1.87,2l-3.36-1.95a5.12,5.12,0,0,1,1.84-1.93L388.47,95.89a1.88,1.88,0,0,1,1.93-.16c.47.29,2.67,1.54,3.23,1.84A1.93,1.93,0,0,0,391.86,97.81Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Program--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M264.45,192.19c0,1.23.86,1.73,1.93,1.12a4.29,4.29,0,0,0,1.93-3.34c0-1.24-.86-1.73-1.93-1.12A4.3,4.3,0,0,0,264.45,192.19Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.86,184.11l17.22-9.94c.57-.33,1-.09,1,.52a2.2,2.2,0,0,1-1,1.71l-17.22,9.94c-.57.33-1,.1-1-.52A2.22,2.22,0,0,1,277.86,184.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.79,170.7,318,160.76c.57-.33,1-.09,1,.52a2.22,2.22,0,0,1-1,1.71l-17.22,9.94c-.57.33-1,.09-1-.52A2.22,2.22,0,0,1,300.79,170.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.72,157.29l17.22-9.94c.57-.33,1-.1,1,.52a2.22,2.22,0,0,1-1,1.71l-17.22,9.94c-.57.33-1,.09-1-.52A2.22,2.22,0,0,1,323.72,157.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.65,143.88l17.22-9.94c.57-.33,1-.1,1,.52a2.22,2.22,0,0,1-1,1.71l-17.22,9.94c-.57.33-1,.09-1-.52A2.2,2.2,0,0,1,346.65,143.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.58,130.47l17.23-9.94c.56-.33,1-.1,1,.52a2.2,2.2,0,0,1-1,1.7l-17.23,9.95c-.57.33-1,.09-1-.52A2.2,2.2,0,0,1,369.58,130.47Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,203.71v1.91c0,.53.37.74.82.48l4.59-2.66a1.82,1.82,0,0,0,.82-1.42v-1.91c0-.53-.37-.74-.82-.48l-4.6,2.66A1.82,1.82,0,0,0,266.13,203.71Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83,197.94l12.35-7.11c.57-.33,1-.1,1,.52a2.22,2.22,0,0,1-1,1.71l-12.35,7.1c-.57.33-1,.1-1-.52A2.2,2.2,0,0,1,275.83,197.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,210.34a.27.27,0,0,1-.12,0,.26.26,0,0,1-.13-.22v-8.9a.26.26,0,0,1,.13-.22l27-15.58a.26.26,0,0,1,.24,0,.24.24,0,0,1,.13.21v8.91a.23.23,0,0,1-.13.21l-27,15.59A.31.31,0,0,1,264.45,210.34Zm.25-9v8.33l26.49-15.29V186Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,217.07V219c0,.52.37.73.82.47l4.59-2.65a1.82,1.82,0,0,0,.82-1.42v-1.92c0-.52-.37-.73-.82-.47l-4.6,2.66A1.82,1.82,0,0,0,266.13,217.07Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83,211.29l12.35-7.1c.57-.33,1-.1,1,.52a2.2,2.2,0,0,1-1,1.7l-12.35,7.11c-.57.33-1,.09-1-.52A2.22,2.22,0,0,1,275.83,211.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,223.7a.19.19,0,0,1-.12,0,.23.23,0,0,1-.13-.21v-8.91a.24.24,0,0,1,.13-.21l27-15.58a.21.21,0,0,1,.24,0,.23.23,0,0,1,.13.21v8.91a.23.23,0,0,1-.13.21l-27,15.58A.22.22,0,0,1,264.45,223.7Zm.25-9V223l26.49-15.3v-8.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,230.43v1.9c0,.53.37.74.82.48l4.59-2.65a1.84,1.84,0,0,0,.82-1.43v-1.91c0-.52-.37-.74-.82-.47L267,229A1.84,1.84,0,0,0,266.13,230.43Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83,224.65l12.35-7.11c.57-.33,1-.09,1,.52a2.2,2.2,0,0,1-1,1.71l-12.35,7.11c-.57.32-1,.09-1-.52A2.2,2.2,0,0,1,275.83,224.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,237.05l-.12,0a.24.24,0,0,1-.13-.21V227.9a.23.23,0,0,1,.13-.21l27-15.59a.26.26,0,0,1,.24,0,.26.26,0,0,1,.13.22v8.9a.26.26,0,0,1-.13.22l-27,15.58A.31.31,0,0,1,264.45,237.05Zm.25-9v8.34l26.49-15.3v-8.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,243.78v1.91c0,.53.37.74.82.48l4.59-2.66a1.82,1.82,0,0,0,.82-1.42v-1.91c0-.53-.37-.74-.82-.48l-4.6,2.66A1.82,1.82,0,0,0,266.13,243.78Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83,238l12.35-7.11c.57-.33,1-.1,1,.52a2.18,2.18,0,0,1-1,1.7l-12.35,7.11c-.57.33-1,.1-1-.52A2.18,2.18,0,0,1,275.83,238Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,250.41a.27.27,0,0,1-.12,0,.26.26,0,0,1-.13-.22v-8.9a.26.26,0,0,1,.13-.22l27-15.58a.25.25,0,0,1,.24,0,.24.24,0,0,1,.13.21v8.91a.23.23,0,0,1-.13.21l-27,15.59A.31.31,0,0,1,264.45,250.41Zm.25-9v8.33l26.49-15.29V226.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.13,257.14v1.91c0,.52.37.73.82.47l4.59-2.65a1.82,1.82,0,0,0,.82-1.42v-1.92c0-.52-.37-.73-.82-.47l-4.6,2.66A1.82,1.82,0,0,0,266.13,257.14Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.83,251.36l12.35-7.1c.57-.33,1-.1,1,.51a2.2,2.2,0,0,1-1,1.71l-12.35,7.11c-.57.33-1,.09-1-.52A2.22,2.22,0,0,1,275.83,251.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.45,263.77a.19.19,0,0,1-.12,0,.23.23,0,0,1-.13-.21v-8.91a.23.23,0,0,1,.13-.21l27-15.58a.21.21,0,0,1,.24,0,.23.23,0,0,1,.13.21v8.91a.24.24,0,0,1-.13.21l-27,15.58A.22.22,0,0,1,264.45,263.77Zm.25-9v8.33l26.49-15.3v-8.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.38,214.24l28.25-16.31a4.21,4.21,0,0,0,1.9-3.29v-24.4c0-1.21-.85-1.7-1.9-1.09l-28.25,16.31a4.17,4.17,0,0,0-1.9,3.28v24.4C300.48,214.35,301.33,214.84,302.38,214.24Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.53,215a1.49,1.49,0,0,1-.72-.19,1.77,1.77,0,0,1-.79-1.63v-24.4a4.65,4.65,0,0,1,2.13-3.68l28.25-16.31a1.61,1.61,0,0,1,2.59,1.49v24.4a4.64,4.64,0,0,1-2.13,3.68l-28.25,16.31A2.14,2.14,0,0,1,301.53,215Zm30-45.61a1.26,1.26,0,0,0-.62.19l-28.25,16.31a3.78,3.78,0,0,0-1.67,2.89v24.4a.92.92,0,0,0,.33.83.93.93,0,0,0,.88-.13l28.25-16.31a3.77,3.77,0,0,0,1.67-2.89v-24.4a.92.92,0,0,0-.33-.83A.53.53,0,0,0,331.48,169.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.75,183.71a.33.33,0,0,1-.28-.16.33.33,0,0,1,.12-.45l1-.55a.33.33,0,0,1,.45.12.34.34,0,0,1-.12.45l-.95.55A.35.35,0,0,1,298.75,183.71Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7,182a.35.35,0,0,1-.29-.17.33.33,0,0,1,.12-.44l2-1.16a.34.34,0,0,1,.45.12.33.33,0,0,1-.12.45l-2,1.16A.47.47,0,0,1,301.7,182Zm4-2.31a.33.33,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.32.57l-2,1.15A.33.33,0,0,1,305.69,179.7Zm4-2.3a.32.32,0,0,1-.29-.17.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,1,1,.33.57l-2,1.15A.33.33,0,0,1,309.69,177.4Zm4-2.31a.36.36,0,0,1-.29-.16.33.33,0,0,1,.13-.45l2-1.16a.35.35,0,0,1,.45.12.33.33,0,0,1-.12.45l-2,1.16A.29.29,0,0,1,313.68,175.09Zm4-2.31a.31.31,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.45.12.34.34,0,0,1-.12.45l-2,1.15A.33.33,0,0,1,317.67,172.78Zm4-2.3a.34.34,0,0,1-.29-.17.33.33,0,0,1,.12-.44l2-1.16a.34.34,0,0,1,.45.12.33.33,0,0,1-.12.45l-2,1.16A.47.47,0,0,1,321.67,170.48Zm4-2.31a.33.33,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.32.57l-2,1.15A.33.33,0,0,1,325.66,168.17Zm4-2.3a.33.33,0,0,1-.17-.62l2-1.15a.33.33,0,1,1,.33.57l-2,1.15A.33.33,0,0,1,329.66,165.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.65,163.56a.33.33,0,0,1-.28-.16.32.32,0,0,1,.12-.45l.94-.55a.33.33,0,1,1,.33.57l-.95.55A.29.29,0,0,1,333.65,163.56Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.29,219.94a.32.32,0,0,1-.33-.32v-1.1a.33.33,0,0,1,.66,0v1.1A.32.32,0,0,1,297.29,219.94Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.29,216.75a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,1,1,.66,0v2.1A.33.33,0,0,1,297.29,216.75Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0v2.1A.33.33,0,0,1,297.29,212.55Zm0-4.21A.32.32,0,0,1,297,208v-2.11a.33.33,0,0,1,.66,0V208A.32.32,0,0,1,297.29,208.34Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0v2.1A.33.33,0,0,1,297.29,204.14Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,1,1,.66,0v2.1A.33.33,0,0,1,297.29,199.94Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0v2.1A.33.33,0,0,1,297.29,195.74Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0v2.1A.33.33,0,0,1,297.29,191.54Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.29,187.33A.32.32,0,0,1,297,187v-1.1a.33.33,0,1,1,.66,0V187A.32.32,0,0,1,297.29,187.33Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.68,200.62a.36.36,0,0,1-.29-.16.34.34,0,0,1,.12-.45l.95-.55a.33.33,0,1,1,.33.57l-1,.55A.32.32,0,0,1,333.68,200.62Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.7,219.08a.31.31,0,0,1-.28-.16.32.32,0,0,1,.12-.45l2-1.15a.33.33,0,1,1,.33.57l-2,1.15A.29.29,0,0,1,301.7,219.08Zm4-2.3a.32.32,0,0,1-.29-.17.34.34,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.33.57l-2,1.15A.33.33,0,0,1,305.7,216.78Zm4-2.31a.33.33,0,0,1-.16-.61l2-1.16a.34.34,0,0,1,.45.12.33.33,0,0,1-.12.45l-2,1.16A.47.47,0,0,1,309.69,214.47Zm4-2.31a.33.33,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.16a.33.33,0,0,1,.45.12.34.34,0,0,1-.12.45l-2,1.16A.33.33,0,0,1,313.69,212.16Zm4-2.31a.36.36,0,0,1-.29-.16.33.33,0,0,1,.13-.45l2-1.16a.34.34,0,0,1,.45.13.33.33,0,0,1-.12.45l-2,1.15A.29.29,0,0,1,317.69,209.85Zm4-2.31a.32.32,0,0,1-.29-.16.34.34,0,0,1,.12-.45l2-1.15a.33.33,0,1,1,.33.57l-2,1.15A.32.32,0,0,1,321.69,207.54Zm4-2.3a.32.32,0,0,1-.28-.17.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.45.12.34.34,0,0,1-.12.45l-2,1.15A.34.34,0,0,1,325.68,205.24Zm4-2.31a.33.33,0,0,1-.16-.61l2-1.16a.34.34,0,0,1,.45.12.33.33,0,0,1-.13.45l-2,1.16A.53.53,0,0,1,329.68,202.93Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.75,220.79a.32.32,0,0,1-.28-.17.33.33,0,0,1,.12-.45l1-.55a.34.34,0,0,1,.45.13.33.33,0,0,1-.12.44l-.95.55A.37.37,0,0,1,298.75,220.79Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,164.94a.33.33,0,0,1-.33-.33v-1.1a.33.33,0,0,1,.66,0v1.1A.33.33,0,0,1,336.09,164.94Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,194.35a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,1,1,.66,0V194A.33.33,0,0,1,336.09,194.35Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,1,1,.66,0v2.1A.33.33,0,0,1,336.09,190.15Zm0-4.21a.32.32,0,0,1-.33-.32v-2.11a.33.33,0,0,1,.66,0v2.11A.32.32,0,0,1,336.09,185.94Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,1,1,.66,0v2.1A.33.33,0,0,1,336.09,181.74Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,1,1,.66,0v2.1A.33.33,0,0,1,336.09,177.54Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0V173A.33.33,0,0,1,336.09,173.34Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,1,1,.66,0v2.1A.33.33,0,0,1,336.09,169.14Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.09,197.54a.32.32,0,0,1-.33-.32v-1.1a.33.33,0,1,1,.66,0v1.1A.32.32,0,0,1,336.09,197.54Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,164.68a.33.33,0,0,1-.17,0,.34.34,0,0,1-.16-.29V161a.33.33,0,0,1,.16-.28l2.92-1.69a.33.33,0,0,1,.33,0,.34.34,0,0,1,.17.29v3.37a.33.33,0,0,1-.17.28l-2.92,1.69A.32.32,0,0,1,334.63,164.68Zm.33-3.51v2.61l2.26-1.3v-2.61Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.63,201.76a.47.47,0,0,1-.17,0,.34.34,0,0,1-.16-.29v-3.37a.34.34,0,0,1,.16-.29l2.92-1.68a.33.33,0,0,1,.33,0,.33.33,0,0,1,.17.28v3.37a.34.34,0,0,1-.17.29l-2.92,1.69A.47.47,0,0,1,334.63,201.76Zm.33-3.51v2.61l2.26-1.31v-2.61Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.83,187.08a.32.32,0,0,1-.16,0,.34.34,0,0,1-.17-.29v-3.37a.33.33,0,0,1,.17-.28l2.92-1.69a.32.32,0,0,1,.33,0,.34.34,0,0,1,.16.29v3.37a.33.33,0,0,1-.16.28L296,187A.33.33,0,0,1,295.83,187.08Zm.33-3.51v2.61l2.26-1.3v-2.62Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.83,224.16a.33.33,0,0,1-.16,0,.32.32,0,0,1-.17-.28v-3.37a.34.34,0,0,1,.17-.29l2.92-1.68a.32.32,0,0,1,.33,0,.32.32,0,0,1,.16.28v3.37a.34.34,0,0,1-.16.29L296,224.11A.34.34,0,0,1,295.83,224.16Zm.33-3.51v2.61l2.26-1.31v-2.61Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.56,181.59a3.53,3.53,0,0,1-1.47,2.81c-.81.47-1.47,0-1.47-1.11a3.53,3.53,0,0,1,1.47-2.81C336.9,180,337.56,180.51,337.56,181.59Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.15,172.18a3.53,3.53,0,0,1-1.47,2.81c-.82.46-1.47,0-1.47-1.12a3.51,3.51,0,0,1,1.47-2.81C317.49,170.6,318.15,171.09,318.15,172.18Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.15,209.25a3.53,3.53,0,0,1-1.47,2.81c-.82.47-1.47,0-1.47-1.11a3.51,3.51,0,0,1,1.47-2.81C317.49,207.67,318.15,208.17,318.15,209.25Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.76,204a3.53,3.53,0,0,1-1.47,2.81c-.81.47-1.47,0-1.47-1.11a3.53,3.53,0,0,1,1.47-2.81C298.1,202.46,298.76,203,298.76,204Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.11,188.42v-2.24a.15.15,0,0,0-.22-.15l-1.73.78a.2.2,0,0,1-.29-.13,3.57,3.57,0,0,0-.39-.86.48.48,0,0,1,0-.42l1.15-2.33a.24.24,0,0,0-.1-.33l-1.25-.73a.27.27,0,0,0-.35.08l-1.44,2.17a.45.45,0,0,1-.37.18,4.49,4.49,0,0,0-.94.1.21.21,0,0,1-.26-.19l-.19-1.88a.15.15,0,0,0-.23-.13l-2,1.13a.52.52,0,0,0-.23.36l-.19,2.17a.78.78,0,0,1-.21.4,11.7,11.7,0,0,0-1.08,1.14.34.34,0,0,1-.38.11l-1.25-.43a.29.29,0,0,0-.35.13l-1.43,2.47a.3.3,0,0,0,.06.37l1,.87a.34.34,0,0,1,.1.38,12.35,12.35,0,0,0-.45,1.51.75.75,0,0,1-.25.38l-1.77,1.25a.51.51,0,0,0-.2.38v2.25a.15.15,0,0,0,.22.14l1.73-.78a.2.2,0,0,1,.29.13,4,4,0,0,0,.38.86.48.48,0,0,1,0,.42l-1.15,2.33a.26.26,0,0,0,.1.34l1.25.72a.27.27,0,0,0,.35-.08l1.43-2.16a.46.46,0,0,1,.38-.19,3.91,3.91,0,0,0,.94-.1.21.21,0,0,1,.26.19l.19,1.89a.14.14,0,0,0,.23.12l2-1.13a.52.52,0,0,0,.23-.36l.19-2.16a.77.77,0,0,1,.21-.41,11.7,11.7,0,0,0,1.08-1.14.34.34,0,0,1,.38-.11l1.25.43a.3.3,0,0,0,.35-.13l1.43-2.47a.3.3,0,0,0-.06-.37l-1-.86a.37.37,0,0,1-.09-.39,14.4,14.4,0,0,0,.45-1.51.68.68,0,0,1,.25-.37l1.77-1.26A.5.5,0,0,0,324.11,188.42Zm-7.61,7.07c-1.81,1-3.28.19-3.28-1.9a7.25,7.25,0,0,1,3.28-5.69c1.82-1.05,3.29-.2,3.29,1.89A7.27,7.27,0,0,1,316.5,195.49Z",
    style: {
      fill: "#35885D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M352.34,185.47l28.25-16.31a4.21,4.21,0,0,0,1.89-3.29V141.48c0-1.21-.85-1.7-1.89-1.1l-28.25,16.31a4.21,4.21,0,0,0-1.9,3.29v24.4C350.44,185.59,351.29,186.08,352.34,185.47Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.49,186.19a1.42,1.42,0,0,1-.73-.19,1.77,1.77,0,0,1-.78-1.62V160a4.63,4.63,0,0,1,2.13-3.69L380.36,140a1.6,1.6,0,0,1,2.58,1.5v24.39a4.65,4.65,0,0,1-2.12,3.69l-28.25,16.31A2.25,2.25,0,0,1,351.49,186.19Zm29.94-45.61a1.25,1.25,0,0,0-.61.2l-28.25,16.31A3.72,3.72,0,0,0,350.9,160v24.4a1,1,0,0,0,.32.83.93.93,0,0,0,.89-.14l28.25-16.31a3.74,3.74,0,0,0,1.66-2.89V141.48a.91.91,0,0,0-.32-.83A.5.5,0,0,0,381.43,140.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.71,155a.35.35,0,0,1-.29-.17.34.34,0,0,1,.12-.45l.95-.55a.35.35,0,0,1,.45.12.33.33,0,0,1-.12.45l-.95.55A.33.33,0,0,1,348.71,155Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,153.24a.31.31,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.45.12.34.34,0,0,1-.12.45l-2,1.15A.33.33,0,0,1,351.65,153.24Zm4-2.3a.35.35,0,0,1-.29-.17.33.33,0,0,1,.12-.44l2-1.16a.34.34,0,0,1,.45.12.33.33,0,0,1-.12.45l-2,1.16A.47.47,0,0,1,355.65,150.94Zm4-2.31a.33.33,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,1,1,.32.57l-2,1.15A.33.33,0,0,1,359.64,148.63Zm4-2.3a.33.33,0,0,1-.17-.62l2-1.15a.33.33,0,1,1,.33.57l-2,1.15A.33.33,0,0,1,363.64,146.33Zm4-2.31a.33.33,0,0,1-.28-.16.32.32,0,0,1,.12-.45l2-1.16a.35.35,0,0,1,.45.12.33.33,0,0,1-.12.45l-2,1.16A.29.29,0,0,1,367.63,144Zm4-2.31a.31.31,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.45.12.34.34,0,0,1-.12.45l-2,1.15A.33.33,0,0,1,371.62,141.71Zm4-2.3a.35.35,0,0,1-.29-.17.34.34,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.33.57l-2,1.15A.3.3,0,0,1,375.62,139.41Zm4-2.31a.33.33,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.45.12.34.34,0,0,1-.13.45l-2,1.15A.33.33,0,0,1,379.61,137.1Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.61,134.8a.32.32,0,0,1-.29-.17.34.34,0,0,1,.12-.45l.95-.54a.33.33,0,0,1,.33.57l-1,.54A.33.33,0,0,1,383.61,134.8Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.25,191.18a.33.33,0,0,1-.33-.33v-1.09a.33.33,0,0,1,.66,0v1.09A.33.33,0,0,1,347.25,191.18Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.25,188a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0v2.1A.33.33,0,0,1,347.25,188Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,1,1,.66,0v2.1A.33.33,0,0,1,347.25,183.78Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0v2.1A.33.33,0,0,1,347.25,179.58Zm0-4.2a.33.33,0,0,1-.33-.33V173a.33.33,0,1,1,.66,0v2.1A.33.33,0,0,1,347.25,175.38Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0v2.1A.33.33,0,0,1,347.25,171.18Zm0-4.21a.32.32,0,0,1-.33-.32v-2.11a.33.33,0,0,1,.66,0v2.11A.32.32,0,0,1,347.25,167Zm0-4.2a.33.33,0,0,1-.33-.33v-2.1a.33.33,0,0,1,.66,0v2.1A.33.33,0,0,1,347.25,162.77Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.25,158.57a.33.33,0,0,1-.33-.33v-1.09a.33.33,0,0,1,.66,0v1.09A.33.33,0,0,1,347.25,158.57Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.64,171.86a.32.32,0,0,1-.29-.17.33.33,0,0,1,.12-.45l.95-.54a.33.33,0,0,1,.45.12.33.33,0,0,1-.12.45l-.95.54A.33.33,0,0,1,383.64,171.86Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.66,190.32a.34.34,0,0,1-.29-.16.33.33,0,0,1,.12-.45l2-1.16a.33.33,0,0,1,.33.57l-2,1.16A.32.32,0,0,1,351.66,190.32Zm4-2.31a.33.33,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.16a.34.34,0,0,1,.45.13.33.33,0,0,1-.12.44l-2,1.16A.33.33,0,0,1,355.65,188Zm4-2.31a.31.31,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,0,1,.32.57l-2,1.15A.35.35,0,0,1,359.65,185.7Zm4-2.3a.35.35,0,0,1-.29-.17.34.34,0,0,1,.12-.45l2-1.15a.33.33,0,1,1,.33.57l-2,1.15A.33.33,0,0,1,363.65,183.4Zm4-2.31a.32.32,0,0,1-.29-.17.33.33,0,0,1,.12-.45l2-1.15a.33.33,0,1,1,.33.57l-2,1.15A.33.33,0,0,1,367.65,181.09Zm4-2.31a.33.33,0,0,1-.28-.16.33.33,0,0,1,.12-.45l2-1.16a.33.33,0,0,1,.45.12.34.34,0,0,1-.12.45l-2,1.16A.33.33,0,0,1,371.64,178.78Zm4-2.31a.33.33,0,0,1-.28-.16.32.32,0,0,1,.12-.45l2-1.16a.34.34,0,0,1,.45.13.33.33,0,0,1-.12.45l-2,1.15A.29.29,0,0,1,375.64,176.47Zm4-2.31a.32.32,0,0,1-.29-.16.34.34,0,0,1,.12-.45l2-1.15a.33.33,0,1,1,.33.57l-2,1.15A.32.32,0,0,1,379.64,174.16Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.71,192a.36.36,0,0,1-.29-.16.34.34,0,0,1,.12-.45l.95-.55a.33.33,0,0,1,.33.57l-.95.55A.32.32,0,0,1,348.71,192Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,136.17a.32.32,0,0,1-.32-.33v-1.09a.33.33,0,1,1,.65,0v1.09A.33.33,0,0,1,386,136.17Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,165.58a.32.32,0,0,1-.32-.33v-2.1a.33.33,0,1,1,.65,0v2.1A.32.32,0,0,1,386,165.58Zm0-4.2a.32.32,0,0,1-.32-.33V159a.33.33,0,1,1,.65,0v2.1A.33.33,0,0,1,386,161.38Zm0-4.2a.32.32,0,0,1-.32-.33v-2.1a.33.33,0,1,1,.65,0v2.1A.33.33,0,0,1,386,157.18Zm0-4.2a.32.32,0,0,1-.32-.33v-2.1a.33.33,0,1,1,.65,0v2.1A.33.33,0,0,1,386,153Zm0-4.2a.32.32,0,0,1-.32-.33v-2.1a.33.33,0,1,1,.65,0v2.1A.33.33,0,0,1,386,148.78Zm0-4.21a.32.32,0,0,1-.32-.32v-2.1a.33.33,0,1,1,.65,0v2.1A.32.32,0,0,1,386,144.57Zm0-4.2a.32.32,0,0,1-.32-.33v-2.1a.33.33,0,1,1,.65,0V140A.32.32,0,0,1,386,140.37Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386,168.78a.32.32,0,0,1-.32-.33v-1.09a.33.33,0,1,1,.65,0v1.09A.33.33,0,0,1,386,168.78Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.58,135.92a.33.33,0,0,1-.16,0,.31.31,0,0,1-.16-.28v-3.37a.34.34,0,0,1,.16-.29l2.92-1.68a.32.32,0,0,1,.33,0,.32.32,0,0,1,.16.28v3.37a.34.34,0,0,1-.16.29l-2.92,1.68A.34.34,0,0,1,384.58,135.92Zm.33-3.51V135l2.27-1.31V131.1Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.58,173a.32.32,0,0,1-.16,0,.33.33,0,0,1-.16-.28v-3.38a.33.33,0,0,1,.16-.28l2.92-1.69a.32.32,0,0,1,.33,0,.34.34,0,0,1,.16.29V171a.31.31,0,0,1-.16.28L384.75,173A.33.33,0,0,1,384.58,173Zm.33-3.51v2.62l2.27-1.31v-2.61Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.79,158.32a.34.34,0,0,1-.17,0,.32.32,0,0,1-.16-.28v-3.37a.34.34,0,0,1,.16-.29l2.92-1.68a.32.32,0,0,1,.33,0,.32.32,0,0,1,.17.28v3.37a.34.34,0,0,1-.17.29L346,158.27A.3.3,0,0,1,345.79,158.32Zm.33-3.51v2.61l2.26-1.31V153.5Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.79,195.39a.33.33,0,0,1-.17,0,.34.34,0,0,1-.16-.29v-3.37a.33.33,0,0,1,.16-.28l2.92-1.69a.32.32,0,0,1,.33,0,.34.34,0,0,1,.17.29v3.37a.33.33,0,0,1-.17.28L346,195.35A.29.29,0,0,1,345.79,195.39Zm.33-3.51v2.62l2.26-1.31v-2.61Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.51,152.83a3.51,3.51,0,0,1-1.47,2.81c-.81.46-1.47,0-1.47-1.12a3.53,3.53,0,0,1,1.47-2.81C386.86,151.25,387.51,151.74,387.51,152.83Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.1,143.41a3.53,3.53,0,0,1-1.47,2.81c-.81.47-1.47,0-1.47-1.11a3.53,3.53,0,0,1,1.47-2.81C367.44,141.83,368.1,142.33,368.1,143.41Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.1,180.49a3.53,3.53,0,0,1-1.47,2.81c-.81.47-1.47,0-1.47-1.11a3.52,3.52,0,0,1,1.47-2.81C367.44,178.91,368.1,179.41,368.1,180.49Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.72,175.28a3.53,3.53,0,0,1-1.47,2.81c-.81.46-1.47,0-1.47-1.12a3.53,3.53,0,0,1,1.47-2.81C348.06,173.7,348.72,174.19,348.72,175.28Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.07,159.66v-2.25a.14.14,0,0,0-.22-.14l-1.73.78a.21.21,0,0,1-.29-.14,3.68,3.68,0,0,0-.39-.85.52.52,0,0,1,0-.42l1.16-2.33a.27.27,0,0,0-.1-.34l-1.26-.72a.26.26,0,0,0-.34.08l-1.44,2.16a.49.49,0,0,1-.38.19,3.8,3.8,0,0,0-.93.09.2.2,0,0,1-.26-.18l-.19-1.89a.15.15,0,0,0-.24-.12l-1.94,1.12a.51.51,0,0,0-.23.37l-.2,2.16a.75.75,0,0,1-.2.41,10.66,10.66,0,0,0-1.08,1.14.39.39,0,0,1-.38.11l-1.25-.44a.31.31,0,0,0-.35.13l-1.43,2.48a.3.3,0,0,0,.06.37l1,.86a.38.38,0,0,1,.1.39,10.68,10.68,0,0,0-.45,1.5.71.71,0,0,1-.25.38l-1.78,1.25a.53.53,0,0,0-.2.38v2.25c0,.14.1.2.23.14l1.73-.78a.22.22,0,0,1,.29.14,4.22,4.22,0,0,0,.38.86.48.48,0,0,1,0,.42l-1.16,2.32a.26.26,0,0,0,.11.34l1.25.72a.25.25,0,0,0,.34-.08l1.44-2.16a.5.5,0,0,1,.38-.19,3.76,3.76,0,0,0,.93-.09.2.2,0,0,1,.26.18l.19,1.89a.15.15,0,0,0,.24.12l1.94-1.12a.56.56,0,0,0,.24-.36l.19-2.17a.7.7,0,0,1,.2-.4,11.83,11.83,0,0,0,1.08-1.15.4.4,0,0,1,.39-.11l1.24.44a.32.32,0,0,0,.36-.13l1.43-2.48a.32.32,0,0,0-.07-.37l-1-.86a.39.39,0,0,1-.1-.38,10.81,10.81,0,0,0,.45-1.51.75.75,0,0,1,.25-.38l1.78-1.25A.53.53,0,0,0,374.07,159.66Zm-7.61,7.06c-1.81,1.05-3.29.2-3.29-1.9a7.29,7.29,0,0,1,3.29-5.69c1.82-1,3.29-.2,3.29,1.9A7.26,7.26,0,0,1,366.46,166.72Z",
    style: {
      fill: "#35885D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M295.3,243.34V232.5a4.56,4.56,0,0,1,2.05-3.56l88.43-51.05c1.13-.66,2.05-.13,2.05,1.18v10.84a4.56,4.56,0,0,1-2.05,3.56l-88.43,51.05C296.22,245.18,295.3,244.65,295.3,243.34Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-30",
    d: "M75.05,258.47,46.41,275a2.54,2.54,0,0,0-1.15,2v34.53c0,.73.52,1,1.15.66l28.64-16.5a2.56,2.56,0,0,0,1.15-2V259.13C76.2,258.4,75.68,258.11,75.05,258.47Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-30",
    d: "M66.93,189.91,45.79,202.09a1.16,1.16,0,0,0-.53.91v11.8c0,.34.24.47.53.3l21.14-12.18a1.14,1.14,0,0,0,.53-.9V190.21C67.46,189.88,67.22,189.74,66.93,189.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-30",
    d: "M66.93,214.44,45.79,226.62a1.16,1.16,0,0,0-.53.91v11.8c0,.33.24.47.53.3l21.14-12.18a1.15,1.15,0,0,0,.53-.91v-11.8C67.46,214.41,67.22,214.27,66.93,214.44Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-30",
    d: "M66.93,239,45.79,251.15a1.15,1.15,0,0,0-.53.91v11.8c0,.33.24.47.53.3L66.93,252a1.16,1.16,0,0,0,.53-.91v-11.8C67.46,238.93,67.22,238.8,66.93,239Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.6,259.85,50,276.35a2.54,2.54,0,0,0-1.15,2v34.53a2.51,2.51,0,0,0,1.15,2l2.18,1.23a2.55,2.55,0,0,0,2.3,0l28.64-16.5a2.54,2.54,0,0,0,1.15-2V263a2.51,2.51,0,0,0-1.16-2l-2.17-1.23A2.55,2.55,0,0,0,78.6,259.85Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.44,316.05a2.62,2.62,0,0,1-2.3,0L50,314.82a2.48,2.48,0,0,1-1.15-2V278.33a2.4,2.4,0,0,1,.37-1.17l4.45,2.58a2.31,2.31,0,0,0-.34,1.13v34.52C53.29,316.06,53.76,316.44,54.44,316.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.21,262.84c-.09-.58-.56-.79-1.13-.46L54.44,278.89a2.29,2.29,0,0,0-.81.85l-4.46-2.58a2.28,2.28,0,0,1,.79-.81l28.64-16.5a2.55,2.55,0,0,1,2.3,0l2.17,1.23A2.54,2.54,0,0,1,84.21,262.84Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.08,262.38,54.44,278.89a2.53,2.53,0,0,0-1.15,2v34.52c0,.73.52,1,1.15.66l28.64-16.5a2.53,2.53,0,0,0,1.14-2V263C84.22,262.31,83.71,262,83.08,262.38Z",
    style: {
      fill: "#35885D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.19,296.76a1.85,1.85,0,0,1,.12-.71,5.24,5.24,0,0,1,.37-.67l6.75-10.92a.88.88,0,0,1,.11-.13l.08-.06a.19.19,0,0,1,.25,0,.45.45,0,0,1,.1.33v4.22a1.84,1.84,0,0,1-.19.88,5.51,5.51,0,0,1-.35.57l-3,4.54,3,1.16a1.49,1.49,0,0,1,.35.16c.13.08.19.3.19.65V301a1,1,0,0,1-.1.45.69.69,0,0,1-.25.3l-.08,0a.2.2,0,0,1-.11,0l-6.75-3.12a1,1,0,0,1-.37-.25.93.93,0,0,1-.12-.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.92,278.24a3.32,3.32,0,0,1,.25-.68,1.2,1.2,0,0,1,.49-.53l2.26-1.31a.21.21,0,0,1,.27,0,.46.46,0,0,1,.11.34,1.41,1.41,0,0,1,0,.25l-5.71,24.34a2.67,2.67,0,0,1-.24.66,1.21,1.21,0,0,1-.5.55l-2.22,1.28a.2.2,0,0,1-.26,0,.46.46,0,0,1-.11-.34.85.85,0,0,1,0-.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.33,282.18a1.92,1.92,0,0,1-.12.71,6,6,0,0,1-.37.66l-6.76,10.92a.58.58,0,0,1-.1.13l-.08.06c-.1.06-.19.06-.25,0a.44.44,0,0,1-.1-.33v-4.21a1.75,1.75,0,0,1,.19-.87c.13-.23.24-.42.34-.57l3-4.56-3-1.13a1.26,1.26,0,0,1-.34-.18c-.13-.09-.19-.31-.19-.65v-4.22a1,1,0,0,1,.1-.45.63.63,0,0,1,.25-.3l.08,0h.1l6.76,3.12a1,1,0,0,1,.37.25,1,1,0,0,1,.12.56Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.51,191.24,49.37,203.43a1.14,1.14,0,0,0-.53.9v11.81a1.14,1.14,0,0,0,.53.9l2.09,1.19a1.18,1.18,0,0,0,1,0L73.66,206a1.18,1.18,0,0,0,.52-.91v-11.8a1.14,1.14,0,0,0-.53-.9l-2.08-1.19A1.23,1.23,0,0,0,70.51,191.24Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51,191.24,49.37,203.43a1.14,1.14,0,0,0-.53.9v11.81a1.14,1.14,0,0,0,.53.9l2.09,1.19a1.18,1.18,0,0,0,1,0L73.66,206a1.18,1.18,0,0,0,.52-.91v-11.8a1.14,1.14,0,0,0-.53-.9l-2.08-1.19A1.23,1.23,0,0,0,70.51,191.24Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.17,193.23c0-.26-.25-.35-.52-.2L52.51,205.21a1.07,1.07,0,0,0-.37.39L49,203.8a1,1,0,0,1,.36-.38l21.14-12.18a1.2,1.2,0,0,1,1.06,0l2.08,1.19A1.11,1.11,0,0,1,74.17,193.23Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.66,193,52.51,205.21a1.14,1.14,0,0,0-.52.91v11.8c0,.33.23.47.52.3L73.66,206a1.15,1.15,0,0,0,.52-.91v-11.8C74.18,193,74,192.86,73.66,193Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.66,193,52.51,205.21a1.14,1.14,0,0,0-.52.91v11.8c0,.33.23.47.52.3L73.66,206a1.15,1.15,0,0,0,.52-.91v-11.8C74.18,193,74,192.86,73.66,193Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M57.21,208.23c0,.1,0,.22,0,.38v1c0,.16,0,.28,0,.37a2.65,2.65,0,0,0,.06.42.61.61,0,0,0,.15.3.4.4,0,0,0,.26.12.78.78,0,0,0,.38-.13,1.15,1.15,0,0,0,.38-.3,1.51,1.51,0,0,0,.24-.34,1.76,1.76,0,0,0,.15-.35c0-.12.06-.22.08-.31a1,1,0,0,1,.07-.28.41.41,0,0,1,.16-.16l.88-.51s.08,0,.1,0a.17.17,0,0,1,.05.13,4.33,4.33,0,0,1-.17,1.1,5.28,5.28,0,0,1-.45,1.07,5.42,5.42,0,0,1-.66.93,3.31,3.31,0,0,1-.83.68,1.71,1.71,0,0,1-.87.27,1,1,0,0,1-.65-.23,1.36,1.36,0,0,1-.41-.66,3.52,3.52,0,0,1-.17-1c0-.28,0-.58,0-.9s0-.65,0-.95a6.18,6.18,0,0,1,.16-1.18,5.55,5.55,0,0,1,.42-1.14,4.64,4.64,0,0,1,.65-1,3.52,3.52,0,0,1,.87-.73,1.87,1.87,0,0,1,.83-.27,1.1,1.1,0,0,1,.66.16,1.19,1.19,0,0,1,.45.55,2.41,2.41,0,0,1,.17.9.41.41,0,0,1-.05.19.27.27,0,0,1-.1.13l-.88.51c-.08,0-.13.05-.16,0a.39.39,0,0,1-.07-.19c0-.07,0-.15-.08-.23a.52.52,0,0,0-.15-.18.43.43,0,0,0-.24-.06.85.85,0,0,0-.38.14,1.18,1.18,0,0,0-.38.32,1.59,1.59,0,0,0-.26.41,2,2,0,0,0-.15.47A4.1,4.1,0,0,0,57.21,208.23Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63,202.05a1.73,1.73,0,0,1,.79-.27,1.17,1.17,0,0,1,.63.13,1.13,1.13,0,0,1,.41.43,1.28,1.28,0,0,1,.15.61.39.39,0,0,1,0,.18.24.24,0,0,1-.1.13l-.88.51a.32.32,0,0,1-.16,0l-.11-.06-.07-.07a.36.36,0,0,0-.12-.08.47.47,0,0,0-.21,0,.59.59,0,0,0-.29.11,2.2,2.2,0,0,0-.25.17,1.34,1.34,0,0,0-.21.2,1.28,1.28,0,0,0-.15.25.71.71,0,0,0-.05.29.3.3,0,0,0,.06.22.26.26,0,0,0,.22.07,1.84,1.84,0,0,0,.4-.06l.62-.16a2,2,0,0,1,.65-.08.78.78,0,0,1,.46.17,1,1,0,0,1,.28.47,2.81,2.81,0,0,1,.09.79,3.37,3.37,0,0,1-.16,1,4.56,4.56,0,0,1-.43,1,4.13,4.13,0,0,1-.67.83,3.92,3.92,0,0,1-.83.64,2,2,0,0,1-.84.3,1.06,1.06,0,0,1-1.08-.56,1.67,1.67,0,0,1-.16-.69.49.49,0,0,1,.05-.19.24.24,0,0,1,.09-.12l.89-.51a.26.26,0,0,1,.15-.05.16.16,0,0,1,.1.05l.09.08a.31.31,0,0,0,.14.11.41.41,0,0,0,.23,0,.7.7,0,0,0,.34-.12,2.41,2.41,0,0,0,.6-.47.81.81,0,0,0,.24-.57.23.23,0,0,0-.09-.21.62.62,0,0,0-.26,0,2.53,2.53,0,0,0-.45.09l-.65.17a1,1,0,0,1-1-.18,1.81,1.81,0,0,1-.32-1.24,3.42,3.42,0,0,1,.13-.93,4.21,4.21,0,0,1,.38-.94,4.58,4.58,0,0,1,.6-.84A3.27,3.27,0,0,1,63,202.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.85,199.22a1.79,1.79,0,0,1,.79-.26,1.12,1.12,0,0,1,.62.13,1,1,0,0,1,.42.43,1.37,1.37,0,0,1,.15.61.39.39,0,0,1,0,.18.36.36,0,0,1-.1.13l-.89.51a.24.24,0,0,1-.15,0,.21.21,0,0,1-.12-.05l-.06-.07a.36.36,0,0,0-.12-.08.47.47,0,0,0-.21,0,.74.74,0,0,0-.29.12,1.38,1.38,0,0,0-.25.17,1.34,1.34,0,0,0-.21.2,1,1,0,0,0-.15.25.72.72,0,0,0-.06.29.32.32,0,0,0,.07.22.25.25,0,0,0,.21.07,1.83,1.83,0,0,0,.41-.06l.62-.16a1.7,1.7,0,0,1,.64-.08.75.75,0,0,1,.47.17,1,1,0,0,1,.27.46,2.89,2.89,0,0,1,.1.8,3.57,3.57,0,0,1-.16,1,4.33,4.33,0,0,1-1.1,1.8,4.28,4.28,0,0,1-.83.64,2.2,2.2,0,0,1-.84.3,1.14,1.14,0,0,1-.65-.12,1.1,1.1,0,0,1-.43-.45,1.45,1.45,0,0,1-.16-.68.43.43,0,0,1,0-.19.32.32,0,0,1,.1-.12l.89-.51c.06,0,.11-.06.14,0a.21.21,0,0,1,.11,0l.08.09a.58.58,0,0,0,.15.11.41.41,0,0,0,.23,0,.87.87,0,0,0,.34-.12,2.66,2.66,0,0,0,.6-.47.81.81,0,0,0,.24-.57.23.23,0,0,0-.09-.21.49.49,0,0,0-.26,0,2.53,2.53,0,0,0-.45.09l-.65.16a1,1,0,0,1-1-.17,1.84,1.84,0,0,1-.33-1.25,3.5,3.5,0,0,1,.14-.93,3.72,3.72,0,0,1,.38-.93,4.21,4.21,0,0,1,.6-.85A3.52,3.52,0,0,1,67.85,199.22Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.51,215.77,49.37,228a1.18,1.18,0,0,0-.53.91v11.8a1.16,1.16,0,0,0,.53.91l2.09,1.18a1.14,1.14,0,0,0,1,0l21.15-12.18a1.2,1.2,0,0,0,.52-.91v-11.8a1.16,1.16,0,0,0-.53-.91l-2.08-1.18A1.2,1.2,0,0,0,70.51,215.77Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51,215.77,49.37,228a1.18,1.18,0,0,0-.53.91v11.8a1.16,1.16,0,0,0,.53.91l2.09,1.18a1.14,1.14,0,0,0,1,0l21.15-12.18a1.2,1.2,0,0,0,.52-.91v-11.8a1.16,1.16,0,0,0-.53-.91l-2.08-1.18A1.2,1.2,0,0,0,70.51,215.77Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.17,217.76c0-.26-.25-.36-.52-.21L52.51,229.74a1.07,1.07,0,0,0-.37.39L49,228.33a1,1,0,0,1,.36-.38l21.14-12.18a1.17,1.17,0,0,1,1.06,0L73.65,217A1.12,1.12,0,0,1,74.17,217.76Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.66,217.55,52.51,229.74a1.13,1.13,0,0,0-.52.9v11.81c0,.33.23.47.52.3l21.15-12.18a1.17,1.17,0,0,0,.52-.91v-11.8C74.18,217.52,74,217.39,73.66,217.55Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.66,217.55,52.51,229.74a1.13,1.13,0,0,0-.52.9v11.81c0,.33.23.47.52.3l21.15-12.18a1.17,1.17,0,0,0,.52-.91v-11.8C74.18,217.52,74,217.39,73.66,217.55Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M57.31,229.94a.09.09,0,0,1,.13,0,.2.2,0,0,1,.06.16v6.72a.53.53,0,0,1-.06.23.32.32,0,0,1-.13.15l-.88.51a.09.09,0,0,1-.13,0s0-.08,0-.16V235l-1.5.87v2.54a.46.46,0,0,1-.06.23.35.35,0,0,1-.12.16l-.89.51a.1.1,0,0,1-.13,0,.25.25,0,0,1,0-.17v-6.72a.64.64,0,0,1,0-.23.43.43,0,0,1,.13-.16l.89-.51a.1.1,0,0,1,.12,0,.22.22,0,0,1,.06.17v2.5l1.5-.86v-2.51a.5.5,0,0,1,0-.23.39.39,0,0,1,.13-.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.25,227.09a.09.09,0,0,1,.13,0,.23.23,0,0,1,0,.16v1.1a.59.59,0,0,1,0,.23.36.36,0,0,1-.13.16l-1.19.69v5.33A.64.64,0,0,1,61,235a.43.43,0,0,1-.13.16l-.89.51a.12.12,0,0,1-.13,0,.26.26,0,0,1,0-.17v-5.33l-1.19.68a.1.1,0,0,1-.13,0,.29.29,0,0,1-.05-.17v-1.1a.59.59,0,0,1,.05-.23.36.36,0,0,1,.13-.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.35,230.74a.47.47,0,0,1-.09-.12l-.64-1.35v3.44a.48.48,0,0,1-.05.23.36.36,0,0,1-.13.16l-.88.51a.1.1,0,0,1-.13,0,.22.22,0,0,1,0-.17v-6.71a.48.48,0,0,1,0-.23.36.36,0,0,1,.13-.16l.78-.45c.09,0,.16,0,.2,0a.53.53,0,0,1,.09.11l1.1,2.25,1.09-3.51a1.25,1.25,0,0,1,.09-.22.45.45,0,0,1,.2-.23l.78-.45a.09.09,0,0,1,.13,0,.19.19,0,0,1,0,.16v6.72a.48.48,0,0,1,0,.23.43.43,0,0,1-.13.16l-.88.51a.12.12,0,0,1-.13,0,.22.22,0,0,1,0-.17V228l-.64,2.08a1.78,1.78,0,0,1-.09.23.4.4,0,0,1-.16.18l-.43.24C65.44,230.77,65.39,230.78,65.35,230.74Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.67,226.69s.09,0,.12,0a.2.2,0,0,1,.06.16V228a.46.46,0,0,1-.06.23.3.3,0,0,1-.12.16l-3.13,1.8a.1.1,0,0,1-.13,0,.26.26,0,0,1,0-.17v-6.72a.59.59,0,0,1,0-.22.36.36,0,0,1,.13-.16l.88-.51a.09.09,0,0,1,.13,0,.2.2,0,0,1,.06.16v5.34Z",
    style: {
      fill: "#f0f0f0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-box--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.51,240.3,49.37,252.48a1.16,1.16,0,0,0-.53.91v11.8a1.16,1.16,0,0,0,.53.91l2.09,1.18a1.18,1.18,0,0,0,1,0L73.66,255.1a1.2,1.2,0,0,0,.52-.91v-11.8a1.16,1.16,0,0,0-.53-.91l-2.08-1.18A1.17,1.17,0,0,0,70.51,240.3Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.51,240.3,49.37,252.48a1.16,1.16,0,0,0-.53.91v11.8a1.16,1.16,0,0,0,.53.91l2.09,1.18a1.18,1.18,0,0,0,1,0L73.66,255.1a1.2,1.2,0,0,0,.52-.91v-11.8a1.16,1.16,0,0,0-.53-.91l-2.08-1.18A1.17,1.17,0,0,0,70.51,240.3Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.17,242.29c0-.26-.25-.36-.52-.21L52.51,254.26a1.2,1.2,0,0,0-.37.4L49,252.85a1.06,1.06,0,0,1,.36-.37L70.51,240.3a1.2,1.2,0,0,1,1.06,0l2.08,1.19A1.12,1.12,0,0,1,74.17,242.29Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.66,242.08,52.51,254.26a1.17,1.17,0,0,0-.52.91V267c0,.34.23.47.52.31L73.66,255.1a1.17,1.17,0,0,0,.52-.91v-11.8C74.18,242.05,74,241.92,73.66,242.08Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.66,242.08,52.51,254.26a1.17,1.17,0,0,0-.52.91V267c0,.34.23.47.52.31L73.66,255.1a1.17,1.17,0,0,0,.52-.91v-11.8C74.18,242.05,74,241.92,73.66,242.08Z"
  })))))), /*#__PURE__*/React.createElement("path", {
    d: "M57.62,257.05c0,.09,0,.22,0,.38v1c0,.17,0,.29,0,.38a2.65,2.65,0,0,0,.06.42.84.84,0,0,0,.15.3.42.42,0,0,0,.26.12.78.78,0,0,0,.38-.13,1.48,1.48,0,0,0,.38-.3,2.46,2.46,0,0,0,.25-.34,2,2,0,0,0,.14-.35c0-.12.06-.22.08-.32a1.68,1.68,0,0,1,.07-.27.35.35,0,0,1,.16-.16l.88-.51a.09.09,0,0,1,.11,0s0,.07,0,.13a3.93,3.93,0,0,1-.17,1.1,5.24,5.24,0,0,1-.44,1.07,5,5,0,0,1-.67.92,3.1,3.1,0,0,1-.83.68,1.73,1.73,0,0,1-.86.28,1,1,0,0,1-.65-.23,1.45,1.45,0,0,1-.42-.66,3.65,3.65,0,0,1-.17-1c0-.28,0-.58,0-.91s0-.64,0-.94a5.42,5.42,0,0,1,.17-1.18A5.52,5.52,0,0,1,57,255.4a4.77,4.77,0,0,1,.65-1,3.52,3.52,0,0,1,.87-.73,1.87,1.87,0,0,1,.83-.27,1.06,1.06,0,0,1,.67.16,1.17,1.17,0,0,1,.44.55,2.22,2.22,0,0,1,.17.9.43.43,0,0,1,0,.19.36.36,0,0,1-.11.13l-.88.51c-.08,0-.13,0-.16,0a.54.54,0,0,1-.07-.19c0-.07,0-.15-.08-.23a.37.37,0,0,0-.14-.18.49.49,0,0,0-.25-.06.94.94,0,0,0-.38.13,1.5,1.5,0,0,0-.38.32,2.26,2.26,0,0,0-.26.42,3.23,3.23,0,0,0-.15.47A4.1,4.1,0,0,0,57.62,257.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.82,255.67v1.71a.64.64,0,0,1,0,.23.36.36,0,0,1-.13.16l-.85.49a.1.1,0,0,1-.13,0,.22.22,0,0,1,0-.17v-1.71l-1,.6a.09.09,0,0,1-.13,0,.23.23,0,0,1,0-.16v-1.05a.59.59,0,0,1,0-.23.36.36,0,0,1,.13-.16l1-.6V253a.5.5,0,0,1,0-.23.33.33,0,0,1,.13-.15l.85-.5a.12.12,0,0,1,.13,0,.26.26,0,0,1,0,.17v1.71l1-.6a.12.12,0,0,1,.13,0,.22.22,0,0,1,.05.17v1.05a.48.48,0,0,1-.05.23.43.43,0,0,1-.13.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3,253.08v1.72a.53.53,0,0,1-.06.23.38.38,0,0,1-.12.15l-.86.49a.08.08,0,0,1-.12,0,.2.2,0,0,1-.06-.16v-1.72l-1,.61a.1.1,0,0,1-.13,0,.22.22,0,0,1-.06-.17v-1.05a.53.53,0,0,1,.06-.23.28.28,0,0,1,.13-.15l1-.61v-1.71a.46.46,0,0,1,.06-.23.35.35,0,0,1,.12-.16l.86-.49a.08.08,0,0,1,.12,0,.2.2,0,0,1,.06.16v1.72l1-.6a.09.09,0,0,1,.13,0,.25.25,0,0,1,0,.17v1a.59.59,0,0,1,0,.22.36.36,0,0,1-.13.16Z",
    style: {
      fill: "#f0f0f0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubbles--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.19,112.83a1.63,1.63,0,0,1-.81-.21,2,2,0,0,1-.88-1.85V75.86A5.39,5.39,0,0,1,69,71.59L99.45,54a1.82,1.82,0,0,1,2.93,1.69V90.59a5.38,5.38,0,0,1-2.47,4.27l-10,5.8L86.82,111a1.06,1.06,0,0,1-1,.77,1.09,1.09,0,0,1-1-.65l-2.62-6-12.77,7.37A2.42,2.42,0,0,1,68.19,112.83Zm31.72-58L69.42,72.39a4.53,4.53,0,0,0-2,3.47v34.91a1.17,1.17,0,0,0,.42,1,1.14,1.14,0,0,0,1.12-.16l13.67-7.89,3,7a.14.14,0,0,0,.15.09.17.17,0,0,0,.13-.11L89.09,100l10.36-6a4.48,4.48,0,0,0,2-3.47V55.68a1.17,1.17,0,0,0-.42-1,1.19,1.19,0,0,0-1.12.16Z",
    style: {
      fill: "#35885D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M84.44,70.42a6.47,6.47,0,0,1,5.63-.8L84.44,83.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,76.13a17.49,17.49,0,0,1,5.64-5.71V83.23Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.31,84.54a25.63,25.63,0,0,1,3.49-8.41l5.64,7.1Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.07,69.62A6.23,6.23,0,0,1,93.57,74l-9.13,9.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.31,92.45a13.24,13.24,0,0,1-.48-3.68,20,20,0,0,1,.48-4.23l9.13-1.31Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,81.91a25.65,25.65,0,0,1-3.5,8.41l-5.63-7.09Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.44,96a6.46,6.46,0,0,1-5.64.8l5.64-13.6Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.31,92.45l9.13-9.22L78.8,96.83A6.22,6.22,0,0,1,75.31,92.45Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,76.13a25.63,25.63,0,0,0-3.49,8.41,20,20,0,0,0-.48,4.23,13.24,13.24,0,0,0,.48,3.68,6.22,6.22,0,0,0,3.49,4.38l5.64-13.6Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,74A13.64,13.64,0,0,1,94,77.68a20.61,20.61,0,0,1-.47,4.23l-9.13,1.32Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.07,90.32A17.47,17.47,0,0,1,84.44,96V83.23Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.57,74l-9.13,9.23L78.8,96.83a6.46,6.46,0,0,0,5.64-.8,17.47,17.47,0,0,0,5.63-5.71,25.65,25.65,0,0,0,3.5-8.41A20.61,20.61,0,0,0,94,77.68,13.64,13.64,0,0,0,93.57,74Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.84,86.48a1.52,1.52,0,0,1-.81-.22,2,2,0,0,1-.89-1.84V49.51a5.36,5.36,0,0,1,2.47-4.27l30.48-17.6A1.81,1.81,0,0,1,148,29.33V64.24a5.37,5.37,0,0,1-2.47,4.27l-10,5.79-3,10.37a1.07,1.07,0,0,1-2,.12l-2.62-6.05-12.77,7.37A2.55,2.55,0,0,1,113.84,86.48Zm31.71-58L115.07,46a4.51,4.51,0,0,0-2,3.47V84.42a.92.92,0,0,0,1.55.89l13.66-7.89,3,7a.13.13,0,0,0,.15.08.12.12,0,0,0,.13-.1l3.15-10.72,10.36-6a4.51,4.51,0,0,0,2-3.47V29.33a.92.92,0,0,0-1.55-.89Z",
    style: {
      fill: "#35885D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,44.07a6.46,6.46,0,0,1,5.64-.8l-5.64,13.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,49.78a17.59,17.59,0,0,1,5.64-5.71v12.8Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,58.19a25.63,25.63,0,0,1,3.49-8.41l5.64,7.09Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.44,49.78A25.63,25.63,0,0,0,121,58.19l9.13-1.32V44.07A17.59,17.59,0,0,0,124.44,49.78Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,43.27a6.22,6.22,0,0,1,3.49,4.38l-9.13,9.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,66.1a13.64,13.64,0,0,1-.47-3.68,20.61,20.61,0,0,1,.47-4.23l9.13-1.32Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.21,55.56A25.63,25.63,0,0,1,135.72,64l-5.64-7.1Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,69.68a6.46,6.46,0,0,1-5.64.8l5.64-13.61Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,66.1l9.13-9.23-5.64,13.61A6.22,6.22,0,0,1,121,66.1Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.21,47.65a13.64,13.64,0,0,1,.47,3.68,20.61,20.61,0,0,1-.47,4.23l-9.13,1.31Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.72,64a17.59,17.59,0,0,1-5.64,5.71V56.87Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.08,56.87l-5.64,13.61a6.46,6.46,0,0,0,5.64-.8A17.59,17.59,0,0,0,135.72,64a25.63,25.63,0,0,0,3.49-8.41Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.69,101.58,286.18,111.7a1.4,1.4,0,0,0-.62,1.09v21.4a1.34,1.34,0,0,0,.63,1.07l2.48,1.42a1.43,1.43,0,0,0,1.26,0l17.51-10.13a1.38,1.38,0,0,0,.62-1.08v-21.4a1.37,1.37,0,0,0-.63-1.08L305,101.57A1.4,1.4,0,0,0,303.69,101.58Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.93,136.67a1.46,1.46,0,0,1-1.26,0l-2.48-1.42a1.34,1.34,0,0,1-.63-1.07v-21.4a1.3,1.3,0,0,1,.2-.64l3.73,2.14c-.12.2-.19.42-.19.08v21.4C289.3,136.67,289.56,136.88,289.93,136.67Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,104c-.05-.32-.3-.43-.61-.25l-17.51,10.13a1.3,1.3,0,0,0-.44.46l-3.74-2.14a1.36,1.36,0,0,1,.44-.45l17.51-10.13a1.38,1.38,0,0,1,1.25,0l2.48,1.41A1.35,1.35,0,0,1,308.05,104Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.85,128.66c-.4-.24-3.39-1.92-3.48-2a.58.58,0,0,1-.13-.89l5.32-6.1,3.74,2.15-5.56,5.94A.59.59,0,0,0,283.85,128.66Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.85,128.66c-.4-.24-3.39-1.92-3.48-2a.58.58,0,0,1-.13-.89l5.32-6.1,3.74,2.15-5.56,5.94A.59.59,0,0,0,283.85,128.66Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.44,103.7l-17.51,10.13a1.37,1.37,0,0,0-.63,1.08v6.93l-5.56,5.94a.56.56,0,0,0,.36,1l5.2-.38h0v7.95c0,.4.28.56.63.36l17.51-10.13a1.38,1.38,0,0,0,.62-1.08v-21.4C308.06,103.66,307.78,103.5,307.44,103.7Z",
    style: {
      fill: "#ffa8a7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--X--inject-30",
    d: "M304,122.69,300.41,120l3.7-7.08a1.34,1.34,0,0,0-2.38-1.25l-3.5,6.69-3.2-2.42a1.34,1.34,0,1,0-1.62,2.14l3.56,2.69-3.55,6.78a1.35,1.35,0,0,0,.57,1.82,1.38,1.38,0,0,0,.62.15,1.34,1.34,0,0,0,1.19-.72l3.34-6.38,3.21,2.42a1.35,1.35,0,0,0,1.88-.26A1.35,1.35,0,0,0,304,122.69Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M289.93,103.12a1.43,1.43,0,0,1-1.26,0l-2.48-1.42c-.35-.19-.63-.67-.63-.53V79.78a2.08,2.08,0,0,1,.2-1.18l3.73,2.15a2,2,0,0,0-.19,1.15v21.4C289.3,103.13,289.56,103.34,289.93,103.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,70.4c-.05-.32-.3-.43-.61-.25L289.93,80.28a1.25,1.25,0,0,0-.44.47l-3.74-2.15a1.23,1.23,0,0,1,.44-.44L303.7,68A1.38,1.38,0,0,1,305,68l2.48,1.41A1.37,1.37,0,0,1,308.05,70.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.85,95.11l-3.48-2a.58.58,0,0,1-.13-.89l5.32-6.1,3.74,2.15-5.56,5.94A.59.59,0,0,0,283.85,95.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.44,70.15,289.93,80.28a1.37,1.37,0,0,0-.63,1.08v6.93l-5.56,5.94a.56.56,0,0,0,.36,1l5.2-.38h0v8c0,.4.28.56.63.36L307.44,93a1.38,1.38,0,0,0,.62-1.08V70.51C308.06,70.11,307.78,70,307.44,70.15Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Bug--inject-30",
    d: "M305.14,85.25l-.41-3.07a.38.38,0,0,0-.23-.29.35.35,0,0,0-.14,0,.33.33,0,0,0-.23.09l-1,.83a4.76,4.76,0,0,0-.62-1.46h0L303,80l.68-2.4a.35.35,0,0,0-.25-.45l-.1,0a.38.38,0,0,0-.36.27l-.66,2.33-.39.93a2.11,2.11,0,0,0-.35-.26,2.32,2.32,0,0,0-1.18-.35l.63-2.42a.37.37,0,0,0-.27-.45h-.09a.37.37,0,0,0-.36.27l-.69,2.7a3.48,3.48,0,0,0-.82.32c-.19.11-.39.23-.57.36l-.45-1.64a.36.36,0,0,0-.35-.27h-.1a.37.37,0,0,0-.26.45l.53,2A9.79,9.79,0,0,0,295.72,84l-.16-.26L295,82.08a.38.38,0,0,0-.35-.26l-.11,0a.37.37,0,0,0-.24.47l.55,1.73.47.72a14.17,14.17,0,0,0-.86,2.7h-.08l-1.28.33a.38.38,0,0,0-.27.3l-.62,3.61a.38.38,0,0,0,.3.43h.06a.38.38,0,0,0,.37-.3l.58-3.38.81-.22a10.26,10.26,0,0,0-.12,1.34,8,8,0,0,0,.33,2.7.39.39,0,0,0-.1.08l-1.19,1.44a.39.39,0,0,0,0,.4l1.15,2.32a.36.36,0,0,0,.33.21.35.35,0,0,0,.17,0,.36.36,0,0,0,.16-.49l-1-2.12.88-1A3.16,3.16,0,0,0,296,94.27a2.42,2.42,0,0,0,1.26.35,3.15,3.15,0,0,0,1.52-.42h0c1.62-.89,3.08-3,3.89-5.48h0l.9.15-1.18,3.24a.37.37,0,0,0,.22.47.3.3,0,0,0,.13,0,.38.38,0,0,0,.35-.24l1.33-3.66a.34.34,0,0,0,0-.31.37.37,0,0,0-.26-.18L302.88,88a12.42,12.42,0,0,0,.45-2.88,9.43,9.43,0,0,0-.08-1.53l0,0,.79-.64.33,2.41a.36.36,0,0,0,.36.32h.05a.35.35,0,0,0,.25-.14A.44.44,0,0,0,305.14,85.25Zm-6-4.1a2.48,2.48,0,0,1,1.17-.33,1.55,1.55,0,0,1,.87.25,1.65,1.65,0,0,1,.41.34,7.65,7.65,0,0,1-2.93,3.31,2.82,2.82,0,0,1-1.32.37,1.63,1.63,0,0,1-1.14-.44A7.74,7.74,0,0,1,299.16,81.15ZM295,89.6a12.4,12.4,0,0,1,.92-4.24,2.38,2.38,0,0,0,1.45.48,3.09,3.09,0,0,0,1.12-.22l-.25,8a2.45,2.45,0,0,1-1,.23,1.68,1.68,0,0,1-.87-.24C295.43,93.06,294.91,91.56,295,89.6Zm4,3.59.25-7.93a8.33,8.33,0,0,0,2.86-3.15,6.56,6.56,0,0,1,.51,3C302.49,88.28,300.92,91.72,299,93.19Z",
    style: {
      fill: "#35885D"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.69,34.48,286.18,44.61c-.34.2-.62.68-.62,1.62v21.4c0-.14.28.34.63.54l2.48,1.41a1.43,1.43,0,0,0,1.26,0l17.51-10.13a1.4,1.4,0,0,0,.62-1.09V37a1.35,1.35,0,0,0-.63-1.07L305,34.47A1.43,1.43,0,0,0,303.69,34.48Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.93,69.58a1.43,1.43,0,0,1-1.26,0l-2.48-1.41c-.35-.2-.63-.68-.63-.54V46.23a2.1,2.1,0,0,1,.2-1.18l3.73,2.15c-.12.19-.19.42-.19.08v21.4C289.3,69.58,289.56,69.79,289.93,69.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.05,36.85c-.05-.31-.3-.43-.61-.25L289.93,46.73a1.25,1.25,0,0,0-.44.47l-3.74-2.15a1.32,1.32,0,0,1,.44-.44L303.7,34.48a1.41,1.41,0,0,1,1.25,0l2.48,1.42A1.35,1.35,0,0,1,308.05,36.85Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.85,61.56l-3.48-2a.59.59,0,0,1-.13-.9l5.32-6.09,3.74,2.14-5.56,5.95A.58.58,0,0,0,283.85,61.56Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.85,61.56l-3.48-2a.59.59,0,0,1-.13-.9l5.32-6.09,3.74,2.14-5.56,5.95A.58.58,0,0,0,283.85,61.56Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.44,36.6,289.93,46.73a1.39,1.39,0,0,0-.63,1.09v6.93l-5.56,5.93a.56.56,0,0,0,.36,1l5.2-.38h0v7.95c0,.4.28.56.63.37l17.51-10.13a1.4,1.4,0,0,0,.62-1.09V37C308.06,36.57,307.78,36.4,307.44,36.6Z",
    style: {
      fill: "#35885D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Check--inject-30",
    d: "M304.19,42.58a1.56,1.56,0,0,0-2,.83l-5.88,14L294.87,56a1.55,1.55,0,0,0-2.2,0,1.57,1.57,0,0,0,0,2.2l3,2.95a1.56,1.56,0,0,0,2.52-.51L305,44.62A1.56,1.56,0,0,0,304.19,42.58Z",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M442,382a8.69,8.69,0,0,1,.92,4.53c-.07,1.37-.89,3.15-.52,6.24s1.08,4.07,1.41,6.25a7.68,7.68,0,0,1-1.21,5.81c-1.28,2.08-4.1,3.73-9.68,3.53-4.5-.16-6.32-2.47-6.42-5.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.72,375.62a10.65,10.65,0,0,1,.27,1.75c.17,1.05.48,2,.73,3.07.07.27.13.54.19.81.43,2.07,0,4.21,0,6.32a35,35,0,0,0,1.31,7.36c1,4.38,1.17,7.31-2.66,10.34-2,1.6-4.23,1.65-6.79,1.72a10.82,10.82,0,0,1-5.64-1.36c-1.64-1.21-1.62-2.23-1.63-2.62-.15-4.65,1.53-10.06,1.87-14.7a23.64,23.64,0,0,0,.08-3.76c-.16-1.54-.69-3.07-.86-4.62a2.69,2.69,0,0,1,.21-1.71,2.74,2.74,0,0,1,2.07-.93c2-.27,4.08-.47,6.13-.62a1.88,1.88,0,0,1,1.39.28c.4.36.41,1,.52,1.49s.49,1.12,1,1a.9.9,0,0,0,.62-.78c.05-.34.2-3,.19-3.39C439.76,375.29,440.48,375.18,440.72,375.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,391.05a3.44,3.44,0,0,0,0,2.56c.33.76,4.14,3.12,9.41,3a22,22,0,0,0,11-3.36c2.05-1.25,4.15-1.41,6.76-1.46s5.67-1,6.56-2.17a6.26,6.26,0,0,0,0-3.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.08,375.48a11.16,11.16,0,0,0-.54,1.16,9.28,9.28,0,0,1-2.9,3.61,30,30,0,0,1-5.82,3.14c-1.3.58-2.66.74-4,1.2a22.25,22.25,0,0,0-4.27,1.88c-2.12,1.3-2.52,4.79-.23,6.27,2,1.27,7.27,2.78,12.93,1.42,3.09-.74,6.6-3.87,10.62-4,2.55-.09,7.4-.61,9.12-2.48.63-2.79-.06-3.58-.63-6a19.28,19.28,0,0,1-.48-4.08c0-.72.48-2.79-1-3l-.15,1.55s-.29.52-1.87.8c-.51.09-.91.76-1.18,1.37s-.44,1.08-1,1.07a1,1,0,0,1-.79-.62,7.25,7.25,0,0,1-.29-1,4,4,0,0,0-2.39-2.37,12.14,12.14,0,0,0-2.8-.59c-.72-.11-1.32-.42-2,.2A2.2,2.2,0,0,0,392.08,375.48Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.11,256.54c1,15.27,1.53,24.16,4.26,65.83a109,109,0,0,1,3.81,21.84c.54,9.22,1.85,37,1.85,37s-7.43,6.1-16,3.28c0,0-7.78-40.84-10.5-53.58-2.6-12.23-4.6-25.6-4.6-25.6L410,322.37s.34,7.59.1,18.92c-.12,6.06-3,38.86-3,38.86s-10.43,4.74-17.47-1.35c0,0-.51-53.19-.62-58.67-.12-6.26,1-69.21,1-69.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.89,305.32l-5.33-27.93s-8.24-.72-12.79-5.32c0,0,.81,4.51,11.17,7.21L410.09,305,410,322.37Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.79,376.2a16.9,16.9,0,0,1-11.43,4.12s7.1-1.06,11.36-5.74Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.43,376.28s-7.27,2.54-13.4.6c0,0,4.73,3.18,13.29.57Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330.75,199.72a1.71,1.71,0,0,0-.3-.66,3,3,0,0,1,.06-3,3.31,3.31,0,0,0,.44-.72c.2-.55-.05-1.17,0-1.76.18-2.63,4.94-1.48,6.45-1,.44.15,3,.81,4,1.16a13.57,13.57,0,0,1,.42-4.29c.68-2.73,2.93-2.45,3.06-.78a21.76,21.76,0,0,0,.84,4.46c.28,1.07,1,2.13,1.41,3.71.59,2,.44,3.12,2.44,5,3,2.83,18.4,13.27,18.4,13.27,3.84-2.47,18.7-11.61,24.27-14.63,5.39-2.93,8.14-.57,8.14-.57l-4.7,17.31s-18.53,9.56-25.21,12.48c-4.66,2-6.72.88-11.86-3.7h0c-4.08-3.86-9.46-9.44-15.27-14.58-2.32-2.06-4-3.11-5.64-3.19-.62,0-1.24-.07-1.85-.13-1.38-.16-3-.5-3.67-1.87-.23-.46-.34-1-.53-1.46-.29-.74-.75-1.4-1-2.14a3,3,0,0,1-.2-1.57C330.45,200.63,330.81,200.2,330.75,199.72Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.36,198.58c-4.74,0-6.58,0-12.6,3.42S371,213.19,371,213.19s5.26,2.93,6.31,13.33l19-8.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.57,195.33c1.57.38,2.06,1.37,2.17,3.58.06,1.31.61,3.7,2.1,4.57a3.41,3.41,0,0,1-1.91-.67c-.72-.65-.91-.71-1.26-.29a2.4,2.4,0,0,1-.94.63,1.69,1.69,0,0,1,.29,2c-.61,1.18-3.68,1.41-6.28.28,0,0,4.17,1,5-.36s-1.41-2.84-3-3.17c0,0,4,.67,4.52-.66s-1.18-2.2-3.54-2.63c0,0,3.3.37,3.78-.78A2,2,0,0,0,339.57,195.33Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.93,215.14a12.38,12.38,0,0,1,4.62,5.7s.33-4.39-3.28-6.55Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.44,215.68c.59-11.77,5.33-16.52,11.92-17.1l14.81-1c4,.93,14.4,2.93,14.4,2.93,4.31,1.29,7.34,12.53,6.33,18.93s-3.12,11.28-3.71,22.05c.17,10.2.32,12.22.32,16.22-9.21,5.85-33.95,7.07-43.68,1.2,0,0-.17-9.86-.37-16.14C389.12,232,389.24,219.73,389.44,215.68Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.33,165.75a3.81,3.81,0,0,0-1.92,3.39,5,5,0,0,0,.84,2.89,6.4,6.4,0,0,0,3.4,2.22,9.88,9.88,0,0,1,1.69.57,14.42,14.42,0,0,1,1.9,1.62c.91.7,1.81,1.42,2.74,2.1a56.11,56.11,0,0,0,5.77,3.78,41.18,41.18,0,0,0,6,2.82c2.19.81,4,.1,6.34.31l-.34,6.34s.78-1.46,1.67-3.2c.77-1.5,4-9.14,4-9.14,1.26-3,2.86-6.14,2.67-9.49-.16-2.71-.7-5.09-2.76-6.24-.17-3.12-.88-4.64-3.07-6.31a12.11,12.11,0,0,0-5.41-2,22,22,0,0,0-6.57.23c-3.24.52-6.48,1.35-9.76,1.18a15.6,15.6,0,0,0-5.24.33,5.31,5.31,0,0,0-3.67,5.19C391.54,163.53,392.49,165.49,393.33,165.75Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.85,166.56c0,2,1.84,4.83,4.64,7.27a13.8,13.8,0,0,0,.15,5.58,5.47,5.47,0,0,0,.78,1.59,1.61,1.61,0,0,0,1.17.74c.65,0,.91-.34,1.11-.85a17.68,17.68,0,0,1,1-1.88,4.52,4.52,0,0,1,.57-.72c1-.91,3.89-2,5.24,1.08s-1.18,7.44-3.52,8.09c-4,1.13-4.91-1.62-4.91-1.62l.07,13.34c-1.13,3.38-7.39,6.67-12.43,6s-3.44-3.71-1.39-5.77l-.26-4.63a19.86,19.86,0,0,1-5.38-.2c-2.09-.4-3.81-2.36-4.68-5.55a48.6,48.6,0,0,1-.6-18.52c.76-3.76,1.69-5.38,2.14-5.82,0,.82,1.57,3.33,5.64,3.89C407.49,169.2,410.75,167.84,413.85,166.56Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.05,194.8c3.72-.34,6.74-.85,8.84-2,1.54-.81,2.87-3.34,3.27-4.24,0,0-.1,3.46-2.17,5.38-2.92,2.71-9.83,2.71-9.83,2.71Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,177.82a1.35,1.35,0,1,0,1.4-1.36A1.38,1.38,0,0,0,408,177.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.49,173.41l3.27,1.35a1.85,1.85,0,0,0-1-2.36A1.72,1.72,0,0,0,408.49,173.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.77,185.1l-5,2a2.63,2.63,0,0,0,3.47,1.56A2.81,2.81,0,0,0,409.77,185.1Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.86,188.61a2.29,2.29,0,0,0,0,.25,2.58,2.58,0,0,0,1.39-.16,2.77,2.77,0,0,0,1.68-2.58,2.48,2.48,0,0,0-.54-.06A2.55,2.55,0,0,0,406.86,188.61Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.25,174.68l3.23-1.25a1.67,1.67,0,0,0-2.19-1A1.76,1.76,0,0,0,396.25,174.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.08,177.53a1.37,1.37,0,0,0,1.31,1.45,1.41,1.41,0,1,0-1.31-1.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404.26 184.44 399.28 183.5 403.98 175.54 404.26 184.44",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.43,200.75c6.23,1.08,10,3.08,11.6,8,2.27,7,8.62,26.83,9.93,33.88.8,4.33,2.05,7.07-1.62,9.92A260.27,260.27,0,0,1,424,269.85c-8.32,4.36-20.88,5.22-20.88,5.22l9.11-5.51,1.62-3.09L438.2,244.9,429,217.72S426.68,203.75,431.43,200.75Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.2,244.9a13.87,13.87,0,0,1,6.4-1.54s-2.16-1.86-6.93,0Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.57,200.51c2.85.53,6,.84,8.9,2.68s3.43,4.07,5.66,10.94,4.86,17,4.86,17-5.46,4.62-14.86,4.75c0,0-4.63-12.85-5.77-15.71S425.35,208.09,430.57,200.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.53,262.24l0,.86a2.42,2.42,0,0,1-1.16,2.12L396.67,279a2.46,2.46,0,0,1-2.41,0L351.5,255.58a2.45,2.45,0,0,1-1.25-2.07v-.58l45.19,24.78Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.53,262.24l0,.86a2.42,2.42,0,0,1-1.16,2.12L396.67,279a2.46,2.46,0,0,1-2.41,0L351.5,255.58a2.45,2.45,0,0,1-1.25-2.07v-.58l45.19,24.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M420.53,262.24l0,.86a2.42,2.42,0,0,1-1.16,2.12L396.67,279a2.46,2.46,0,0,1-2.41,0L351.5,255.58a2.45,2.45,0,0,1-1.25-2.07v-.58l45.19,24.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M350.24,252.93l24.71-15a1.45,1.45,0,0,1,1.44,0l44,24.12a.32.32,0,0,1,0,.55l-24.95,15.15Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.85
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M350.24,252.93l24.71-15a1.45,1.45,0,0,1,1.44,0l44,24.12a.32.32,0,0,1,0,.55l-24.95,15.15Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "395.22 275.36 408.55 267.27 368.97 245.57 355.57 253.62 395.22 275.36",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "395.22 275.36 408.55 267.27 368.97 245.57 355.57 253.62 395.22 275.36",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "401.78 253.77 401.53 253.92 395 257.89 383.08 251.35 382.83 251.22 389.61 247.1 401.78 253.77",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "401.53 253.92 395 257.89 383.08 251.35 389.62 247.39 401.53 253.92",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "401.53 253.92 395 257.89 383.08 251.35 389.62 247.39 401.53 253.92",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.43,277.71l0,1.6a2.35,2.35,0,0,1-1.21-.29L351.5,255.58a2.45,2.45,0,0,1-1.25-2.07v-.58Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.03
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.43,277.71l0,1.6a2.35,2.35,0,0,1-1.21-.29L351.5,255.58a2.45,2.45,0,0,1-1.25-2.07v-.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M395.43,277.71l0,1.6a2.35,2.35,0,0,1-1.21-.29L351.5,255.58a2.45,2.45,0,0,1-1.25-2.07v-.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M394.76,278.08a2.83,2.83,0,0,1-2.47-.14L349.73,254.6a2.89,2.89,0,0,1-1.44-2l-5.2-27.34a2.59,2.59,0,0,1,0-.47,2.84,2.84,0,0,1,.8-2.05L388.07,247a2.08,2.08,0,0,1,1.06,1.45Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M394.76,278.08a2.83,2.83,0,0,1-2.47-.14L349.73,254.6a2.89,2.89,0,0,1-1.44-2l-5.2-27.34a2.59,2.59,0,0,1,0-.47,2.84,2.84,0,0,1,.8-2.05L388.07,247a2.08,2.08,0,0,1,1.06,1.45Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M395.43,277.71l-.28.17a2.87,2.87,0,0,1-.39.2l-5.63-29.59a2.08,2.08,0,0,0-1.06-1.45l-44.23-24.26a2.56,2.56,0,0,1,.57-.46l44.33,24.3a2.15,2.15,0,0,1,1.06,1.46Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.43,277.71l-.28.17a2.87,2.87,0,0,1-.39.2l-5.63-29.59a2.08,2.08,0,0,0-1.06-1.45l-44.23-24.26a2.56,2.56,0,0,1,.57-.46l44.33,24.3a2.15,2.15,0,0,1,1.06,1.46Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M388.72,247.59l.66-.4a2.09,2.09,0,0,1,.42.89l5.63,29.63-.28.17a2.87,2.87,0,0,1-.39.2l-5.63-29.59A2.11,2.11,0,0,0,388.72,247.59Z",
    style: {
      fill: "#35885D"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.72,247.59l.66-.4a2.09,2.09,0,0,1,.42.89l5.63,29.63-.28.17a2.87,2.87,0,0,1-.39.2l-5.63-29.59A2.11,2.11,0,0,0,388.72,247.59Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.72,247.59l.66-.4a2.09,2.09,0,0,1,.42.89l5.63,29.63-.28.17a2.87,2.87,0,0,1-.39.2l-5.63-29.59A2.11,2.11,0,0,0,388.72,247.59Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.53,253.27a9.3,9.3,0,0,0-4.36-5.36c-2.05-1.12-3.44-.56-3.09,1.28s2.3,4.22,4.36,5.35S370.88,255.1,370.53,253.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.36,259.82c-2.38,1.67-5.59.32-8.75.7s-5.86,1.16-8.4,1.09-3.78.44-2,2.47,6.87.86,8.25,1.48a3,3,0,0,1,.64,4.68c-1.49,1.73,8.48-1.61,9.81-3.66S423.16,260.08,421.36,259.82Z",
    style: {
      fill: "#ffa8a7"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.e4840af4a4b7bc637f9a3c660454d3d1.svg";
export { ForwardRef as ReactComponent };